
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4Ov3V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "JiraHomeShell", () => $d0324223fba9940c$export$8bed9950abe5af2b);
$parcel$export(module.exports, "default", () => $d0324223fba9940c$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("3avtZ");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $dzSzf = parcelRequire("dzSzf");

var $eSnSE = parcelRequire("eSnSE");

var $cxKOj = parcelRequire("cxKOj");

var $2wake = parcelRequire("2wake");

var $7KbdA = parcelRequire("7KbdA");

var $fXBb1 = parcelRequire("fXBb1");

var $cPmvw = parcelRequire("cPmvw");

var $lRq8t = parcelRequire("lRq8t");

var $6UU7v = parcelRequire("6UU7v");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iDAU4 = parcelRequire("iDAU4");

var $8pvq9 = parcelRequire("8pvq9");

var $iEXnd = parcelRequire("iEXnd");

var $koAZ4 = parcelRequire("koAZ4");

var $4EKqI = parcelRequire("4EKqI");

var $eJrcF = parcelRequire("eJrcF");

var $6CNTI = parcelRequire("6CNTI");

var $bSpEN = parcelRequire("bSpEN");
const $d0324223fba9940c$var$useJiraHomePrefetchResource = (0, $6UU7v.withSuspense)((intl)=>{
    const assignedToUserLoading = (0, $eJOHy.useRef)(false);
    const state = (0, $eJrcF.useResource)((0, $iDAU4.jiraHomeResourceWithCache));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const generateUpdateTabFn = (0, $eJOHy.useCallback)((tabName, fetchData)=>(0, $6CNTI.generateUpdateTabStateFn)(state, tabName, fetchData), [
        state
    ]);
    const updateLastVisitedTab = (0, $eJOHy.useCallback)((lastVisitedTab)=>{
        state.update((currentData)=>currentData && {
                ...currentData,
                lastVisitedTab: lastVisitedTab
            });
    }, [
        state
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (state?.data?.tabs.AssignedToUser?.data?.issues?.totalCount == null && !assignedToUserLoading.current) {
            assignedToUserLoading.current = true;
            (0, $2wake.fetchData)().then((assignedToUserResults)=>{
                state.update((currentData)=>currentData && {
                        ...currentData,
                        tabs: {
                            ...currentData.tabs,
                            AssignedToUser: assignedToUserResults
                        }
                    });
            });
        }
    }, [
        state
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (state?.data?.analytics) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'load',
            actionSubject: 'jiraHome'
        }), 'jiraHomeResource', state.data.analytics);
    }, [
        createAnalyticsEvent,
        state?.data?.analytics
    ]);
    try {
        if (state.data) {
            const { RecentlyViewed: RecentlyViewed, AssignedToUser: AssignedToUser, Favourites: Favourites, WorkedOn: WorkedOn } = state.data.tabs;
            const tabs = {
                RecentlyViewed: {
                    data: (0, $cPmvw.transformResult)(RecentlyViewed, intl),
                    timeZone: RecentlyViewed?.timeZone,
                    update: generateUpdateTabFn('RecentlyViewed', (0, $cPmvw.fetchAllData))
                },
                AssignedToUser: {
                    data: (0, $2wake.transformResult)(AssignedToUser),
                    update: generateUpdateTabFn('AssignedToUser', (0, $2wake.fetchData))
                },
                Favourites: {
                    data: (0, $7KbdA.transformResult)(Favourites),
                    update: generateUpdateTabFn('Favourites', (0, $7KbdA.fetchData))
                },
                WorkedOn: {
                    data: (0, $fXBb1.transformResult)(WorkedOn, intl)
                }
            };
            return {
                loading: state.loading,
                refresh: state.refresh,
                promise: state.promise,
                error: state.error,
                data: {
                    lastVisitedTab: state.data && state.data.lastVisitedTab || '',
                    tabs: tabs,
                    updateLastVisitedTab: updateLastVisitedTab,
                    recommendedProjectsData: (0, $cxKOj.expValEquals)('recommended_projects_for_you_page', 'cohort', 'test', 'control') ? state.data.recommendedProjectsData : undefined
                }
            };
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa-apps.jira-home', 'Cannot prefetch the data', e);
    }
    return {
        loading: state.loading,
        refresh: state.refresh,
        promise: state.promise,
        error: state.error,
        data: null
    };
});
const $d0324223fba9940c$export$8bed9950abe5af2b = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $koAZ4.useTenantContext)();
    const intl = (0, $lRq8t.default)();
    const state = $d0324223fba9940c$var$useJiraHomePrefetchResource(intl);
    if (!atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzSzf.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "your-work"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
        id: "jira-home"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bSpEN.default), {
        prefetchResult: state
    }))));
};
const $d0324223fba9940c$var$JiraHomeType = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEXnd.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d0324223fba9940c$export$8bed9950abe5af2b, null), (0, $cxKOj.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled') !== 'not-enrolled' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8pvq9.HrExpansionSpotlight), null) : null);
var $d0324223fba9940c$export$2e2bcd8739ae039 = $d0324223fba9940c$var$JiraHomeType;

});
parcelRegister("dzSzf", function(module, exports) {
$parcel$export(module.exports, "default", () => $5046373a400bd483$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dOwXt = parcelRequire("dOwXt");

var $gr8eh = parcelRequire("gr8eh");
const $5046373a400bd483$var$LoginRedirect = ()=>{
    const { href: href = null } = (0, $dOwXt.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr8eh.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};
var $5046373a400bd483$export$2e2bcd8739ae039 = $5046373a400bd483$var$LoginRedirect;

});

parcelRegister("2wake", function(module, exports) {
$parcel$export(module.exports, "transformResult", () => $079fc6b5b10777d4$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "fetchData", () => $079fc6b5b10777d4$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $079fc6b5b10777d4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $hgi0g = parcelRequire("hgi0g");

var $bXOg3 = parcelRequire("bXOg3");

var $ewZIt = parcelRequire("ewZIt");
const $079fc6b5b10777d4$export$f446d01a07ac0096 = '/rest/gira/1/';
const $079fc6b5b10777d4$var$operationName = 'homeAssignedIssuesQuery';
const $079fc6b5b10777d4$var$query = `query ${$079fc6b5b10777d4$var$operationName}($first: Int!, $jql: String, $useIssueService: Boolean!, $isMaxResultsLimitEnabled: Boolean!) {
    issues(first: $first, jql: $jql, useIssueService: $useIssueService, isMaxResultsLimitEnabled: $isMaxResultsLimitEnabled) {
      edges {
        node {
          issueId
          issuekey {
            stringValue
          }
          summary {
            textValue
          }
          project {
            id
            name
          }
          status {
            statusCategoryId
            name
          }
          issuetype {
            id
            name
            iconUrl
          }
        }
      }
      totalCount
    }
  }`;
const $079fc6b5b10777d4$var$jqlQuery = 'assignee = currentUser() AND statusCategory != 3 ORDER BY statusCategory DESC';
const $079fc6b5b10777d4$export$f13b29f9ed0c5a03 = (result)=>{
    if (typeof result === 'undefined' || typeof result.data === 'undefined' || typeof result.data.issues === 'undefined') return undefined;
    const { data: { issues: issueList } } = result;
    const { edges: edges, totalCount: totalCount } = issueList;
    if (Array.isArray(edges) === false) return {
        sections: [],
        total: 0
    };
    const issues = edges.map((edge)=>edge.node);
    const sections = [
        ...new Set(issues.map((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(item, 'status.name')))
    ];
    return {
        total: totalCount,
        sections: sections.map((status)=>({
                header: status,
                items: issues.map((issue)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'status.name') === status ? {
                        // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issueId'),
                        title: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'summary.textValue'),
                        // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
                        entityId: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issueId'),
                        subtitle: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issuekey.stringValue'),
                        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issuetype.iconUrl'),
                        url: `/browse/${(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issuekey.stringValue')}`,
                        status: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'status.name'),
                        statusField: {
                            id: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'status.statusId'),
                            name: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'status.name'),
                            statusCategory: {
                                id: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'status.statusCategoryId')
                            }
                        },
                        attributes: {
                            containerId: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'project.id'),
                            containerName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'project.name'),
                            issueTypeId: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issuetype.id'),
                            issueTypeName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issue, 'issuetype.name'),
                            parentType: 'project'
                        },
                        type: 'issue',
                        favourite: undefined
                    } : undefined).filter(Boolean)
            }))
    };
};
const $079fc6b5b10777d4$export$8134c072fddab6a5 = async ()=>{
    const result = await (0, $hgi0g.default)($079fc6b5b10777d4$export$f446d01a07ac0096, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $079fc6b5b10777d4$var$operationName,
            query: $079fc6b5b10777d4$var$query,
            variables: {
                first: (0, $bXOg3.MAX_ITEMS_PER_PAGE),
                jql: $079fc6b5b10777d4$var$jqlQuery,
                useIssueService: true,
                isMaxResultsLimitEnabled: true
            }
        })
    });
    if (typeof result === 'undefined') throw Error('Could not retrieve issues assigned to you');
    return result;
};
const $079fc6b5b10777d4$var$AssignedToUserProvider = (props)=>{
    const { userProviderData: userProviderData, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewZIt.default), otherProps);
};
var $079fc6b5b10777d4$export$2e2bcd8739ae039 = $079fc6b5b10777d4$var$AssignedToUserProvider;

});
parcelRegister("bXOg3", function(module, exports) {
$parcel$export(module.exports, "PERF_METRICS_TABS_PREFIX", () => $5d1555ca8de15a97$export$7a6b448044362bfe);
$parcel$export(module.exports, "WORKEDON_TAB_KEY", () => $5d1555ca8de15a97$export$fe645a0f953963ae);
$parcel$export(module.exports, "VIEWED_TAB_KEY", () => $5d1555ca8de15a97$export$decc7a4188c45a97);
$parcel$export(module.exports, "ASSIGNED_TAB_KEY", () => $5d1555ca8de15a97$export$3cbecc33330b99be);
$parcel$export(module.exports, "STARRED_TAB_KEY", () => $5d1555ca8de15a97$export$b936f628c6a68f31);
$parcel$export(module.exports, "BOARDS_TAB_KEY", () => $5d1555ca8de15a97$export$5967e74d071813ea);
$parcel$export(module.exports, "WORK_SUGGESTIONS_TAB_KEY", () => $5d1555ca8de15a97$export$c12bc53d97e2f49b);
$parcel$export(module.exports, "MAX_ITEMS_PER_PAGE", () => $5d1555ca8de15a97$export$e7a0dcb737d8e4ee);
$parcel$export(module.exports, "PRODUCTS", () => $5d1555ca8de15a97$export$4f02bea739260915);
$parcel$export(module.exports, "SUCCESS_STATE", () => $5d1555ca8de15a97$export$e0b6fc71ed186b89);
$parcel$export(module.exports, "ERROR_STATE", () => $5d1555ca8de15a97$export$417957022d4c769f);
$parcel$export(module.exports, "EMPTY_STATE", () => $5d1555ca8de15a97$export$f040258c471d4154);
const $5d1555ca8de15a97$export$7a6b448044362bfe = 'jira-home.tabs';
const $5d1555ca8de15a97$export$fe645a0f953963ae = 'workedon';
const $5d1555ca8de15a97$export$decc7a4188c45a97 = 'viewed';
const $5d1555ca8de15a97$export$3cbecc33330b99be = 'assigned';
const $5d1555ca8de15a97$export$b936f628c6a68f31 = 'starred';
const $5d1555ca8de15a97$export$5967e74d071813ea = 'boards';
const $5d1555ca8de15a97$export$c12bc53d97e2f49b = 'workSuggestions';
const $5d1555ca8de15a97$export$e7a0dcb737d8e4ee = 30;
const $5d1555ca8de15a97$export$4f02bea739260915 = [
    'jira'
];
const $5d1555ca8de15a97$export$e0b6fc71ed186b89 = 'success';
const $5d1555ca8de15a97$export$417957022d4c769f = 'error';
const $5d1555ca8de15a97$export$f040258c471d4154 = 'empty';

});

parcelRegister("ewZIt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8dcb297e414b78b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $9pTd3 = parcelRequire("9pTd3");

var $hJSyB = parcelRequire("hJSyB");

var $dFtHW = parcelRequire("dFtHW");

var $3lhVL = parcelRequire("3lhVL");

var $2Mqjh = parcelRequire("2Mqjh");


var $fQ03e = parcelRequire("fQ03e");
const $b8dcb297e414b78b$export$dbdc7674ebd4ca0a = {
    sections: [],
    total: 0
};
class $b8dcb297e414b78b$export$20d7a9065849b23d extends (0, $eJOHy.Component) {
    componentDidMount() {
        if (this.props.spaStateTransitionState && !this.props.spaStateTransitionState.isInitialRender) this.fetchData();
        this.canSetState = true;
        if (this.props.prefetchResult.error || this.isResultMissingInPrefetch()) this.fetchData();
        else if (this.didReceivePrefetchData()) this.props.onTotalChange(this.props.id, this.state.data.total);
        if (window) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('visibilitychange', this.reload);
    }
    async componentDidUpdate(prevProps) {
        if (!prevProps.prefetchResult.error && this.props.prefetchResult.error) {
            this.fetchData();
            return;
        }
        if (!prevProps.prefetchResult.data && this.props.prefetchResult.data) {
            this.addDataToState(this.parsePrefetchData());
            return;
        }
        if ((this.shouldAutoUpdate() || !this.props.selected) && this.isUpdateAvailable()) this.updateToLatest();
        if (!this.shouldAutoUpdate() && this.state.updateAvailable !== true && this.isUpdateAvailable()) this.setState({
            updateAvailable: true
        });
        if (this.state.initialised === false) return;
        if (this.state.loading === true) return;
        if (!prevProps.selected && this.props.selected || (0, $hJSyB.favoritesChangedPessimistically)(prevProps.favoriteChangeContext, this.props.favoriteChangeContext)) // attempt to reload the data
        this.reload();
    }
    componentWillUnmount() {
        this.canSetState = false;
        if (window) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('visibilitychange', this.reload);
    }
    render() {
        return this.props.children({
            data: this.state.data,
            loading: this.state.loading,
            reloading: this.state.reloading,
            error: this.state.error,
            reorder: this.reorderData,
            updateAvailable: this.state.updateAvailable,
            update: this.updateToLatest
        });
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line react/sort-comp
        this.didReceivePrefetchData = ()=>{
            const { prefetchResult: prefetchResult, providerKey: providerKey } = this.props;
            return !prefetchResult.loading && !!prefetchResult.data && !!prefetchResult.data.tabs && !!prefetchResult.data.tabs[providerKey] && !!prefetchResult.data.tabs[providerKey].data;
        }, this.isResultMissingInPrefetch = ()=>{
            const { prefetchResult: prefetchResult, providerKey: providerKey } = this.props;
            return !prefetchResult.loading && (!prefetchResult.data || !prefetchResult.data.tabs || !prefetchResult.data.tabs[providerKey] || !prefetchResult.data.tabs[providerKey].data);
        }, this.parsePrefetchData = ()=>{
            const { prefetchResult: prefetchResult, providerKey: providerKey } = this.props;
            if (!prefetchResult.loading && prefetchResult.data && prefetchResult.data.tabs && prefetchResult.data.tabs[providerKey] && prefetchResult.data.tabs[providerKey].data) return prefetchResult.data.tabs[providerKey].data;
            // @ts-expect-error - TS2322 - Type '{ readonly sections: readonly []; readonly total: 0; }' is not assignable to type 'ItemProviderData'.
            return $b8dcb297e414b78b$export$dbdc7674ebd4ca0a;
        }, this.state = {
            data: this.parsePrefetchData(),
            loading: !this.didReceivePrefetchData(),
            reloading: false,
            initialised: this.didReceivePrefetchData(),
            error: undefined,
            fetchTime: new Date().getTime() + (0, $d97aad3f3e53cebb$export$ef0746d38f69fe04) + (0, $d97aad3f3e53cebb$export$fa73dea77ea505e9),
            updateAvailable: false
        }, this.isUpdateAvailable = ()=>{
            const { data: data } = this.state;
            const latest = this.parsePrefetchData();
            return this.state.updateAvailable === true || !(0, $fQ03e.isItemProviderDataEqual)(data, latest);
        }, this.shouldAutoUpdate = ()=>{
            const { data: data } = this.state;
            return this.props.autoUpdate === true || !data || !data.sections || data.sections.length === 0;
        }, this.updateToLatest = ()=>{
            const data = this.parsePrefetchData();
            this.updateData(data);
        }, this.updateData = (data)=>{
            const { id: id, onTotalChange: onTotalChange } = this.props;
            if (!this.state.data || this.state.data.total !== data.total) onTotalChange && onTotalChange(id, data.total);
            this.setState({
                data: data,
                updateAvailable: false
            });
        }, this.canSetState = false, this.fetching = false, this.addDataToState = (data)=>{
            if (!this.canSetState) return;
            this.setState((prevState, props)=>{
                if (prevState.initialised === false) props.onTotalChange(props.providerKey, data.total);
                else if (prevState.data.total !== data.total) props.onTotalChange(props.providerKey, data.total);
                return {
                    loading: false,
                    initialised: true,
                    data: data,
                    fetchTime: new Date().getTime() + (0, $d97aad3f3e53cebb$export$ef0746d38f69fe04),
                    error: undefined
                };
            });
            this.fetching = false;
        }, this.fetchData = async ()=>{
            if (this.fetching === true) return;
            try {
                this.fetching = true;
                const { prefetchResult: prefetchResult, providerKey: providerKey } = this.props;
                prefetchResult.data?.tabs[providerKey]?.update?.();
                this.setState({
                    loading: false,
                    initialised: true,
                    fetchTime: new Date().getTime() + (0, $d97aad3f3e53cebb$export$ef0746d38f69fe04),
                    error: undefined
                });
                this.fetching = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                if (this.canSetState) {
                    // @ts-expect-error - TS2345 - Argument of type '(prevState: Readonly<ItemProviderState>) => { loading: false; error: any; data: ItemProviderData | { readonly sections: readonly []; readonly total: 0; }; reloading: boolean; initialised: boolean; fetchTime: number; updateAvailable?: boolean | undefined; }' is not assignable to parameter of type 'ItemProviderState | ((prevState: Readonly<ItemProviderState>, props: Readonly<Props>) => ItemProviderState | Pick<...> | null) | Pick<...> | null'.
                    this.setState((prevState)=>({
                            ...prevState,
                            loading: false,
                            error: e,
                            data: prevState.data.total ? prevState.data : $b8dcb297e414b78b$export$dbdc7674ebd4ca0a
                        }));
                    (0, $9pTd3.fireErrorAnalytics)({
                        error: e,
                        meta: {
                            id: 'itemProvider',
                            packageName: 'jiraHome'
                        }
                    });
                }
                this.fetching = false;
            }
        }, this.reorderData = (result)=>{
            this.onReorderData(result);
            (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendUIEvent({
                    actionSubject: 'reorderableItem',
                    action: 'reordered',
                    attributes: {
                        result: result
                    },
                    source: 'your work'
                });
            });
        }, this.onReorderData = async (result)=>{
            if (!this.props.onReorderItemsNew) return;
            const { prefetchResult: prefetchResult, providerKey: providerKey } = this.props;
            const { sections: sections } = this.state.data;
            const update = prefetchResult.data?.tabs[providerKey]?.update;
            const resolve = this.props.onReorderItemsNew(result, sections, update);
            // send backend request
            const itemsReodered = !!resolve && await resolve.save();
            // call the reload to update view if the server returns error.
            if (!itemsReodered) this.reload();
        }, this.reload = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(async ()=>{
            // Don't attempt reload if the network is down, it causes errors.
            if (globalThis.navigator?.onLine === false) return;
            if (!this.state.loading && !this.state.reloading && new Date().getTime() > this.state.fetchTime && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.visibilityState === 'visible') {
                this.setState({
                    reloading: true
                });
                await this.fetchData();
                this.setState({
                    reloading: false
                });
            }
        }, (0, $d97aad3f3e53cebb$export$677a33448fa3ce0a));
    }
}
const $b8dcb297e414b78b$var$ItemProviderWithSpaTransitionSubscriber = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3lhVL.default), null, (spaStateTransitionState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b8dcb297e414b78b$export$20d7a9065849b23d, {
                ...props,
                favoriteChangeContext: favoriteChangeContext,
                spaStateTransitionState: spaStateTransitionState
            })));
var $b8dcb297e414b78b$export$2e2bcd8739ae039 = $b8dcb297e414b78b$var$ItemProviderWithSpaTransitionSubscriber;

});
parcelRegister("hJSyB", function(module, exports) {
$parcel$export(module.exports, "favoritesChangedPessimistically", () => $eb2ccdae79f716ed$export$f6954cb313b4d90a);

var $9Dhvc = parcelRequire("9Dhvc");

var $jUVzX = parcelRequire("jUVzX");

var $40zJW = parcelRequire("40zJW");
/**
 * Finds if the item has been changed pessimistically.
 *
 * @param {*} item an item in the latest favorite change context
 * @param {*} prevItemsByType the items in the previous favorite change context, grouped by type
 */ const $eb2ccdae79f716ed$var$isItemChangedPessimistically = (item, prevItemsByType)=>{
    const { type: type, id: id, value: value, pending: pending } = item;
    if (pending === true) return false;
    const prevItem = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(prevItemsByType, `${type}.${id}`);
    if (!prevItem) return true;
    return prevItem.pending || prevItem.value !== value;
};
/**
 * Finds if any items in the array have a non-pending change.
 *
 * @param {*} items the items from latest favorite change context
 * @param {*} prevItemsByType the items in the previous favorite change context, grouped by type
 */ const $eb2ccdae79f716ed$var$itemsHavePessimisticUpdate = (items, prevItemsByType)=>(0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(items, (item)=>$eb2ccdae79f716ed$var$isItemChangedPessimistically(item, prevItemsByType));
const $eb2ccdae79f716ed$export$f6954cb313b4d90a = (prevContext, nextContext)=>{
    const prevItemsByType = prevContext.items;
    const nextItemsByType = nextContext.items;
    // @ts-expect-error - TS2769 - No overload matches this call.
    return (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(nextItemsByType, (itemsById)=>$eb2ccdae79f716ed$var$itemsHavePessimisticUpdate((0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(itemsById), prevItemsByType));
};

});

const $d97aad3f3e53cebb$export$ef0746d38f69fe04 = 500;
const $d97aad3f3e53cebb$export$fa73dea77ea505e9 = 3000;
const $d97aad3f3e53cebb$export$677a33448fa3ce0a = 5000;

parcelRegister("fQ03e", function(module, exports) {
$parcel$export(module.exports, "getSortedItems", () => $697cb6cb2f1a1dbc$export$bfb4bfd7fab7e1d8);
$parcel$export(module.exports, "trimItemsBySection", () => $697cb6cb2f1a1dbc$export$6c780ba1c133f724);
$parcel$export(module.exports, "addSection", () => $697cb6cb2f1a1dbc$export$b3168b879aa49104);
$parcel$export(module.exports, "isItemProviderDataEqual", () => $697cb6cb2f1a1dbc$export$940fede0081b54cc);
$parcel$export(module.exports, "EndInteractionsTracker", () => $697cb6cb2f1a1dbc$export$ff613cea64c96805);
$parcel$export(module.exports, "useFireErrorOrSuccessAnalytics", () => $697cb6cb2f1a1dbc$export$c04e2e14a32f5b4);

var $eJOHy = parcelRequire("eJOHy");

var $cYmQs = parcelRequire("cYmQs");

var $ibLUB = parcelRequire("ibLUB");
var $bf0oy = parcelRequire("bf0oy");
var $kQ82p = parcelRequire("kQ82p");
var $2InI0 = parcelRequire("2InI0");
var $iux1t = parcelRequire("iux1t");

var $6pRIG = parcelRequire("6pRIG");

var $mjinE = parcelRequire("mjinE");

var $9pTd3 = parcelRequire("9pTd3");

var $dYdRZ = parcelRequire("dYdRZ");
const $697cb6cb2f1a1dbc$export$bfb4bfd7fab7e1d8 = (result, timeZone, intl, getDateForComparison)=>{
    // items
    const todayItems = [];
    const yesterdayItems = [];
    const thisWeekItems = [];
    const thisMonthItems = [];
    const moreThanAMonthItems = [];
    const currentTimeInTimeZone = (0, $6pRIG.default)((0, $kQ82p.default)(new Date().toISOString()), timeZone);
    // epochs for comparison
    const today = (0, $2InI0.default)(currentTimeInTimeZone);
    const yesterday = (0, $2InI0.default)((0, $iux1t.default)(currentTimeInTimeZone, 1));
    const oneWeekAgo = (0, $2InI0.default)((0, $iux1t.default)(currentTimeInTimeZone, 6));
    const oneMonthAgo = (0, $2InI0.default)((0, $iux1t.default)(currentTimeInTimeZone, 29));
    result.forEach((item)=>{
        const since = getDateForComparison(item);
        if (since !== undefined) {
            if ((0, $ibLUB.default)(since, today)) todayItems.push(item);
            else if ((0, $ibLUB.default)(since, yesterday)) yesterdayItems.push(item);
            else if ((0, $ibLUB.default)(since, oneWeekAgo)) thisWeekItems.push(item);
            else if ((0, $bf0oy.default)(since, oneMonthAgo)) moreThanAMonthItems.push(item);
            else if ((0, $ibLUB.default)(since, oneMonthAgo)) thisMonthItems.push(item);
        }
    });
    return {
        todayItems: todayItems,
        yesterdayItems: yesterdayItems,
        thisWeekItems: thisWeekItems,
        thisMonthItems: thisMonthItems,
        moreThanAMonthItems: moreThanAMonthItems
    };
};
const $697cb6cb2f1a1dbc$export$6c780ba1c133f724 = (maxItems, sections)=>sections.reduce((accumulator, currentSection)=>{
        const { itemCount: itemCount } = accumulator;
        if (itemCount < maxItems) {
            const additionalItemCount = Math.min(currentSection.items.length, maxItems - itemCount);
            accumulator.sections.push({
                ...currentSection,
                items: currentSection.items.slice(0, additionalItemCount)
            });
            accumulator.itemCount += additionalItemCount;
        }
        return accumulator;
    }, {
        itemCount: 0,
        sections: []
    }).sections;
const $697cb6cb2f1a1dbc$export$b3168b879aa49104 = (sections, items, header)=>{
    if (items.length > 0) sections.push({
        header: header,
        items: items
    });
};
const $697cb6cb2f1a1dbc$export$940fede0081b54cc = (oldData, newData)=>// deep equal, ignoring viewTimeAgo attribute
    (0, (/*@__PURE__*/$parcel$interopDefault($cYmQs)))(oldData, newData, (val1, val2, key)=>{
        if (key === 'viewTimeAgo') return true;
        return undefined;
    });
const $697cb6cb2f1a1dbc$export$ff613cea64c96805 = ({ transitionKey: transitionKey, renderState: renderState })=>{
    (0, $eJOHy.useEffect)(()=>{
        (0, $dYdRZ.interactionMetrics)[transitionKey].stop({
            customData: {
                renderState: renderState
            }
        });
    }, [
        transitionKey,
        renderState
    ]);
    return null;
};
const $697cb6cb2f1a1dbc$export$c04e2e14a32f5b4 = (hasData, error, isLoading, tab, isUnauthenticated)=>{
    const wasExperienceSuccessful = hasData || !error;
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoading && !(isUnauthenticated != null && isUnauthenticated === true)) {
            (0, $mjinE.default)({
                analyticsSource: 'jiraHomeTabScreen',
                wasExperienceSuccesful: wasExperienceSuccessful,
                experience: 'showTabData',
                application: null,
                edition: null,
                additionalAttributes: {
                    tab: tab
                }
            });
            if (!wasExperienceSuccessful) (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'showTabData',
                    packageName: 'jiraHome'
                },
                error: error,
                attributes: {
                    tab: tab
                }
            });
        }
    // We need to prevent the 'error' object being added into
    // the deps list to avoid additional analytics being fired.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading,
        isUnauthenticated,
        tab,
        wasExperienceSuccessful
    ]);
};

});
parcelRegister("cYmQs", function(module, exports) {

var $hk7J0 = parcelRequire("hk7J0");
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function $971ccf34f2c7d275$var$isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? $hk7J0(value, other, undefined, customizer) : !!result;
}
module.exports = $971ccf34f2c7d275$var$isEqualWith;

});

parcelRegister("dYdRZ", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $0bbac757e39811b5$export$86db56030b57ba34);

var $hqYEY = parcelRequire("hqYEY");

var $bXOg3 = parcelRequire("bXOg3");
const $0bbac757e39811b5$export$86db56030b57ba34 = {
    [(0, $bXOg3.ASSIGNED_TAB_KEY)]: (0, $hqYEY.metrics).interaction({
        key: `${(0, $bXOg3.PERF_METRICS_TABS_PREFIX)}.${(0, $bXOg3.ASSIGNED_TAB_KEY)}`
    }),
    [(0, $bXOg3.WORKEDON_TAB_KEY)]: (0, $hqYEY.metrics).interaction({
        key: `${(0, $bXOg3.PERF_METRICS_TABS_PREFIX)}.${(0, $bXOg3.WORKEDON_TAB_KEY)}`
    }),
    [(0, $bXOg3.VIEWED_TAB_KEY)]: (0, $hqYEY.metrics).interaction({
        key: `${(0, $bXOg3.PERF_METRICS_TABS_PREFIX)}.${(0, $bXOg3.VIEWED_TAB_KEY)}`
    }),
    [(0, $bXOg3.STARRED_TAB_KEY)]: (0, $hqYEY.metrics).interaction({
        key: `${(0, $bXOg3.PERF_METRICS_TABS_PREFIX)}.${(0, $bXOg3.STARRED_TAB_KEY)}`
    }),
    [(0, $bXOg3.BOARDS_TAB_KEY)]: (0, $hqYEY.metrics).interaction({
        key: `${(0, $bXOg3.PERF_METRICS_TABS_PREFIX)}.${(0, $bXOg3.BOARDS_TAB_KEY)}`
    }),
    [(0, $bXOg3.WORK_SUGGESTIONS_TAB_KEY)]: (0, $hqYEY.metrics).interaction({
        key: `${(0, $bXOg3.PERF_METRICS_TABS_PREFIX)}.${(0, $bXOg3.WORK_SUGGESTIONS_TAB_KEY)}`
    })
};

});




parcelRegister("7KbdA", function(module, exports) {
$parcel$export(module.exports, "transformResult", () => $37d28619e0683be4$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "fetchData", () => $37d28619e0683be4$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $37d28619e0683be4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hgi0g = parcelRequire("hgi0g");

var $3ugTQ = parcelRequire("3ugTQ");

var $bXOg3 = parcelRequire("bXOg3");

var $ewZIt = parcelRequire("ewZIt");
const $37d28619e0683be4$export$f446d01a07ac0096 = `/rest/internal/2/favourites?count=${(0, $bXOg3.MAX_ITEMS_PER_PAGE)}&types=projects,issues,filters,dashboards,boards,queues,plans`;
const $37d28619e0683be4$export$f13b29f9ed0c5a03 = (data)=>{
    if (typeof data === 'undefined' || Array.isArray(data) === false) return undefined;
    if (data.length === 0) return {
        sections: [],
        total: 0
    };
    return {
        sections: [
            {
                items: data.map((item)=>{
                    const mappedItem = {
                        ...item,
                        type: `${item.type}s`,
                        id: `${item.id}`
                    };
                    if (item.type === 'board' && typeof item.metadata === 'string') {
                        mappedItem.attributes = mappedItem.attributes ? mappedItem.attributes : {};
                        mappedItem.attributes = {
                            ...mappedItem.attributes,
                            containerName: item.metadata
                        };
                    }
                    mappedItem.entityId = item.id;
                    return mappedItem;
                })
            }
        ],
        total: data.length
    };
};
const $37d28619e0683be4$export$8134c072fddab6a5 = async ()=>{
    const result = await (0, $hgi0g.default)($37d28619e0683be4$export$f446d01a07ac0096, {});
    if (typeof result === 'undefined' || !Array.isArray(result)) throw Error('Could not retrieve your favourites');
    return result;
};
const $37d28619e0683be4$var$mapToRequest = (payload)=>{
    const { entity: entity, beforeEntity: beforeEntity } = payload;
    return {
        entity: {
            id: Number(entity.id),
            type: entity.type
        },
        beforeEntityPosition: beforeEntity ? {
            id: Number(beforeEntity.id),
            type: beforeEntity.type
        } : null
    };
};
const $37d28619e0683be4$export$b09090648b8b5f2 = async (payload)=>{
    // TODO do the backend call
    const url = '/rest/internal/2/favourites';
    const body = $37d28619e0683be4$var$mapToRequest(payload);
    return (0, $3ugTQ.performPostRequest)(url, {
        body: JSON.stringify(body)
    }).then(()=>true).catch(()=>false);
};
const $37d28619e0683be4$var$reorder = (list, fromIndex, toIndex)=>{
    const result = [
        ...list
    ];
    const [removedItem] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, removedItem);
    return result;
};
const $37d28619e0683be4$export$28d16177d5da18d1 = (result, sections)=>{
    if (!sections || sections.length < 1) return undefined;
    const starredGroup = sections[0].items;
    const { destination: destination } = result;
    if (!destination || result.source.index === destination.index) return undefined;
    const starredItemsReordered = $37d28619e0683be4$var$reorder(starredGroup, result.source.index, destination.index);
    const draggedEntity = starredItemsReordered[destination.index];
    const beforeEntity = starredItemsReordered[destination.index + 1];
    const reorderItems = {
        items: starredItemsReordered
    };
    return {
        optimisticUpdate: {
            sections: [
                reorderItems
            ]
        },
        save: ()=>$37d28619e0683be4$export$b09090648b8b5f2({
                entity: draggedEntity,
                beforeEntity: beforeEntity,
                starredItemsReordered: starredItemsReordered
            })
    };
};
const $37d28619e0683be4$export$aef218ded99af9b4 = (result, sections, updateData)=>{
    if (!sections || sections.length < 1) return undefined;
    const starredGroup = sections[0].items;
    const { destination: destination } = result;
    if (!updateData || !destination || result.source.index === destination.index) return undefined;
    updateData((data)=>{
        if (Array.isArray(data) && data.length > 1 && data[0].id && data[0].type) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const favourites = data;
            return $37d28619e0683be4$var$reorder(favourites, result.source.index, destination.index);
        }
        return data;
    });
    const starredItemsReordered = $37d28619e0683be4$var$reorder(starredGroup, result.source.index, destination.index);
    const draggedEntity = starredItemsReordered[destination.index];
    const beforeEntity = starredItemsReordered[destination.index + 1];
    const reorderItems = {
        items: starredItemsReordered
    };
    return {
        optimisticUpdate: {
            sections: [
                reorderItems
            ]
        },
        save: ()=>$37d28619e0683be4$export$b09090648b8b5f2({
                entity: draggedEntity,
                beforeEntity: beforeEntity,
                starredItemsReordered: starredItemsReordered
            })
    };
};
const $37d28619e0683be4$var$FavouritesProvider = (props)=>{
    const { userProviderData: userProviderData, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewZIt.default), {
        ...otherProps,
        onReorderItems: $37d28619e0683be4$export$28d16177d5da18d1,
        onReorderItemsNew: $37d28619e0683be4$export$aef218ded99af9b4,
        autoUpdate: true
    });
};
var $37d28619e0683be4$export$2e2bcd8739ae039 = $37d28619e0683be4$var$FavouritesProvider;

});

parcelRegister("fXBb1", function(module, exports) {
$parcel$export(module.exports, "fetchData", () => $d646166501c47a8f$export$8134c072fddab6a5);
$parcel$export(module.exports, "transformResult", () => $d646166501c47a8f$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "default", () => $d646166501c47a8f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $lRq8t = parcelRequire("lRq8t");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $fYeTG = parcelRequire("fYeTG");

var $2QZBX = parcelRequire("2QZBX");

var $cHtIB = parcelRequire("cHtIB");

var $chqbB = parcelRequire("chqbB");

var $bXOg3 = parcelRequire("bXOg3");

var $dfke1 = parcelRequire("dfke1");
const $d646166501c47a8f$var$TIME_ZONE = (0, $2QZBX.toTimeZone)('UTC');
const $d646166501c47a8f$var$POLLING_INTERVAL = 5000;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d646166501c47a8f$var$isActiveTab = ()=>!document.hidden;
const $d646166501c47a8f$var$activityClient = (0, $chqbB.createActivityClient)('v3', 'jira');
const $d646166501c47a8f$export$8134c072fddab6a5 = (cloudId)=>$d646166501c47a8f$var$activityClient.fetchActivities([
        50,
        125,
        250
    ], {
        limit: (0, $bXOg3.MAX_ITEMS_PER_PAGE) * 2,
        rootContainerIds: [
            `ari:cloud:platform::site/${cloudId}`
        ],
        products: (0, $bXOg3.PRODUCTS)
    }, [
        'workedOn'
    ]);
const $d646166501c47a8f$export$f13b29f9ed0c5a03 = (result, intl)=>{
    if (result?.workedOn == null) return {
        sections: [],
        total: 0
    };
    const sections = (0, $dfke1.groupIntoSections)({
        result: (0, $dfke1.extractResponseItems)(result, intl),
        timeZone: $d646166501c47a8f$var$TIME_ZONE,
        intl: intl
    });
    return {
        sections: sections,
        total: result.workedOn.length
    };
};
const $d646166501c47a8f$var$WorkedOnProvider = ({ prefetchResult: prefetchResult, providerKey: providerKey, children: children })=>{
    const isMobileWebAndInMVPExperiment = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    const intl = (0, $lRq8t.default)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const defaultData = {
        sections: [],
        total: 0
    };
    const prefetchData = prefetchResult?.data?.tabs[providerKey]?.data;
    const hasPrefetchData = Boolean(prefetchData?.total);
    const [isActiveTabState, setIsActiveTabState] = (0, $eJOHy.useState)(true);
    const [data, setData] = (0, $eJOHy.useState)(prefetchData || defaultData);
    const [pollingData, setPollingData] = (0, $eJOHy.useState)(prefetchData || defaultData);
    const [updateAvailable, setUpdateAvailable] = (0, $eJOHy.useState)(false);
    const [loading, setLoading] = (0, $eJOHy.useState)(!hasPrefetchData);
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const [error, setError] = (0, $eJOHy.useState)();
    // TODO: when cleaning up Mobile MVP should consider always calling `useGICLifeCycleEvents` and make the use conditional
    // Should chat with "Your Work" team to see if we want to make the button appear after GIC issue create on desktop web as well (not just mobile web)
    const { subscribe: subscribe } = isMobileWebAndInMVPExperiment ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4PKlm.useGICLifeCycleEvents)() : {
        subscribe: undefined
    };
    const [hasNewIssueViaGIC, setHasNewIssueViaGIC] = (0, $eJOHy.useState)(false);
    const fetchAndTransformData = (0, $eJOHy.useCallback)(async ()=>{
        const response = await $d646166501c47a8f$export$8134c072fddab6a5(cloudId);
        return $d646166501c47a8f$export$f13b29f9ed0c5a03(response, intl);
    }, [
        cloudId,
        intl
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isMobileWebAndInMVPExperiment && subscribe) return subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, ()=>{
            setHasNewIssueViaGIC(true);
        });
    }, [
        isMobileWebAndInMVPExperiment,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const initalDataLoad = async ()=>{
            try {
                const results = await fetchAndTransformData();
                results && setData(results);
            } catch (err) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                setError(err);
            } finally{
                setLoading(false);
            }
        };
        !hasPrefetchData && initalDataLoad();
    }, [
        fetchAndTransformData,
        hasPrefetchData
    ]);
    const updateData = (0, $eJOHy.useCallback)(()=>{
        setData(pollingData);
        setUpdateAvailable(false);
    }, [
        pollingData
    ]);
    const backgroundCheckRef = (0, $eJOHy.useRef)(null);
    const stopPolling = (0, $eJOHy.useCallback)(()=>{
        backgroundCheckRef.current && clearInterval(backgroundCheckRef.current);
        backgroundCheckRef.current = null;
    }, []);
    const startPolling = (0, $eJOHy.useCallback)(()=>{
        stopPolling();
        backgroundCheckRef.current = setInterval(async ()=>{
            // when window tab gets re-activated or new issue is created via GIC
            if ($d646166501c47a8f$var$isActiveTab() && !isActiveTabState || hasNewIssueViaGIC) {
                setIsActiveTabState(true);
                setHasNewIssueViaGIC(false);
                const results = await fetchAndTransformData();
                if (results && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(pollingData?.sections, results.sections)) {
                    setPollingData(results);
                    setUpdateAvailable(true);
                }
            }
            // reset active tab state
            if (!$d646166501c47a8f$var$isActiveTab() && isActiveTabState) setIsActiveTabState(false);
        }, $d646166501c47a8f$var$POLLING_INTERVAL);
    }, [
        stopPolling,
        isActiveTabState,
        hasNewIssueViaGIC,
        fetchAndTransformData,
        pollingData?.sections
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startPolling();
        return ()=>stopPolling();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        startPolling
    ]);
    return children({
        data: data,
        loading: loading,
        reloading: false,
        error: error,
        updateAvailable: updateAvailable,
        update: updateData
    });
};
var $d646166501c47a8f$export$2e2bcd8739ae039 = $d646166501c47a8f$var$WorkedOnProvider;

});
parcelRegister("xMjNG", function(module, exports) {
$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $6988db3fd722d63c$export$876003a5b887f37e);
const $6988db3fd722d63c$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("4PKlm", function(module, exports) {
$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8e36a2abc6a32ec2$export$e3ff72f196296fcc);

var $8Urkc = parcelRequire("8Urkc");
const $8e36a2abc6a32ec2$var$GICLifeCycleEventsService = new (0, $8Urkc.PubSubHub)();
const $8e36a2abc6a32ec2$export$e3ff72f196296fcc = ()=>({
        ...$8e36a2abc6a32ec2$var$GICLifeCycleEventsService
    });

});
parcelRegister("8Urkc", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $ef124bfbd3a417bb$export$e3607828f8f2c01e);
class $ef124bfbd3a417bb$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("chqbB", function(module, exports) {
$parcel$export(module.exports, "createActivityClient", () => $c6cf21b18dd043bb$export$224367b01f71f2aa);

var $5BdcH = parcelRequire("5BdcH");

var $bsKjZ = parcelRequire("bsKjZ");
let $c6cf21b18dd043bb$var$previousClientVersion;
const $c6cf21b18dd043bb$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($c6cf21b18dd043bb$var$previousClientVersion && $c6cf21b18dd043bb$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $c6cf21b18dd043bb$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $5BdcH.ActivityClientV2)(product, baseUrl);
    return new (0, $bsKjZ.ActivityClientV3)(product, baseUrl, logger, configFetch);
};

});
parcelRegister("5BdcH", function(module, exports) {
$parcel$export(module.exports, "ActivityClientV2", () => $940d614706c0ae01$export$330ab0047f2fb745);

var $csYSh = parcelRequire("csYSh");

var $1J5kj = parcelRequire("1J5kj");

var $1tj4G = parcelRequire("1tj4G");
class $940d614706c0ae01$export$330ab0047f2fb745 extends (0, $1J5kj.ActivityClient) {
    constructor(product, baseUrl){
        super('v2', product, undefined, baseUrl), this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $csYSh.fetchActivitiesWithExperience)((experience)=>(0, $1tj4G.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        }, this.setProduct = (product)=>{
            this.product = product;
        };
    }
}

});
parcelRegister("csYSh", function(module, exports) {
$parcel$export(module.exports, "fetchActivitiesWithExperience", () => $489b686fffef6f2a$export$4a906f16800734f3);

var $gU173 = parcelRequire("gU173");

var $9Rfzc = parcelRequire("9Rfzc");

var $gY91T = parcelRequire("gY91T");
async function $489b686fffef6f2a$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $gY91T.recentWorkClientExperienceV2)() : (0, $gY91T.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $9Rfzc.packageName,
            packageVersion: $9Rfzc.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $489b686fffef6f2a$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $489b686fffef6f2a$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $gU173.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};

});
parcelRegister("gU173", function(module, exports) {
$parcel$export(module.exports, "default", () => $31456f91ba8f8087$export$2e2bcd8739ae039);
class $31456f91ba8f8087$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $31456f91ba8f8087$export$97b788730ba59845 = (e)=>e instanceof $31456f91ba8f8087$export$2e2bcd8739ae039;

});

parcelRegister("9Rfzc", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $c8a5a72ab88e3c43$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $c8a5a72ab88e3c43$export$91546b032799aa40);
const $c8a5a72ab88e3c43$export$9345d7360ffe0722 = "platform-pkg";
const $c8a5a72ab88e3c43$export$91546b032799aa40 = "0.0.0-use.local";

});

parcelRegister("gY91T", function(module, exports) {
$parcel$export(module.exports, "recentWorkClientExperienceV2", () => $775a25df4f24cd67$export$d7769758f5eaa63b);
$parcel$export(module.exports, "recentWorkClientExperienceV3", () => $775a25df4f24cd67$export$9e32a4ed888f4717);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $775a25df4f24cd67$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $775a25df4f24cd67$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($775a25df4f24cd67$var$keyToTiming);
const $775a25df4f24cd67$export$d7769758f5eaa63b = ()=>{
    return new (0, $f39LL.UFOExperience)('client', {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $775a25df4f24cd67$var$timings
    });
};
const $775a25df4f24cd67$export$9e32a4ed888f4717 = ()=>new (0, $f39LL.UFOExperience)('client-v3', {
        type: (0, $2lxLk.ExperienceTypes).Load,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $775a25df4f24cd67$var$timings
    });

});


parcelRegister("1J5kj", function(module, exports) {
$parcel$export(module.exports, "ActivityClient", () => $ec6db3366398bbd0$export$157740f5433f3dbe);

var $1qSOD = parcelRequire("1qSOD");
class $ec6db3366398bbd0$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.product = 'unknown';
        this.baseUrl = (0, $1qSOD.GRAPHQL_GATEWAY_PATH);
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}

});
parcelRegister("1qSOD", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_GATEWAY_PATH", () => $0666145e87499778$export$851c5df667ca24c8);
$parcel$export(module.exports, "VIEWED_EVENT", () => $0666145e87499778$export$d245b105c09339d8);
$parcel$export(module.exports, "WORKED_EVENT", () => $0666145e87499778$export$eb4e9f525aef1cc3);
$parcel$export(module.exports, "ActivityObjectType", () => $0666145e87499778$export$d02a56686be43f69);
const $0666145e87499778$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $0666145e87499778$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SMARTLINK_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SMARTLINK_CLICKED"] = "sl-clicked";
    return VIEWED_EVENT;
}({});
var $0666145e87499778$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $0666145e87499778$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    // 3P Graph types below
    ActivityObjectType["DOCUMENT"] = "document";
    ActivityObjectType["REMOTE_LINK"] = "remote-link";
    return ActivityObjectType;
}({});

});


parcelRegister("1tj4G", function(module, exports) {
$parcel$export(module.exports, "fetchActivitiesV2", () => $8c11877868dd350a$export$750ec7816fdd2f9e);

var $8TPWG = parcelRequire("8TPWG");

var $gbikV = parcelRequire("gbikV");

var $2xqwp = parcelRequire("2xqwp");

var $h9AVW = parcelRequire("h9AVW");
const $8c11877868dd350a$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $8c11877868dd350a$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $8c11877868dd350a$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $8c11877868dd350a$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $8c11877868dd350a$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $2xqwp.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $8c11877868dd350a$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $gbikV.postResource)(baseUrl, {
            operationName: (0, $8TPWG.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($8c11877868dd350a$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $h9AVW.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $h9AVW.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $h9AVW.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $h9AVW.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $h9AVW.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};

});
parcelRegister("8TPWG", function(module, exports) {
$parcel$export(module.exports, "getOperationName", () => $f715a8e0c1695e46$export$41bca9dc6871dd4e);

var $7mF43 = parcelRequire("7mF43");
const $f715a8e0c1695e46$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(product);
};
const $f715a8e0c1695e46$export$41bca9dc6871dd4e = (product)=>{
    return `${$f715a8e0c1695e46$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};

});

parcelRegister("gbikV", function(module, exports) {
$parcel$export(module.exports, "postResource", () => $4964a47baa17325b$export$2ff3e1f219ccfad6);

var $eWi0F = parcelRequire("eWi0F");

var $gs2dD = parcelRequire("gs2dD");

var $gU173 = parcelRequire("gU173");
const $4964a47baa17325b$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $gs2dD.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $eWi0F.FailedFetchError)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $4964a47baa17325b$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $gU173.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $4964a47baa17325b$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $4964a47baa17325b$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return text ? JSON.parse(text) : {};
};
const $4964a47baa17325b$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $eWi0F.retryOnException)(()=>$4964a47baa17325b$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $4964a47baa17325b$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}

});
parcelRegister("gs2dD", function(module, exports) {
$parcel$export(module.exports, "getFullUrl", () => $b1e3cc787b07405c$export$2414511207262909);
const $b1e3cc787b07405c$var$urlRegex = new RegExp(/^https?:\/\//);
function $b1e3cc787b07405c$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($b1e3cc787b07405c$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}

});


parcelRegister("2xqwp", function(module, exports) {
$parcel$export(module.exports, "generateActivityQueryWithFilters", () => $11d60da9688edb07$export$855cd08371c65b8c);

var $8TPWG = parcelRequire("8TPWG");

var $3mgIE = parcelRequire("3mgIE");
const $11d60da9688edb07$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $11d60da9688edb07$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$11d60da9688edb07$var$ACTIVITIES}
   }
`;
const $11d60da9688edb07$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$11d60da9688edb07$var$ACTIVITIES}
   }
`;
const $11d60da9688edb07$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$11d60da9688edb07$var$ACTIVITIES}
    }
`;
const $11d60da9688edb07$var$activityQueryMap = new Map([
    [
        'workedOn',
        $11d60da9688edb07$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $11d60da9688edb07$var$VIEWED__QUERY
    ],
    [
        'all',
        $11d60da9688edb07$var$ALL__QUERY
    ]
]);
const $11d60da9688edb07$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $11d60da9688edb07$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $8TPWG.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $11d60da9688edb07$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $11d60da9688edb07$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$11d60da9688edb07$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $3mgIE.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $11d60da9688edb07$var$getActivitiesQuery(product, $11d60da9688edb07$var$getMyActivitiesQuery(activityQueries.map((query)=>$11d60da9688edb07$var$activityQueryMap.get(query)))),
        queryFilters: (0, $3mgIE.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};

});
parcelRegister("3mgIE", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_COLLECTION", () => $82a17e001791a7c8$export$5201d39848130041);

var $8cyeC = parcelRequire("8cyeC");

var $in7CV = parcelRequire("in7CV");
const $82a17e001791a7c8$export$5201d39848130041 = {
    v2: (0, $8cyeC.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $in7CV.ACTIVITY_FILTER_V3_MAP)
};

});
parcelRegister("8cyeC", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_V2_MAP", () => $f6f6cd8ce4913a0c$export$1dca7bc1ec360897);

var $3OwDA = parcelRequire("3OwDA");

var $il7el = parcelRequire("il7el");
const $f6f6cd8ce4913a0c$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $il7el.default)
    ],
    [
        'activities',
        (0, $3OwDA.default)
    ]
]);

});
parcelRegister("3OwDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $84f2f4555be35c89$export$2e2bcd8739ae039);

var $7JZHe = parcelRequire("7JZHe");
/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $84f2f4555be35c89$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $7JZHe.generateActivityFiltersV2)(restFilters);
};
var $84f2f4555be35c89$export$2e2bcd8739ae039 = $84f2f4555be35c89$var$generateV2ActivitiesFilters;

});
parcelRegister("7JZHe", function(module, exports) {
$parcel$export(module.exports, "generateActivityFiltersV2", () => $18e3fa8a6a3d2879$export$ebef9c1f1e15c057);

var $9GdCG = parcelRequire("9GdCG");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $18e3fa8a6a3d2879$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $18e3fa8a6a3d2879$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $18e3fa8a6a3d2879$export$ebef9c1f1e15c057 = (filters = {})=>(0, $9GdCG.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $18e3fa8a6a3d2879$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $18e3fa8a6a3d2879$var$KEYS_TO_TRANSFROM.has(originalkey) ? $18e3fa8a6a3d2879$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });

});
parcelRegister("9GdCG", function(module, exports) {
$parcel$export(module.exports, "generateActivityFilters", () => $98107f9ffbd16baf$export$23c75313f46dd54e);
const $98107f9ffbd16baf$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};

});



parcelRegister("il7el", function(module, exports) {
$parcel$export(module.exports, "default", () => $57b51d3d8fbdb818$export$2e2bcd8739ae039);

var $7JZHe = parcelRequire("7JZHe");
/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $57b51d3d8fbdb818$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $7JZHe.generateActivityFiltersV2)(restFilters);
};
var $57b51d3d8fbdb818$export$2e2bcd8739ae039 = $57b51d3d8fbdb818$var$generateV2MyActivityFilters;

});


parcelRegister("in7CV", function(module, exports) {
$parcel$export(module.exports, "ACTIVITY_FILTER_V3_MAP", () => $446006248d93d475$export$9a1782843b6e99d2);

var $kXn68 = parcelRequire("kXn68");

var $7xBSI = parcelRequire("7xBSI");
const $446006248d93d475$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $7xBSI.default)
    ],
    [
        'activities',
        (0, $kXn68.default)
    ]
]);

});
parcelRegister("kXn68", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9ccd9cb5f90c6e8$export$2e2bcd8739ae039);

var $lUP8i = parcelRequire("lUP8i");
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $f9ccd9cb5f90c6e8$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $lUP8i.generateActivityFiltersV3)(restFilters);
};
var $f9ccd9cb5f90c6e8$export$2e2bcd8739ae039 = $f9ccd9cb5f90c6e8$var$generateV3ActivityFilters;

});
parcelRegister("lUP8i", function(module, exports) {
$parcel$export(module.exports, "generateActivityFiltersV3", () => $57762e3ceefb4c04$export$e73fe7ded3fe2664);

var $9GdCG = parcelRequire("9GdCG");
// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $57762e3ceefb4c04$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $57762e3ceefb4c04$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $57762e3ceefb4c04$export$e73fe7ded3fe2664 = (filters = {})=>(0, $9GdCG.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $57762e3ceefb4c04$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $57762e3ceefb4c04$var$ROOT_LEVEL_FILTERS);

});


parcelRegister("7xBSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8bcd446d74c1ab18$export$2e2bcd8739ae039);

var $lUP8i = parcelRequire("lUP8i");
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $8bcd446d74c1ab18$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $lUP8i.generateActivityFiltersV3)(restFilters);
};
var $8bcd446d74c1ab18$export$2e2bcd8739ae039 = $8bcd446d74c1ab18$var$generateV3MyActivityFilters;

});




parcelRegister("h9AVW", function(module, exports) {
$parcel$export(module.exports, "transformActivitiesItems", () => $df19be354364454d$export$306a8b649360ca6f);
const $df19be354364454d$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $df19be354364454d$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$df19be354364454d$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}

});



parcelRegister("bsKjZ", function(module, exports) {
$parcel$export(module.exports, "ActivityClientV3", () => $acbdb5ff934b0544$export$3c3c237c92ca1fb9);

var $eWi0F = parcelRequire("eWi0F");

var $eGOwo = parcelRequire("eGOwo");

var $1qSOD = parcelRequire("1qSOD");

var $9Rfzc = parcelRequire("9Rfzc");

var $csYSh = parcelRequire("csYSh");

var $gbikV = parcelRequire("gbikV");

var $jDc5C = parcelRequire("jDc5C");

var $87wMT = parcelRequire("87wMT");

var $2CP4c = parcelRequire("2CP4c");

var $cmHp5 = parcelRequire("cmHp5");

var $b9ukK = parcelRequire("b9ukK");

var $2tRsM = parcelRequire("2tRsM");

var $1J5kj = parcelRequire("1J5kj");

var $2zxwo = parcelRequire("2zxwo");

var $abZO8 = parcelRequire("abZO8");

var $g49ow = parcelRequire("g49ow");
const $acbdb5ff934b0544$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $acbdb5ff934b0544$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $acbdb5ff934b0544$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $acbdb5ff934b0544$var$DEFAULT_TAGS = {
    source: (0, $9Rfzc.packageName),
    sourcePackageVersion: (0, $9Rfzc.packageVersion)
};
class $acbdb5ff934b0544$export$3c3c237c92ca1fb9 extends (0, $1J5kj.ActivityClient) {
    constructor(product, baseUrl, logger, configFetch){
        super('v3', product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl), this.setProduct = (product)=>{
            this.product = product;
        }, this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$acbdb5ff934b0544$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$acbdb5ff934b0544$var$DEFAULT_TAGS,
                ...tags
            });
        }, this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig(), this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $87wMT.GraphQLJSError)(err));
                    const invalidFragment = (0, $2zxwo.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        }, this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $eWi0F.retryOnException)(async ()=>{
                    const request = (0, $abZO8.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $g49ow.filtersToMetadata)(filters)
                    });
                    const res = await (0, $gbikV.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $g49ow.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $jDc5C.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $jDc5C.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$acbdb5ff934b0544$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$acbdb5ff934b0544$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $g49ow.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $2CP4c.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $acbdb5ff934b0544$var$transformActivityItem('workedOn', (0, $g49ow.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $acbdb5ff934b0544$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $acbdb5ff934b0544$var$transformActivityItem('all', (0, $g49ow.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $g49ow.rollupActivitiesData)(activities) : activities;
        }, this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $csYSh.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $2tRsM.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, product, configFetch);
    }
}
const $acbdb5ff934b0544$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $b9ukK.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc) return (0, $b9ukK.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    if (object.product === 'graph' && (0, $b9ukK.isThirdPartyARI)(object.id)) {
        const product = (0, $b9ukK.parseThirdPartyProduct)(object.id).split('.').at(1);
        return (0, $b9ukK.hydrate3pIcon)(product, hydratedData.icon, hydratedData.staticFallbacks);
    }
    return $acbdb5ff934b0544$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $b9ukK.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $b9ukK.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
function $acbdb5ff934b0544$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            let product = object.product;
            const isGraphProductTransformEnabled = (0, $eGOwo.fg)('platform_recentwork_client_graph_product_transform');
            if (isGraphProductTransformEnabled && (object.product === 'graph' || object.id.startsWith('ari:cloud:graph::pull-request'))) product = (0, $g49ow.getThirdPartyGraphProvider)(object);
            const isSmartlinkViewedType = item.node.event.eventType === (0, $1qSOD.VIEWED_EVENT).SMARTLINK_VIEWED;
            const isRemoteLinkGateDisabled = !(0, $eGOwo.fg)('recent_work_client_enable_graph_remote_links');
            const isSmartlinkViewedGateEnabled = (0, $eGOwo.fg)('platform_recent_work_enable_sl-viewed_results');
            const isExternalRemoteLink = item.node.object.data?.__typename === 'ExternalRemoteLink';
            if (isSmartlinkViewedType && !isSmartlinkViewedGateEnabled) // Don't return any `sl-viewed` event results
            return acc;
            if (isExternalRemoteLink && isRemoteLinkGateDisabled) // Don't return Remote Link result if not rolled out to product yet
            return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $cmHp5.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $b9ukK.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $b9ukK.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $1qSOD.WORKED_EVENT).CREATED ? (0, $1qSOD.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $g49ow.parseRootContainerARI)(object.rootContainerId),
                        icon: $acbdb5ff934b0544$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $b9ukK.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $b9ukK.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $b9ukK.hydratedValueToString)(hydratedData.name, ' '),
                        product: product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: (0, $b9ukK.hydratedValueToString)(hydratedData.subtype) || object.data.subtype,
                        url: (0, $b9ukK.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $b9ukK.hydratedValueToString)(hydratedData.objectTypeName),
                        creator: (0, $b9ukK.hydratedValueToString)(hydratedData.creator),
                        providerId: (0, $b9ukK.hydratedValueToString)(hydratedData.providerId)
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}

});
parcelRegister("jDc5C", function(module, exports) {
$parcel$export(module.exports, "GraphQLFragmentError", () => $fe67064028bee393$export$2d1b192199788179);
class $fe67064028bee393$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}

});

parcelRegister("87wMT", function(module, exports) {
$parcel$export(module.exports, "GraphQLJSError", () => $b25ec45525910987$export$8d4af49ee2a0fbe2);
class $b25ec45525910987$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}

});

parcelRegister("2CP4c", function(module, exports) {
$parcel$export(module.exports, "GraphQLNoResultsError", () => $cf5f5d3822a0ca3f$export$3f19ff30d409b70);
class $cf5f5d3822a0ca3f$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}

});

parcelRegister("cmHp5", function(module, exports) {
$parcel$export(module.exports, "hydratePolymorphicData", () => $5b3be4c394e077bd$export$d658049bf1a63492);

var $9Dhvc = parcelRequire("9Dhvc");

var $8ePzp = parcelRequire("8ePzp");
const $5b3be4c394e077bd$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $5b3be4c394e077bd$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $8ePzp.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $8ePzp.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $8ePzp.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $5b3be4c394e077bd$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $5b3be4c394e077bd$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(object, path);
}
function $5b3be4c394e077bd$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $5b3be4c394e077bd$var$getOrSearch(current, split);
    return current;
}
function $5b3be4c394e077bd$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(edge, fieldId) === searchValue);
}
function $5b3be4c394e077bd$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$5b3be4c394e077bd$var$resolvePath(object, path));
}
const $5b3be4c394e077bd$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $5b3be4c394e077bd$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};

});
parcelRegister("8ePzp", function(module, exports) {
$parcel$export(module.exports, "default", () => $1beb8040833dbe1c$export$2e2bcd8739ae039);
class $1beb8040833dbe1c$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}

});


parcelRegister("b9ukK", function(module, exports) {
$parcel$export(module.exports, "hydratedValueToString", () => $44323557307a74d6$export$c5cea44a1f75b431);
$parcel$export(module.exports, "parseThirdPartyProduct", () => $44323557307a74d6$export$4578ef3572b21f34);
$parcel$export(module.exports, "isThirdPartyARI", () => $44323557307a74d6$export$fccbae65febb6fd4);
$parcel$export(module.exports, "hydrate3pIcon", () => $44323557307a74d6$export$c60ec7b3c8b44fe1);
$parcel$export(module.exports, "hydrateIcon", () => $44323557307a74d6$export$a328b2bb0d21d984);
$parcel$export(module.exports, "hydrateConfluenceIcon", () => $44323557307a74d6$export$86b9f44277b105a6);
const $44323557307a74d6$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $44323557307a74d6$var$isURL(icon) {
    return typeof icon === 'string';
}
function $44323557307a74d6$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $44323557307a74d6$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $44323557307a74d6$export$4578ef3572b21f34 = (ari)=>{
    const result = $44323557307a74d6$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$44323557307a74d6$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $44323557307a74d6$export$fccbae65febb6fd4 = (ari)=>$44323557307a74d6$var$thirdPartyRegex.test(ari);
const $44323557307a74d6$export$c60ec7b3c8b44fe1 = (product, icons, fallbacks, fallbackKey = 'icon')=>{
    if (fallbacks?.[fallbackKey] && product) {
        const thirdPartyLogo = fallbacks['thirdPartyIconPath']?.replace('{replaceProductName}', product) ?? fallbacks[fallbackKey];
        return {
            type: 'URL',
            value: thirdPartyLogo,
            fallbackIcon: fallbacks[fallbackKey]
        };
    }
    return $44323557307a74d6$export$a328b2bb0d21d984(icons, fallbacks);
};
const $44323557307a74d6$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $44323557307a74d6$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $44323557307a74d6$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $44323557307a74d6$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $44323557307a74d6$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $44323557307a74d6$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $44323557307a74d6$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($44323557307a74d6$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($44323557307a74d6$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $44323557307a74d6$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks?.[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};

});

parcelRegister("2tRsM", function(module, exports) {
$parcel$export(module.exports, "FD_CLIENT_FETCH_PROPS", () => $013f12c041cd2a2f$export$c270c412a04ff3e6);
$parcel$export(module.exports, "default", () => $013f12c041cd2a2f$export$2e2bcd8739ae039);

var $9nfpX = parcelRequire("9nfpX");

var $9jEPj = parcelRequire("9jEPj");
const $013f12c041cd2a2f$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $013f12c041cd2a2f$var$FD_ENVIRONMENT = 'prod';
const $013f12c041cd2a2f$export$c270c412a04ff3e6 = {
    name: $013f12c041cd2a2f$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $013f12c041cd2a2f$var$FD_ENVIRONMENT
    }
};
class $013f12c041cd2a2f$export$2e2bcd8739ae039 {
    constructor(handlers, product, artifactFetch){
        this.artifactFetch = artifactFetch;
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        new (0, $9nfpX.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $013f12c041cd2a2f$var$FD_ENVIRONMENT
                },
                value: (0, $9jEPj.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
    async fetchArtifact() {
        if (this.artifactFetch) return 0, $9jEPj.default;
        // We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
        // https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
        return 0, $9jEPj.default;
    }
}

});
parcelRegister("9jEPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e8ff461ce37c118$export$2e2bcd8739ae039);
/* Fetch the latest artifact via: atlas fd get-artifact recent-work-service */ var $0e8ff461ce37c118$export$2e2bcd8739ae039 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-viewed': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            clicked: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-clicked': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceWhiteboard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'whiteboardId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceDatabase: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'databaseId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg'
            }
        },
        ConfluenceEmbed: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'embedId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'key'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        TrelloBoard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'boardName'
                ],
                url: [
                    'boardUrl'
                ],
                containers: [
                    'workspace.displayName'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg'
            }
        },
        TrelloCard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'cardName'
                ],
                url: [
                    'cardUrl'
                ],
                containers: [
                    'list.name',
                    'list.board.name'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg'
            }
        },
        DevOpsDocument: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ],
                icon: [
                    'type.iconUrl'
                ]
            }
        },
        DevOpsPullRequestDetails: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                url: [
                    'url'
                ],
                containers: [
                    'repositoryName'
                ],
                key: [
                    'providerName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg'
            }
        },
        DevOpsDesign: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg'
            }
        },
        ExternalDocument: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'type.category'
                ],
                key: [
                    'parent.displayName'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalRemoteLink: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'category'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        MercuryFocusArea: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'focusAreaType.name'
                ],
                icon: [
                    'icon.url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg'
            }
        },
        MercuryPortfolio: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'label'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg'
            }
        },
        CompassComponent: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'typeMetadata.iconUrl'
                ],
                key: [
                    'typeMetadata.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg'
            }
        },
        BitbucketPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'pullRequestTitle'
                ],
                url: [
                    'href'
                ],
                key: [
                    'pullRequestTitle'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg'
            }
        },
        LoomVideo: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'loomUrl'
                ],
                key: [
                    'owner.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg'
            }
        },
        AssetsObject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'label'
                ],
                key: [
                    'objectKey'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'avatar.url48'
                ],
                containers: [
                    'objectType.schema.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsObjectType: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsObjectTypeName'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'assetsObjectTypeIcon.url48'
                ],
                containers: [
                    'schema.assetsSchemaName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsSchema: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsSchemaName'
                ],
                key: [
                    'assetsSchemaKey'
                ],
                url: [
                    'links.web'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        schema {\n          name\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};

});


parcelRegister("2zxwo", function(module, exports) {
$parcel$export(module.exports, "default", () => $db719927e165bc8d$export$2e2bcd8739ae039);

var $gRJZh = parcelRequire("gRJZh");
const $db719927e165bc8d$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $gRJZh.default)
    ]
]);
const $db719927e165bc8d$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $db719927e165bc8d$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $db719927e165bc8d$export$2e2bcd8739ae039 = $db719927e165bc8d$var$graphQLErrorHandler;

});
parcelRegister("gRJZh", function(module, exports) {
$parcel$export(module.exports, "default", () => $95d80d0a1a262417$export$2e2bcd8739ae039);
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $95d80d0a1a262417$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $95d80d0a1a262417$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $95d80d0a1a262417$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $95d80d0a1a262417$export$2e2bcd8739ae039 = $95d80d0a1a262417$var$validationErrorHandler;

});


parcelRegister("abZO8", function(module, exports) {
$parcel$export(module.exports, "generateGraphQLRequest", () => $6797a6e5db35904b$export$7489a6ef09862e48);

var $8TPWG = parcelRequire("8TPWG");

var $3mgIE = parcelRequire("3mgIE");
const $6797a6e5db35904b$var$ACTIVITIES_LIMIT = 50;
const $6797a6e5db35904b$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $6797a6e5db35904b$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $6797a6e5db35904b$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $6797a6e5db35904b$var$activityQueryMap = new Map([
    [
        'workedOn',
        $6797a6e5db35904b$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $6797a6e5db35904b$var$VIEWED__QUERY
    ],
    [
        'all',
        $6797a6e5db35904b$var$ALL__QUERY
    ]
]);
const $6797a6e5db35904b$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $6797a6e5db35904b$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $8TPWG.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $6797a6e5db35904b$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $6797a6e5db35904b$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$6797a6e5db35904b$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $3mgIE.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $6797a6e5db35904b$var$getActivitiesQuery(product, $6797a6e5db35904b$var$getMyActivitiesQuery(activityQueries.map((query)=>$6797a6e5db35904b$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $3mgIE.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $6797a6e5db35904b$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $6797a6e5db35904b$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $6797a6e5db35904b$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $8TPWG.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};

});

parcelRegister("g49ow", function(module, exports) {
$parcel$export(module.exports, "rollupActivitiesData", () => $6a3c8ce15d6395aa$export$750d93207e30f59a);
$parcel$export(module.exports, "activityRoot", () => $6a3c8ce15d6395aa$export$ea55e8e0446efa94);
$parcel$export(module.exports, "parseRootContainerARI", () => $6a3c8ce15d6395aa$export$788e6013936a6bb4);
$parcel$export(module.exports, "filtersToMetadata", () => $6a3c8ce15d6395aa$export$e8f56bed6776c7ea);
$parcel$export(module.exports, "filterInvalidFragments", () => $6a3c8ce15d6395aa$export$e22863ec502608d2);
$parcel$export(module.exports, "isEmptyActivitiesWithErrorsResponse", () => $6a3c8ce15d6395aa$export$c939d6148e47244a);
$parcel$export(module.exports, "getThirdPartyGraphProvider", () => $6a3c8ce15d6395aa$export$618af76292d5645c);

var $l0AWw = parcelRequire("l0AWw");
function $6a3c8ce15d6395aa$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $6a3c8ce15d6395aa$var$rollUpActivityItems(all),
        viewed: $6a3c8ce15d6395aa$var$rollUpActivityItems(viewed),
        workedOn: $6a3c8ce15d6395aa$var$rollUpActivityItems(workedOn)
    };
}
function $6a3c8ce15d6395aa$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $6a3c8ce15d6395aa$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$6a3c8ce15d6395aa$var$fragmentName(key)} on ${$6a3c8ce15d6395aa$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $6a3c8ce15d6395aa$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $6a3c8ce15d6395aa$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $6a3c8ce15d6395aa$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $6a3c8ce15d6395aa$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $6a3c8ce15d6395aa$var$containerMapTypes = new Map([
    [
        $6a3c8ce15d6395aa$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $6a3c8ce15d6395aa$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $6a3c8ce15d6395aa$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $6a3c8ce15d6395aa$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $6a3c8ce15d6395aa$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $6a3c8ce15d6395aa$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$6a3c8ce15d6395aa$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($6a3c8ce15d6395aa$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $6a3c8ce15d6395aa$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $6a3c8ce15d6395aa$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$6a3c8ce15d6395aa$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $6a3c8ce15d6395aa$export$884573c560ed3600(response.data);
}
function $6a3c8ce15d6395aa$export$884573c560ed3600(queryData) {
    return !queryData.activity || $6a3c8ce15d6395aa$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $6a3c8ce15d6395aa$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}
function $6a3c8ce15d6395aa$export$618af76292d5645c(object) {
    const ari = object.id;
    let product = 'graph';
    if (ari.startsWith('ari:cloud:graph::pull-request') && object.data?.providerName) product = object.data?.providerName || 'graph';
    else if ((0, $l0AWw.isThirdPartyARI)(ari)) product = (0, $l0AWw.parseThirdPartyProduct)(ari).split('.')[1];
    return product.toLowerCase();
}

});
parcelRegister("l0AWw", function(module, exports) {
$parcel$export(module.exports, "parseThirdPartyProduct", () => $1e34212319a6d294$export$4578ef3572b21f34);
$parcel$export(module.exports, "isThirdPartyARI", () => $1e34212319a6d294$export$fccbae65febb6fd4);
const $1e34212319a6d294$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $1e34212319a6d294$export$4578ef3572b21f34 = (ari)=>{
    const result = $1e34212319a6d294$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$1e34212319a6d294$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $1e34212319a6d294$export$fccbae65febb6fd4 = (ari)=>$1e34212319a6d294$var$thirdPartyRegex.test(ari);

});




parcelRegister("dfke1", function(module, exports) {
$parcel$export(module.exports, "groupIntoSections", () => $098194a5cc18287d$export$ef30e794367b269c);
$parcel$export(module.exports, "extractResponseItems", () => $098194a5cc18287d$export$b5ff056d50b7c026);

var $5QvHY = parcelRequire("5QvHY");
var $dypWi = parcelRequire("dypWi");

var $6pRIG = parcelRequire("6pRIG");

var $fhBlZ = parcelRequire("fhBlZ");

var $fQ03e = parcelRequire("fQ03e");
const $098194a5cc18287d$export$dbbd4778d05e824e = (activity, intl)=>{
    let result = '';
    switch(activity.toUpperCase()){
        case 'ASSIGNED':
            result = intl.formatMessage((0, $fhBlZ.default).assignedAction);
            break;
        case 'COMMENTED':
            result = intl.formatMessage((0, $fhBlZ.default).commentedAction);
            break;
        case 'CREATED':
            result = intl.formatMessage((0, $fhBlZ.default).createdAction);
            break;
        case 'EDITED':
            result = intl.formatMessage((0, $fhBlZ.default).editedAction);
            break;
        case 'LIKED':
            result = intl.formatMessage((0, $fhBlZ.default).linkedAction);
            break;
        case 'PUBLISHED':
            result = intl.formatMessage((0, $fhBlZ.default).publishedAction);
            break;
        case 'TRANSITIONED':
            result = intl.formatMessage((0, $fhBlZ.default).transitionedAction);
            break;
        case 'UNASSIGNED':
            result = intl.formatMessage((0, $fhBlZ.default).unassignedAction);
            break;
        case 'UPDATED':
            result = intl.formatMessage((0, $fhBlZ.default).updatedAction);
            break;
        case 'VIEWED':
            result = intl.formatMessage((0, $fhBlZ.default).viewedAction);
            break;
        default:
            break;
    }
    return result;
};
const $098194a5cc18287d$var$sortByTimestamp = (a, b)=>b.timestamp && a.timestamp && b.timestamp - a.timestamp || 0;
const $098194a5cc18287d$export$ef30e794367b269c = ({ result: result, timeZone: timeZone, intl: intl })=>{
    const getDateForComparison = (item)=>typeof item.timestamp === 'number' ? (0, $6pRIG.default)((0, $5QvHY.default)(item.timestamp), timeZone) : undefined;
    const { todayItems: todayItems, yesterdayItems: yesterdayItems, thisWeekItems: thisWeekItems, thisMonthItems: thisMonthItems, moreThanAMonthItems: moreThanAMonthItems } = (0, $fQ03e.getSortedItems)(result, timeZone, intl, getDateForComparison);
    const sections = [];
    (0, $fQ03e.addSection)(sections, todayItems.sort($098194a5cc18287d$var$sortByTimestamp), intl.formatMessage((0, $fhBlZ.default).today));
    (0, $fQ03e.addSection)(sections, yesterdayItems.sort($098194a5cc18287d$var$sortByTimestamp), intl.formatMessage((0, $fhBlZ.default).yesterday));
    (0, $fQ03e.addSection)(sections, thisWeekItems.sort($098194a5cc18287d$var$sortByTimestamp), intl.formatMessage((0, $fhBlZ.default).inTheLastWeek));
    (0, $fQ03e.addSection)(sections, thisMonthItems.sort($098194a5cc18287d$var$sortByTimestamp), intl.formatMessage((0, $fhBlZ.default).inTheLastMonth));
    (0, $fQ03e.addSection)(sections, moreThanAMonthItems.sort($098194a5cc18287d$var$sortByTimestamp), intl.formatMessage((0, $fhBlZ.default).moreThanAMonthAgo));
    return sections;
};
const $098194a5cc18287d$export$b5ff056d50b7c026 = (response, intl)=>response.workedOn.map((item)=>({
            id: item?.object?.id,
            title: item?.object?.name || '',
            entityId: item?.object?.localResourceId || '',
            subtitle: item?.containers?.[0]?.name,
            metadata: '',
            avatarUrl: item?.object?.icon?.value,
            url: item?.object?.url,
            action: $098194a5cc18287d$export$dbbd4778d05e824e(item?.eventType, intl),
            user: {
                avatarUrl: '',
                label: '',
                displayName: ''
            },
            attributes: {
                ownerId: '',
                containerId: '',
                containerName: item?.containers?.[1]?.name,
                issueTypeId: '',
                issueTypeName: item?.object?.objectTypeName ?? '',
                parentType: ''
            },
            timestamp: (0, $dypWi.default)(new Date(item.timestamp)),
            type: item?.object?.type,
            contributors: item?.contributors?.map((c)=>({
                    accountId: c.accountId,
                    active: true,
                    name: c.name ?? '',
                    avatarUrls: {
                        '48x48': c.picture,
                        '24x24': c.picture,
                        '16x16': c.picture,
                        '32x32': c.picture
                    },
                    picture: c.picture
                })).filter(Boolean) ?? [],
            favourite: undefined
        }));

});
parcelRegister("fhBlZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8d9481c15fa7e05$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a8d9481c15fa7e05$var$messages = (0, $7qGN1.defineMessages)({
    today: {
        "id": "home.common.today",
        "defaultMessage": "Today"
    },
    yesterday: {
        "id": "home.common.yesterday",
        "defaultMessage": "Yesterday"
    },
    inTheLastWeek: {
        "id": "home.common.in-the-last-week",
        "defaultMessage": "In the last week"
    },
    inTheLastMonth: {
        "id": "home.common.in-the-last-month",
        "defaultMessage": "In the last month"
    },
    moreThanAMonthAgo: {
        "id": "home.common.more-than-a-month-ago",
        "defaultMessage": "More than a month ago"
    },
    assignedAction: {
        "id": "home.common.assigned-action",
        "defaultMessage": "Assigned"
    },
    commentedAction: {
        "id": "home.common.commented-action",
        "defaultMessage": "Commented on"
    },
    createdAction: {
        "id": "home.common.created-action",
        "defaultMessage": "Created"
    },
    editedAction: {
        "id": "home.common.edited-action",
        "defaultMessage": "Edited"
    },
    linkedAction: {
        "id": "home.common.linked-action",
        "defaultMessage": "Liked"
    },
    publishedAction: {
        "id": "home.common.published-action",
        "defaultMessage": "Published"
    },
    transitionedAction: {
        "id": "home.common.transitioned-action",
        "defaultMessage": "Transitioned"
    },
    unassignedAction: {
        "id": "home.common.unassigned-action",
        "defaultMessage": "Unassigned"
    },
    updatedAction: {
        "id": "home.common.updated-action",
        "defaultMessage": "Updated"
    },
    viewedAction: {
        "id": "home.common.viewed-action",
        "defaultMessage": "Viewed"
    }
});
var $a8d9481c15fa7e05$export$2e2bcd8739ae039 = $a8d9481c15fa7e05$var$messages;

});



parcelRegister("cPmvw", function(module, exports) {
$parcel$export(module.exports, "transformResult", () => $20f8889b5f1312ef$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "fetchAllData", () => $20f8889b5f1312ef$export$cf811317032613b5);
$parcel$export(module.exports, "default", () => $20f8889b5f1312ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");
var $bysPq = parcelRequire("bysPq");

var $6pRIG = parcelRequire("6pRIG");

var $hgi0g = parcelRequire("hgi0g");

var $6YFG2 = parcelRequire("6YFG2");

var $2QZBX = parcelRequire("2QZBX");

var $bXOg3 = parcelRequire("bXOg3");

var $fhBlZ = parcelRequire("fhBlZ");

var $fQ03e = parcelRequire("fQ03e");

var $ewZIt = parcelRequire("ewZIt");
const $20f8889b5f1312ef$export$f446d01a07ac0096 = '/rest/internal/2/productsearch/singleRecentList';
const $20f8889b5f1312ef$export$6bb03cd60697a4cc = '/rest/api/3/myself';
const $20f8889b5f1312ef$export$f13b29f9ed0c5a03 = (result, intl)=>{
    if (result == null) return undefined;
    const { data: items, timeZone: timeZone } = result;
    if (items == null || items.length === 0) return {
        sections: [],
        total: 0
    };
    const currentTimeInTimeZone = (0, $6pRIG.default)((0, $kQ82p.default)(new Date().toISOString()), timeZone);
    const getDateForComparison = (item)=>typeof item.viewTimeAgo === 'number' ? (0, $bysPq.default)(currentTimeInTimeZone, item.viewTimeAgo / 1000) : undefined;
    const sortedItems = (0, $fQ03e.getSortedItems)(items, timeZone, intl, getDateForComparison);
    const todayItems = sortedItems.todayItems.map((item)=>({
            ...item,
            entityId: item.id,
            favourite: undefined
        }));
    const yesterdayItems = sortedItems.yesterdayItems.map((item)=>({
            ...item,
            entityId: item.id,
            favourite: undefined
        }));
    const thisWeekItems = sortedItems.thisWeekItems.map((item)=>({
            ...item,
            entityId: item.id,
            favourite: undefined
        }));
    const thisMonthItems = sortedItems.thisMonthItems.map((item)=>({
            ...item,
            entityId: item.id,
            favourite: undefined
        }));
    const moreThanAMonthItems = sortedItems.moreThanAMonthItems.map((item)=>({
            ...item,
            entityId: item.id,
            favourite: undefined
        }));
    // @ts-expect-error - TS2304 - Cannot find name 'ItemProviderDataSection'.
    const sections = [];
    (0, $fQ03e.addSection)(sections, todayItems, intl.formatMessage((0, $fhBlZ.default).today));
    (0, $fQ03e.addSection)(sections, yesterdayItems, intl.formatMessage((0, $fhBlZ.default).yesterday));
    (0, $fQ03e.addSection)(sections, thisWeekItems, intl.formatMessage((0, $fhBlZ.default).inTheLastWeek));
    (0, $fQ03e.addSection)(sections, thisMonthItems, intl.formatMessage((0, $fhBlZ.default).inTheLastMonth));
    (0, $fQ03e.addSection)(sections, moreThanAMonthItems, intl.formatMessage((0, $fhBlZ.default).moreThanAMonthAgo));
    return {
        sections: sections,
        total: items.length
    };
};
const $20f8889b5f1312ef$export$ff2e61bf147c4562 = async ()=>{
    const result = await (0, $hgi0g.default)($20f8889b5f1312ef$export$f446d01a07ac0096, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            groups: [
                {
                    types: [
                        'issues',
                        'boards',
                        'projects',
                        'filters',
                        'dashboards',
                        'queues'
                    ],
                    limit: (0, $bXOg3.MAX_ITEMS_PER_PAGE) * 2
                }
            ]
        })
    });
    if (typeof result !== 'undefined' && Array.isArray(result) && typeof result[0] !== 'undefined' && typeof result[0] !== 'undefined' && Array.isArray(result[0].items)) return result[0].items;
    throw Error('Could not retrieve recently viewed');
};
const $20f8889b5f1312ef$var$timeZoneUTC = (0, $2QZBX.toTimeZone)('UTC');
const $20f8889b5f1312ef$export$5140c0adab7fd8a = async ()=>{
    const result = await fetch($20f8889b5f1312ef$export$6bb03cd60697a4cc);
    if (result.status > 200) return $20f8889b5f1312ef$var$timeZoneUTC;
    const userData = await result.json();
    if (userData && userData.timeZone) return (0, $2QZBX.toTimeZone)(userData.timeZone);
    return $20f8889b5f1312ef$var$timeZoneUTC;
};
const $20f8889b5f1312ef$export$cf811317032613b5 = async ()=>{
    const [rawData, timeZone] = await Promise.all([
        $20f8889b5f1312ef$export$ff2e61bf147c4562(),
        $20f8889b5f1312ef$export$5140c0adab7fd8a()
    ]);
    return {
        data: rawData,
        timeZone: timeZone
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $20f8889b5f1312ef$var$RecentlyViewedProvider extends (0, $eJOHy.Component) {
    // eslint-disable-next-line react/sort-comp
    getTimeZoneProps() {
        const { prefetchResult: prefetchResult, userProviderData: userProviderData } = this.props;
        if (userProviderData.loading === false && typeof userProviderData.error === 'undefined' && // @ts-expect-error - Property 'data' does not exist on type 'never'.
        userProviderData.data !== null && // @ts-expect-error - Property 'data' does not exist on type 'never'.
        userProviderData.data.user && // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
        userProviderData.data.user.timeZone) // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
        return userProviderData.data.user.timeZone;
        if (prefetchResult.data && prefetchResult.data.tabs && prefetchResult.data.tabs[this.props.providerKey]) {
            const data = prefetchResult.data.tabs[this.props.providerKey];
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            if (typeof data.timeZone !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            return (0, $2QZBX.toTimeZone)(data.timeZone);
        }
        return undefined;
    }
    componentDidMount() {
        this.canSetState = true;
        if (!this.getTimeZoneProps()) this.fetchTimeZone();
    }
    componentWillUnmount() {
        this.canSetState = false;
    }
    render() {
        const { intl: intl, userProviderData: userProviderData, ...otherProps } = this.props;
        const { data: timeZone } = this.state;
        if (typeof timeZone === 'undefined') return this.props.children({
            loading: this.state.loading,
            reloading: false,
            data: {
                sections: [],
                total: 0
            },
            error: this.state.error
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewZIt.default), otherProps);
    }
    constructor(...args){
        super(...args), this.state = {
            data: this.getTimeZoneProps(),
            loading: !this.getTimeZoneProps(),
            error: undefined
        }, this.fetching = false, this.canSetState = false, this.fetchTimeZone = async ()=>{
            if (this.fetching === true) return;
            try {
                this.fetching = true;
                const data = await $20f8889b5f1312ef$export$5140c0adab7fd8a();
                if (!this.canSetState) return;
                if (typeof data === 'undefined') return;
                this.setState((prevState)=>({
                        ...prevState,
                        loading: false,
                        data: data,
                        error: undefined
                    }));
                this.fetching = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                if (this.canSetState) this.setState({
                    loading: false,
                    error: e
                });
                this.fetching = false;
            }
        };
    }
}
var $20f8889b5f1312ef$export$2e2bcd8739ae039 = (0, $6YFG2.default)($20f8889b5f1312ef$var$RecentlyViewedProvider);

});

parcelRegister("6UU7v", function(module, exports) {
$parcel$export(module.exports, "withSuspense", () => $d591853152e8b41d$export$a3bce93d4fb4eda6);
const $d591853152e8b41d$var$isDataEmpty = (data)=>data == null;
function $d591853152e8b41d$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $d591853152e8b41d$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("8pvq9", function(module, exports) {
$parcel$export(module.exports, "HrExpansionSpotlight", () => $32819350c4ea4a7f$export$70aac9b19a402d6);

var $eJOHy = parcelRequire("eJOHy");

var $5hQBi = parcelRequire("5hQBi");

var $5vQ2T = parcelRequire("5vQ2T");

var $cxKOj = parcelRequire("cxKOj");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9OCJd = parcelRequire("9OCJd");

var $kAwwe = parcelRequire("kAwwe");


var $kumnd = parcelRequire("kumnd");
const $32819350c4ea4a7f$var$HrExpansionSpotlightWithDelay = ()=>{
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setShouldShowSpotlight(true);
        }, 2000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kumnd.HrExpansionSpotlightView), null);
};
const $32819350c4ea4a7f$var$ChoreographedCustomMessageComponent = (0, $5hQBi.withChoreographedRender)($32819350c4ea4a7f$var$HrExpansionSpotlightWithDelay);
const $32819350c4ea4a7f$var$ChoreographedHrSpotlight = ()=>{
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $9OCJd.usePageContext)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    (0, $eJOHy.useEffect)(()=>{
        if (isAdmin && (0, $cxKOj.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled') !== 'not-enrolled') (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'statsigExperiment exposed', 'jsm_hr_expansion', {
            cohort: (0, $cxKOj.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled'),
            projectId: projectId,
            projectType: projectType
        });
    }, [
        createAnalyticsEvent,
        isAdmin,
        projectId,
        projectType
    ]);
    return isAdmin && (0, $cxKOj.expValEquals)('jsm_hr_expansion', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32819350c4ea4a7f$var$ChoreographedCustomMessageComponent, {
        messageId: (0, $0833318c75cb3b6b$export$3508d9f7bec6727b)
    }) : null;
};
const $32819350c4ea4a7f$export$70aac9b19a402d6 = ()=>{
    const emptyFallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "jira-servicedesk-hr-expansion-experiment-spotlight",
        packageName: "jiraServicedeskHrExpansionExperiment",
        teamName: "jsd-getting-started",
        fallback: emptyFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32819350c4ea4a7f$var$ChoreographedHrSpotlight, null));
};

});
const $0833318c75cb3b6b$export$3508d9f7bec6727b = 'JsmHRExpansionExperimentSpotlight';

parcelRegister("kumnd", function(module, exports) {
$parcel$export(module.exports, "HrExpansionSpotlightView", () => $e54823edab7b75de$export$b94d2eaac7b145e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $guKVF = parcelRequire("guKVF");

var $eJ9f5 = parcelRequire("eJ9f5");

var $IW7jS = parcelRequire("IW7jS");

var $f4Iys = parcelRequire("f4Iys");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9pWNg = parcelRequire("9pWNg");

var $9cody = parcelRequire("9cody");

var $9OCJd = parcelRequire("9OCJd");

var $fbLtk = parcelRequire("fbLtk");

var $4cTDP = parcelRequire("4cTDP");

var $1yrGh = parcelRequire("1yrGh");


var $2uEy3 = parcelRequire("2uEy3");
const $e54823edab7b75de$export$b94d2eaac7b145e = ()=>{
    const [showSpotlight, setShowSpotlight] = (0, $eJOHy.useState)(true);
    const JSM_HR_EXPANSION_SPOTLIGHT_SEEN_STATUS_USER_PROPERTY_KEY = 'JsmHRExpansionExperimentSpotlightSeenStatus';
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $9cody.useSeenStatus)({
        userPropertyKey: JSM_HR_EXPANSION_SPOTLIGHT_SEEN_STATUS_USER_PROPERTY_KEY,
        isSeenValue: true,
        packageName: 'jsmHrExpansionExperiment',
        teamName: 'jsm-getting-started'
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $9OCJd.usePageContext)();
    const { methods: { open: openProjectCreate } } = (0, $9pWNg.useProjectCreateDrawer)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    const renderSpotlightCard = ()=>{
        const onDismissSpotlight = ()=>{
            setShowSpotlight(false);
            markSpotlightAsSeen();
        };
        const handleTryNow = ()=>{
            onDismissSpotlight();
            markSpotlightAsSeen();
            openProjectCreate({
                defaultSelectedTemplateKey: (0, $f4Iys.HR_SERVICE_PROJECT_TEAM_MANAGED_KEY)
            });
        };
        const handleLearnMore = ()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightLearnMore', {
                projectId: projectId,
                projectType: projectType
            });
        };
        const LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/service-management/hr';
        const renderNudge = ()=>{
            const SpotlightRef = (0, $fbLtk.createOnboardingSpotlight)({
                actions: [
                    {
                        onClick: ()=>{
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightDismiss', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissSpotlight();
                        },
                        content: formatMessage((0, $2uEy3.default).dismiss),
                        appearance: 'subtle'
                    },
                    {
                        onClick: ()=>{
                            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightActivate', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleTryNow();
                        },
                        content: formatMessage((0, $2uEy3.default).enable),
                        appearance: 'primary'
                    }
                ],
                contentMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $4cTDP.fg)('itsm-project-renaming') ? (0, $2uEy3.default).descriptionGalaxia : (0, $2uEy3.default).description, {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: LEARN_MORE_LINK,
                            target: "_blank",
                            onClick: handleLearnMore
                        }, chunks)
                })),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1yrGh))),
                    alt: "",
                    width: "320"
                }),
                headingMessage: formatMessage((0, $2uEy3.default).heading)
            });
            // eslint-disable-next-line react/no-unstable-nested-components
            return /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    ref: ref
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpotlightRef, null)));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e54823edab7b75de$var$ModalWrapperStyles, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
            sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
            sourceName: "JsmHrExpansionSpotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guKVF.NudgeSpotlight), {
            setHidden: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            hidden: !showSpotlight,
            spotlightCard: renderNudge(),
            position: "bottom-end",
            zIndex: (0, $IW7jS.layers).spotlight(),
            hideSpotlightCardOnOutsideClick: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
            attributes: {
                messageId: (0, $0833318c75cb3b6b$export$3508d9f7bec6727b),
                name: 'JsmHrExpansionSpotlight',
                projectId: projectId,
                projectType: projectType
            }
        })));
    };
    return showSpotlight && !hasSeenSpotlight ? renderSpotlightCard() : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e54823edab7b75de$var$ModalWrapperStyles = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _94n5xy5q _1xi2oahv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("guKVF", function(module, exports) {
$parcel$export(module.exports, "NudgeSpotlight", () => $ab2a22ecc5abafba$export$eebbda33f5d4d735);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $buco7 = parcelRequire("buco7");

var $67YQP = parcelRequire("67YQP");

var $8qmYl = parcelRequire("8qmYl");

var $4eDgu = parcelRequire("4eDgu");

var $1JTs3 = parcelRequire("1JTs3");

var $2S8TX = parcelRequire("2S8TX");

var $1Q3jn = parcelRequire("1Q3jn");
const $ab2a22ecc5abafba$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $ab2a22ecc5abafba$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $1JTs3.default), nudge: Nudge = (0, $buco7.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $eJOHy.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $eJOHy.useRef)(null);
    const spotlightCardRef = (0, $eJOHy.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $eJOHy.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $eJOHy.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $eJOHy.useState)(false);
    const stopBlink = (0, $eJOHy.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $eJOHy.useRef)({
        fn: ()=>{}
    });
    (0, $eJOHy.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $eJOHy.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $eJOHy.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $eJOHy.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $eJOHy.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $eJOHy.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $eJOHy.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $eJOHy.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $4eDgu.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $ab2a22ecc5abafba$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.(event);
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $eJOHy.useMemo)(()=>Spotlight === (0, $1JTs3.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2S8TX.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $gt9Am.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $ab2a22ecc5abafba$export$2e2bcd8739ae039 = $ab2a22ecc5abafba$export$eebbda33f5d4d735;

});
parcelRegister("buco7", function(module, exports) {
$parcel$export(module.exports, "DefaultNudge", () => $0c5a638aba06f9ee$export$b7d614104f4a4a7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3jO6v = parcelRequire("3jO6v");
const $0c5a638aba06f9ee$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3jO6v.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("3jO6v", function(module, exports) {
$parcel$export(module.exports, "NudgeTooltipPulse", () => $42bc5117e040ba32$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $eGOwo = parcelRequire("eGOwo");
function $42bc5117e040ba32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $42bc5117e040ba32$var$baseShadow = '0 0 0 3px';
const $42bc5117e040ba32$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $7bb4c1736002a04a$exports).P75})`;
const $42bc5117e040ba32$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $42bc5117e040ba32$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $42bc5117e040ba32$var$pulseAnimation = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $42bc5117e040ba32$var$easing,
    animationIterationCount: 'infinite'
});
const $42bc5117e040ba32$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $42bc5117e040ba32$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $1NIU8.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $42bc5117e040ba32$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$42bc5117e040ba32$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $42bc5117e040ba32$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$42bc5117e040ba32$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $42bc5117e040ba32$var$pulseAnimation
            ]
        }
    });
const $42bc5117e040ba32$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = 3, pulseColor: pulseColor = $42bc5117e040ba32$var$basePulseColor, pulseShadowColor: pulseShadowColor = $42bc5117e040ba32$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $1NIU8.jsx)(CastTargetContainer, {
        css: [
            $42bc5117e040ba32$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $eGOwo.fg)('jira_onboarding_experiences_a11y_fixes') && $42bc5117e040ba32$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $42bc5117e040ba32$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});
var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("1JTs3", function(module, exports) {
$parcel$export(module.exports, "default", () => $15ddc28f657a455a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");


var $1NIU8 = parcelRequire("1NIU8");
function $15ddc28f657a455a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $15ddc28f657a455a$var$borderRadius = 3;
const $15ddc28f657a455a$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`,
    borderRadius: `${$15ddc28f657a455a$var$borderRadius}px`,
    overflow: 'auto'
};
const $15ddc28f657a455a$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $15ddc28f657a455a$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $15ddc28f657a455a$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $15ddc28f657a455a$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $15ddc28f657a455a$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $1NIU8.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $7bb4c1736002a04a$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $7bb4c1736002a04a$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $7bb4c1736002a04a$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $7bb4c1736002a04a$export$a7175d4e9206bc80)})`
        }
    });
const $15ddc28f657a455a$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        css: $15ddc28f657a455a$var$actionItemStyles(index),
        ...rest
    });
const $15ddc28f657a455a$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $15ddc28f657a455a$export$b3ae98194e057550 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $eJOHy.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)($15ddc28f657a455a$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$15ddc28f657a455a$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$headerStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $15ddc28f657a455a$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $1NIU8.jsx)("span", null), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$actionItemContainerStyles
    }, renderedActions))));
});
var $15ddc28f657a455a$export$2e2bcd8739ae039 = $15ddc28f657a455a$export$b3ae98194e057550;

});

parcelRegister("2S8TX", function(module, exports) {
$parcel$export(module.exports, "SpotlightContainer", () => $34810c2406c4e27e$export$d0f55839b708c0a0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1aLTh = parcelRequire("1aLTh");

var $67YQP = parcelRequire("67YQP");
const $34810c2406c4e27e$export$474e8ee88cc7cd8f = 200;
const $34810c2406c4e27e$export$3d6f334bf7dc4597 = 120;
const $34810c2406c4e27e$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$34810c2406c4e27e$export$474e8ee88cc7cd8f}ms`
};
const $34810c2406c4e27e$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$34810c2406c4e27e$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $34810c2406c4e27e$var$timeoutDurations = {
    enter: 0,
    exit: $34810c2406c4e27e$export$3d6f334bf7dc4597
};
const $34810c2406c4e27e$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1aLTh.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $34810c2406c4e27e$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$34810c2406c4e27e$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$34810c2406c4e27e$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});


// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fbLtk", function(module, exports) {
$parcel$export(module.exports, "createOnboardingSpotlight", () => $2a8cccc88611f2d5$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1Q3jn = parcelRequire("1Q3jn");

var $abjs4 = parcelRequire("abjs4");
var $goZPP = parcelRequire("goZPP");

var $3l2IB = parcelRequire("3l2IB");

var $9ycBx = parcelRequire("9ycBx");

var $4cTDP = parcelRequire("4cTDP");
const $2a8cccc88611f2d5$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$Title, {
        id: "nudge-spot-light-card-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$CustomHeading, null, formattedMessage));
const $2a8cccc88611f2d5$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${"var(--ds-text-inverse, #FFFFFF)"}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $2a8cccc88611f2d5$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeAction, {
            key: index,
            ...action
        })));
const $2a8cccc88611f2d5$var$NudgeActionsNewAndImproved = ({ actions: actions, actionsBeforeElement: actionsBeforeElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$ActionsBeforeFooter, null, actionsBeforeElement || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$ActionWrapper, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeAction, {
            key: index,
            ...action
        }))));
const $2a8cccc88611f2d5$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $9ycBx.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $2a8cccc88611f2d5$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3l2IB.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            ...!(0, $4cTDP.fg)('jfind-spotlight-step-counter-refactor') ? {
                actionsBeforeElement: actionsBeforeElement
            } : {}
        }, contentMessage, (0, $4cTDP.fg)('jfind-spotlight-step-counter-refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeActionsNewAndImproved, {
            actions: actions,
            actionsBeforeElement: actionsBeforeElement
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeActions, {
            actions: actions
        }))));
};
const $2a8cccc88611f2d5$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $2a8cccc88611f2d5$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Q3jn.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8cccc88611f2d5$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_fkwn1bhr _tml11fxt _19yu1fxt",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$CustomHeading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$ActionsBeforeFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$ActionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1yrGh", function(module, exports) {
module.exports = new URL("spotlightImage.0949772a.png", import.meta.url).toString();

});

parcelRegister("2uEy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $00000c0634aad87b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $00000c0634aad87b$var$messages = (0, $7qGN1.defineMessages)({
    description: {
        "id": "service-management-hr-expansion-experiment-spotlight.description",
        "defaultMessage": "Set up your new project fast using the HR service management template, or <a>read about service management for HR.</a>"
    },
    descriptionGalaxia: {
        "id": "service-management-hr-expansion-experiment-spotlight.description-galaxia",
        "defaultMessage": "Set up your new space fast using the HR service management template, or <a>read about service management for HR.</a>"
    },
    heading: {
        "id": "service-management-hr-expansion-experiment-spotlight.heading",
        "defaultMessage": "Want to deliver better HR service experiences from day one?"
    },
    enable: {
        "id": "service-management-hr-expansion-experiment-spotlight.enable",
        "defaultMessage": "Try now"
    },
    dismiss: {
        "id": "service-management-hr-expansion-experiment-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    }
});
var $00000c0634aad87b$export$2e2bcd8739ae039 = $00000c0634aad87b$var$messages;

});



parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("6CNTI", function(module, exports) {
$parcel$export(module.exports, "generateUpdateTabStateFn", () => $5f8a8f8659c7fa0f$export$97f75f4989aac1cf);
const $5f8a8f8659c7fa0f$export$a76609f84fa5c664 = (state, tabName, updateFn)=>{
    state.update((currentData)=>{
        const currentTabData = currentData && currentData.tabs && currentData.tabs[tabName];
        const updatedData = updateFn(currentTabData);
        return {
            ...currentData,
            tabs: {
                ...currentData && currentData.tabs || null,
                [tabName]: updatedData
            }
        };
    });
};
const $5f8a8f8659c7fa0f$export$2205064ef28205c1 = async (fn)=>{
    const data = await fn();
    return ()=>data;
};
const $5f8a8f8659c7fa0f$export$97f75f4989aac1cf = (state, tabName, fetchData)=>async (updateDataFn)=>{
        const updateTabDataFn = updateDataFn || await $5f8a8f8659c7fa0f$export$2205064ef28205c1(()=>fetchData());
        $5f8a8f8659c7fa0f$export$a76609f84fa5c664(state, tabName, updateTabDataFn);
    };

});

parcelRegister("bSpEN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e0955b14e727826$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fdpHV = parcelRequire("fdpHV");

var $5rgxU = parcelRequire("5rgxU");


var $jUHqr = parcelRequire("jUHqr");

var $cZTMg = parcelRequire("cZTMg");

var $cH6Qf = parcelRequire("cH6Qf");

var $a73Mn = parcelRequire("a73Mn");
const $3e0955b14e727826$var$JiraHome = ({ prefetchResult: prefetchResult })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5rgxU.default), {
        prefetchResult: prefetchResult
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    }), !prefetchResult.loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        appName: "jira-home",
        isExpectedToHaveSsr: true,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $a73Mn.jiraHomePageLoad),
        emitOnAnimationFrame: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null)));
var $3e0955b14e727826$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('jiraHome', (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a))($3e0955b14e727826$var$JiraHome);

});
parcelRegister("5rgxU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d744b7e36c7b59e4$export$2e2bcd8739ae039);

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $04N8m = parcelRequire("04N8m");

var $1zAS0 = parcelRequire("1zAS0");
var $d744b7e36c7b59e4$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expVal)('jira-your-work-work-suggestions-tab-experiment', 'isEnabled', false), (0, $04N8m.JiraHomeWithWorkSuggestions), (0, $1zAS0.JiraHome));

});
parcelRegister("04N8m", function(module, exports) {
$parcel$export(module.exports, "JiraHomeWithWorkSuggestions", () => $31e6c8c1beb6b3cf$export$a9a9c1728b7e8425);

var $clsnW = parcelRequire("clsnW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $d129d = parcelRequire("d129d");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2imLM = parcelRequire("2imLM");

var $3So8J = parcelRequire("3So8J");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fYeTG = parcelRequire("fYeTG");

var $iWvkh = parcelRequire("iWvkh");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $jbJvT = parcelRequire("jbJvT");

var $hTtog = parcelRequire("hTtog");

var $80Ye8 = parcelRequire("80Ye8");

var $9FYIg = parcelRequire("9FYIg");

var $bXOg3 = parcelRequire("bXOg3");

var $fOowo = parcelRequire("fOowo");

var $iiD75 = parcelRequire("iiD75");

var $d5Xhr = parcelRequire("d5Xhr");

var $lsYYU = parcelRequire("lsYYU");

var $02Vwm = parcelRequire("02Vwm");

var $aSC67 = parcelRequire("aSC67");

var $bQ87J = parcelRequire("bQ87J");

var $lUeDZ = parcelRequire("lUeDZ");

var $eDNZI = parcelRequire("eDNZI");

var $1zAS0 = parcelRequire("1zAS0");
const $31e6c8c1beb6b3cf$var$onTabSelected = (0, $LFmXM.default)((setLastVisitedTab)=>(selectedTab)=>setLastVisitedTab(selectedTab));
const $31e6c8c1beb6b3cf$export$f3bf368f74496cef = ({ queryReference: queryReference, prefetchResult: prefetchResult })=>{
    const workSuggestionsQuery = (0, $j4oe4.usePreloadedQuery)((0, $clsnW.default), queryReference);
    const isMobileWebAndInMVPExperiment = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    const isWorkSuggestionsEnabled = workSuggestionsQuery?.workSuggestions?.userProfileByCloudId?.persona === 'DEVELOPER' && !isMobileWebAndInMVPExperiment;
    const intl = (0, $lRq8t.default)();
    const hasLoadedWorkSuggestions = (0, $eJOHy.useRef)(false);
    const { entryPointActions: entryPointWorkSuggestionsActions, entryPointReferenceSubject: entryPointWorkSuggestionsReferenceSubject } = (0, $iWvkh.useEntryPoint)((0, $hTtog.SoftwareWorkSuggestionsYourWorkEntryPoint), {});
    const loadWorkSuggestions = (0, $eJOHy.useCallback)(()=>{
        if (!hasLoadedWorkSuggestions.current) {
            entryPointWorkSuggestionsActions.load();
            hasLoadedWorkSuggestions.current = true;
        }
    }, [
        entryPointWorkSuggestionsActions
    ]);
    const tabConfigsToUse = (0, $eJOHy.useMemo)(()=>{
        if (isWorkSuggestionsEnabled) return [
            ...(0, $eDNZI.getTabConfigToUse)(),
            (0, $eDNZI.getWorkSuggestionsTab)(entryPointWorkSuggestionsReferenceSubject, loadWorkSuggestions)
        ];
        return (0, $eDNZI.getTabConfigToUse)();
    }, [
        isWorkSuggestionsEnabled,
        entryPointWorkSuggestionsReferenceSubject,
        loadWorkSuggestions
    ]);
    const intlTabConfigs = (0, $eJOHy.useMemo)(()=>tabConfigsToUse.map((tab)=>{
            const config = {
                ...tab,
                id: tab.id,
                // generate an intld label for the Atlaskit Tab Navigation component
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ dashboards: MessageDescriptorV2; projects: MessageDescriptorV2; experimentPreferenceChangeSuccessMessage: MessageDescriptorV2; ... 6 more ...; title: MessageDescriptorV2; }'.
                label: intl.formatMessage((0, $02Vwm.default)[tab.id])
            };
            return config;
        }), [
        intl,
        tabConfigsToUse
    ]);
    const slowRunOnce = (0, $eJOHy.useRef)(false);
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('uip_slow_test') && !slowRunOnce.current) {
        slowRunOnce.current = true;
        let timeNow = 0;
        let timeDelayForExperiment = 0;
        try {
            timeNow = performance.now();
            timeDelayForExperiment = (0, $cxKOj.expVal)('uip_slow_test_experiment', 'delay', 0);
        } catch (e) {
        // Silently fail, we have safe defaults above if we fail to get them
        }
        if (timeDelayForExperiment > 0 && timeDelayForExperiment < 1000) {
            /* eslint-disable-next-line no-empty */ while(performance.now() - timeNow <= timeDelayForExperiment);
        }
    }
    const RightPanelWrapper = isMobileWebAndInMVPExperiment ? (0, $eJOHy.Fragment) : (0, $bQ87J.RightPanelLayout);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jbJvT.RelayMigrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "jiraHome"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        id: "root",
        packageName: "jiraHome"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RightPanelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "global-pages.home.ui.home"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiD75.GlobalPagesDocumentTitle), {
        "data-testid": "global-pages.home.ui.global-pages-document-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $31e6c8c1beb6b3cf$var$PageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d129d.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lsYYU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOowo.LastVisitedTabProviderFF), {
        prefetchResult: prefetchResult
    }, ({ queriedTab: queriedTab, lastVisitedTab: lastVisitedTab, setLastVisitedTab: setLastVisitedTab })=>{
        let matchingConfigs = intlTabConfigs.filter((config)=>config.id === lastVisitedTab);
        switch(queriedTab){
            case 'starred':
                matchingConfigs = intlTabConfigs.filter((config)=>config.id === (0, $bXOg3.STARRED_TAB_KEY));
                break;
            case 'viewed':
                matchingConfigs = intlTabConfigs.filter((config)=>config.id === (0, $bXOg3.VIEWED_TAB_KEY));
                break;
            default:
                break;
        }
        if (matchingConfigs.length === 0 && prefetchResult.loading && !isMobileWebAndInMVPExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5Xhr.default), {
            tabConfigs: intlTabConfigs,
            deepDiveCards: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aSC67.default), {
                prefetchResult: undefined
            })
        });
        const selectedTab = matchingConfigs.length > 0 ? matchingConfigs[0] : intlTabConfigs[0];
        const lastVisitedTabIsWorkSuggestions = selectedTab.id === (0, $bXOg3.WORK_SUGGESTIONS_TAB_KEY);
        lastVisitedTabIsWorkSuggestions && loadWorkSuggestions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isMobileWebAndInMVPExperiment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aSC67.default), {
            // @ts-expect-error Type 'Partial<RouteResourceResponse<PrefetchResult>>' is not assignable to type 'RouteResourceResponse<PrefetchResult> | undefined'.
            prefetchResult: prefetchResult
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lUeDZ.TabContainerFF), {
            services: (0, $eDNZI.servicesNav4),
            // @ts-expect-error - TS2322 - Type 'Partial<RouteResourceResponse<PrefetchResult>>' is not assignable to type 'RouteResourceResponse<PrefetchResult>'.
            prefetchResult: prefetchResult,
            tabConfigs: intlTabConfigs,
            defaultSelected: selectedTab,
            onTabChange: $31e6c8c1beb6b3cf$var$onTabSelected(setLastVisitedTab)
        }));
    }))))))));
};
const $31e6c8c1beb6b3cf$export$a9a9c1728b7e8425 = (props)=>{
    const { queryReference: queryReference } = (0, $9FYIg.useRelayResource)((0, $80Ye8.jiraHomeWorkSuggestionsIsDeveloperResource));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "jira-home-with-work-suggestions",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1zAS0.JiraHome), props)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31e6c8c1beb6b3cf$export$f3bf368f74496cef, {
        queryReference: queryReference,
        ...props
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1zAS0.JiraHome), props));
};
const $31e6c8c1beb6b3cf$var$PageWrapperStyles = (0, $1DXK0.xcss)({
    minWidth: '329px',
    marginTop: 'space.075',
    marginRight: 'space.100',
    marginBottom: 'space.400',
    marginLeft: 'space.100'
});

});
parcelRegister("jbJvT", function(module, exports) {
$parcel$export(module.exports, "RelayMigrationProvider", () => $3019ed6ddc909986$export$234eaa9a198021f7);
$parcel$export(module.exports, "useQuery", () => $3019ed6ddc909986$export$dd0a697e1782aedd);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $aXKmr = parcelRequire("aXKmr");

var $YuFtg = parcelRequire("YuFtg");

var $bLDxK = parcelRequire("bLDxK");

var $3BhN4 = parcelRequire("3BhN4");

var $3a9iP = parcelRequire("3a9iP");
const $3019ed6ddc909986$var$QueryRenderer = ({ id: id })=>{
    const [queryConfig] = (0, $3BhN4.useGetQueryById)(id);
    if (queryConfig === undefined) throw new Error(`Query config not found for id=${id}`);
    const { skip: skip } = queryConfig;
    if (skip) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3a9iP.Suspense), {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $YuFtg.ErrorBoundary), {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bLDxK.Query), {
        id: id
    })));
};
const $3019ed6ddc909986$var$Queries = ()=>{
    const [queries] = (0, $3BhN4.useGetQueries)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, queries.map(({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3019ed6ddc909986$var$QueryRenderer, {
            key: id,
            id: id
        })));
};
// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
const $3019ed6ddc909986$var$RelayMigrationContext = /*#__PURE__*/ (0, $eJOHy.createContext)();
const $3019ed6ddc909986$export$234eaa9a198021f7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3BhN4.QueriesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3019ed6ddc909986$var$RelayMigrationContext.Provider, {
        value: true
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3019ed6ddc909986$var$Queries, null)));
const $3019ed6ddc909986$export$dd0a697e1782aedd = (query, options = {})=>{
    // Note: It's not safe to default variables to `{}`, as that doesn't
    // necessary match the variables type expected by the query
    const { skip: skip = false, variables: variables = {}, fetchPolicy: fetchPolicy } = options; // TODO: add support for errorPolicy, etc
    const isProviderInitialized = (0, $eJOHy.useContext)($3019ed6ddc909986$var$RelayMigrationContext);
    if (isProviderInitialized !== true) throw new Error(`Look like you forgot to wrap package root component with

            import { RelayMigrationProvider } from './index.tsx';

            <RelayMigrationProvider>
                <MyApp>
            </RelayMigrationProvider>`);
    const env = (0, $j4oe4.useRelayEnvironment)();
    const id = (0, $eJOHy.useRef)(`query-key-${(0, $aXKmr.v4)()}`).current;
    const [queryConfig, { registerOrUpdateQuery: registerOrUpdateQuery, removeQuery: removeQuery, forceCacheRecheck: forceCacheRecheck }] = (0, $3BhN4.useGetQueryById)(id);
    const prevProps = (0, $eJOHy.useRef)();
    const refetch = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'newVariables' implicitly has an 'any' type.
    (newVariables)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const vars = newVariables || variables;
        // @ts-expect-error - TS2344 - Type 'Variables' is missing the following properties from type 'OperationType': variables, response
        const promise = (0, $j4oe4.fetchQuery)(env, query, vars, {
            fetchPolicy: 'network-only'
        }).toPromise();
        forceCacheRecheck({
            query: query,
            variables: vars
        });
        return promise;
    }, [
        env,
        query,
        variables,
        forceCacheRecheck
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // deepEqual check in case object reference changed but key/values are the same.
        // For example: variables
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevProps.current, {
            skip: skip,
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy
        })) return;
        prevProps.current = {
            skip: skip,
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy
        };
        registerOrUpdateQuery({
            id: id,
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            skip: skip
        });
    }, [
        id,
        registerOrUpdateQuery,
        removeQuery,
        skip,
        query,
        variables,
        fetchPolicy
    ]);
    // cleap up query after useQuery unmount
    // @ts-expect-error - TS2322 - Type '() => void | Promise<void>' is not assignable to type 'void | Destructor'.
    (0, $eJOHy.useEffect)(()=>()=>removeQuery(id), [
        removeQuery,
        id
    ]);
    const result = queryConfig ? {
        ...queryConfig.result,
        refetch: refetch
    } : {
        loading: true,
        data: null,
        error: undefined,
        refetch: ()=>Promise.resolve()
    };
    // @ts-expect-error - TS2322 - Type '{ refetch: (newVariables: any) => Promise<TVariables["response"] | undefined>; data: unknown; error: Error | undefined; loading: boolean; } | { loading: boolean; data: null; error: undefined; refetch: () => Promise<...>; }' is not assignable to type 'QueryResult<TVariables, TData>'.
    return result;
};

});
parcelRegister("YuFtg", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $e7565c3c4a5df08c$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $3BhN4 = parcelRequire("3BhN4");
class $e7565c3c4a5df08c$var$RelayMigrationUtilsErrorBoundary extends (0, $eJOHy.Component) {
    componentDidUpdate(prevProps) {
        const { variables: variables, fetchKey: fetchKey } = this.props;
        const { variables: prevVariables, fetchKey: prevFetchKey } = prevProps;
        // reset error state and give a chance query to recover after variables/fetchKey change
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables, prevVariables) || fetchKey !== prevFetchKey) this.setState({
            error: undefined
        });
    }
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        this.props.onError(error);
    }
    render() {
        const { error: error } = this.state;
        if (error) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
const $e7565c3c4a5df08c$export$e926676385687eaf = ({ id: id, children: children })=>{
    const [queryConfig, { setQueryError: setQueryError }] = (0, $3BhN4.useGetQueryById)(id);
    // this case is not possible, this check is here just to make flow happy
    if (!queryConfig) throw new Error(`Query config not found for id=${id}`);
    const { variables: variables, fetchKey: fetchKey } = queryConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e7565c3c4a5df08c$var$RelayMigrationUtilsErrorBoundary, {
        variables: variables,
        fetchKey: fetchKey,
        onError: (error)=>setQueryError(id, error)
    }, children);
};

});
parcelRegister("3BhN4", function(module, exports) {
$parcel$export(module.exports, "useGetQueries", () => $d156153cd9b50089$export$d6811137951eda62);
$parcel$export(module.exports, "useGetQueryById", () => $d156153cd9b50089$export$6d96567132090f48);
$parcel$export(module.exports, "QueriesContainer", () => $d156153cd9b50089$export$ecb4f76d577c3dc5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $j8ggK = parcelRequire("j8ggK");
const $d156153cd9b50089$var$storeId = 'RELAY_APOLLO_MIGRATION_STORE';
const $d156153cd9b50089$var$initialState = {
    queries: []
};
// @ts-expect-error - TS2322 - Type 'Store<{ readonly queries: readonly []; }, Record<string, ActionThunk<{ readonly queries: readonly []; }, { readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; ... 4 more ...; readonly forceCacheRecheck: ForceCacheRecheckAction; }>>>' is not assignable to type 'Store<State, Actions>'.
const $d156153cd9b50089$var$QueriesStore = (0, $GtRbT.createStore)({
    name: $d156153cd9b50089$var$storeId,
    initialState: $d156153cd9b50089$var$initialState,
    actions: // @ts-expect-error - TS2322 - Type '{ readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; readonly setQueryLoading: SetQueryLoadingAction; readonly setQueryError: SetQueryErrorAction; readonly removeQuery: RemoveQueryAction; readonly updateQuery: UpdateQueryAction; readonly forceCacheRecheck: ForceCa...' is not assignable to type 'Record<string, ActionThunk<{ readonly queries: readonly []; }, { readonly registerOrUpdateQuery: RegisterOrUpdateQueryAction; readonly setQueryData: SetQueryDataAction; ... 4 more ...; readonly forceCacheRecheck: ForceCacheRecheckAction; }>>'.
    $j8ggK.actions
});
const $d156153cd9b50089$export$d6811137951eda62 = (0, $iJq0l.createHook)($d156153cd9b50089$var$QueriesStore, {
    selector: (state)=>state.queries
});
const $d156153cd9b50089$export$6d96567132090f48 = (0, $iJq0l.createHook)($d156153cd9b50089$var$QueriesStore, {
    selector: (state, id)=>state.queries.find((q)=>q.id === id)
});
const $d156153cd9b50089$export$ecb4f76d577c3dc5 = (0, $6E16M.createContainer)($d156153cd9b50089$var$QueriesStore);

});
parcelRegister("j8ggK", function(module, exports) {
$parcel$export(module.exports, "actions", () => $7be3a2b7db89f956$export$e324594224ef24da);

var $cSmYj = parcelRequire("cSmYj");

var $aXKmr = parcelRequire("aXKmr");
const $7be3a2b7db89f956$export$4c8508db433a86f5 = (config)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const existingQueryConfig = state.queries.find((q)=>q.id === config.id);
        if (existingQueryConfig) setState({
            queries: state.queries.map((q)=>{
                if (q.id === config.id) return {
                    ...q,
                    ...config
                };
                return q;
            })
        });
        else setState({
            queries: state.queries.concat({
                ...config,
                fetchKey: config.id,
                result: {
                    data: null,
                    error: undefined,
                    loading: true
                }
            })
        });
    };
const $7be3a2b7db89f956$export$f58ce67e5a1edf5 = (id, data)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    result: {
                        loading: false,
                        error: undefined,
                        data: data
                    }
                } : item)
        });
    };
const $7be3a2b7db89f956$export$636198fd10e804fd = (id)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    result: {
                        loading: true,
                        error: undefined,
                        data: null
                    }
                } : item)
        });
    };
const $7be3a2b7db89f956$export$71ca895ec712e8ca = (id, error)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    result: {
                        loading: false,
                        error: error,
                        data: null
                    }
                } : item)
        });
    };
const $7be3a2b7db89f956$export$d9584b9a625da95f = (id)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.filter((item)=>item.id !== id)
        });
    };
const $7be3a2b7db89f956$var$updateQuery = (id, props)=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.id === id ? {
                    ...item,
                    ...props
                } : item)
        });
    };
const $7be3a2b7db89f956$var$forceCacheRecheck = ({ query: query, variables: variables })=>({ getState: getState, setState: setState })=>{
        const { queries: queries } = getState();
        setState({
            queries: queries.map((item)=>item.query === query && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(item.variables, variables) ? {
                    ...item,
                    fetchKey: `query-key-${(0, $aXKmr.v4)()}`
                } : item)
        });
    };
const $7be3a2b7db89f956$export$e324594224ef24da = {
    registerOrUpdateQuery: $7be3a2b7db89f956$export$4c8508db433a86f5,
    setQueryData: $7be3a2b7db89f956$export$f58ce67e5a1edf5,
    setQueryLoading: $7be3a2b7db89f956$export$636198fd10e804fd,
    setQueryError: $7be3a2b7db89f956$export$71ca895ec712e8ca,
    removeQuery: $7be3a2b7db89f956$export$d9584b9a625da95f,
    updateQuery: $7be3a2b7db89f956$var$updateQuery,
    forceCacheRecheck: $7be3a2b7db89f956$var$forceCacheRecheck
};

});



parcelRegister("bLDxK", function(module, exports) {
$parcel$export(module.exports, "Query", () => $c41e70b8cd703a86$export$62297b13309008b2);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3BhN4 = parcelRequire("3BhN4");
const $c41e70b8cd703a86$export$62297b13309008b2 = ({ id: id })=>{
    const [queryConfig, { setQueryData: setQueryData }] = (0, $3BhN4.useGetQueryById)(id);
    if (queryConfig === undefined) throw new Error(`Query config not found for id=${id}`);
    const { query: query, variables: variables, fetchKey: fetchKey, fetchPolicy: fetchPolicy } = queryConfig;
    /* eslint-disable @atlassian/relay/generated-typescript-types */ const data = (0, $j4oe4.useLazyLoadQuery)(query, variables, {
        fetchKey: fetchKey,
        fetchPolicy: fetchPolicy
    });
    /* eslint-enable @atlassian/relay/generated-typescript-types */ (0, $eJOHy.useEffect)(()=>{
        setQueryData(id, data);
    }, [
        id,
        data,
        setQueryData
    ]);
    return null;
};

});

parcelRegister("3a9iP", function(module, exports) {
$parcel$export(module.exports, "Suspense", () => $cc0753c62a629436$export$74bf444e3cd11ea5);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $3BhN4 = parcelRequire("3BhN4");
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
const $cc0753c62a629436$var$PlaceholderFallback = ({ id: id })=>{
    const [, { setQueryLoading: setQueryLoading }] = (0, $3BhN4.useGetQueryById)(id);
    (0, $eJOHy.useEffect)(()=>{
        setQueryLoading(id);
    }, [
        id,
        setQueryLoading
    ]);
    return null;
};
const $cc0753c62a629436$export$74bf444e3cd11ea5 = ({ id: id, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "query-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc0753c62a629436$var$PlaceholderFallback, {
            id: id
        })
    }, children);

});


parcelRegister("hTtog", function(module, exports) {
$parcel$export(module.exports, "SoftwareWorkSuggestionsYourWorkEntryPoint", () => $2c27d41e6ba43024$export$a91cdcd74a59654c);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $2c27d41e6ba43024$export$a91cdcd74a59654c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lDrit")).then((module)=>module.SoftwareWorkSuggestionsYourWork), {
        moduleId: "29a0083b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lDrit", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bP5jz").then(()=>parcelRequire('ls2V5'));

});


parcelRegister("fOowo", function(module, exports) {
$parcel$export(module.exports, "fetchData", () => $9f8e9b28cffe222b$export$8134c072fddab6a5);
$parcel$export(module.exports, "LastVisitedTabProviderFF", () => $9f8e9b28cffe222b$export$1815c41d05777cb8);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $koAZ4 = parcelRequire("koAZ4");

var $gCY1z = parcelRequire("gCY1z");

var $bXOg3 = parcelRequire("bXOg3");
const $9f8e9b28cffe222b$export$18693c2b0e277020 = 'jira.home.last-visited-tab';
const $9f8e9b28cffe222b$export$8134c072fddab6a5 = async (accountId)=>{
    try {
        const result = await (0, $FppkK.getUserProperty)(accountId, $9f8e9b28cffe222b$export$18693c2b0e277020);
        return result;
    } catch  {
        return 0, $bXOg3.WORKEDON_TAB_KEY;
    }
};
const $9f8e9b28cffe222b$var$getQueriedTab = (query)=>{
    if (Object.keys(query).includes('starred')) return 'starred';
    if (Object.keys(query).includes('viewed')) return 'viewed';
    return undefined;
};
const $9f8e9b28cffe222b$export$1815c41d05777cb8 = ({ prefetchResult: prefetchResult, children: children })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $koAZ4.useTenantContext)();
    const [{ route: route, query: query }, { replaceTo: replaceTo }] = (0, $gCY1z.useRouter)();
    const [queriedTab, setQueriedTab] = (0, $eJOHy.useState)($9f8e9b28cffe222b$var$getQueriedTab(query));
    const lastVisitedTab = prefetchResult.data ? prefetchResult.data.lastVisitedTab : undefined;
    const setLastVisitedTab = (0, $eJOHy.useCallback)((tabName)=>{
        if (tabName !== (0, $bXOg3.STARRED_TAB_KEY)) replaceTo(route, {
            query: {}
        });
        prefetchResult && prefetchResult.data && prefetchResult.data.updateLastVisitedTab && prefetchResult.data.updateLastVisitedTab(tabName);
        if (!atlassianAccountId) return Promise.resolve();
        return (0, $FppkK.setUserProperties)(atlassianAccountId, $9f8e9b28cffe222b$export$18693c2b0e277020, JSON.stringify(tabName));
    }, [
        atlassianAccountId,
        prefetchResult,
        replaceTo,
        route
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setQueriedTab($9f8e9b28cffe222b$var$getQueriedTab(query));
    }, [
        query
    ]);
    return children({
        queriedTab: queriedTab,
        lastVisitedTab: lastVisitedTab,
        setLastVisitedTab: setLastVisitedTab
    });
};
const $9f8e9b28cffe222b$var$LastVisitedTabProvider = ({ prefetchResult: prefetchResult, children: children })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $koAZ4.useTenantContext)();
    const lastVisitedTab = prefetchResult.data ? prefetchResult.data.lastVisitedTab : undefined;
    const setLastVisitedTab = (0, $eJOHy.useCallback)((tabName)=>{
        prefetchResult && prefetchResult.data && prefetchResult.data.updateLastVisitedTab && prefetchResult.data.updateLastVisitedTab(tabName);
        if (!atlassianAccountId) return Promise.resolve();
        return (0, $FppkK.setUserProperties)(atlassianAccountId, $9f8e9b28cffe222b$export$18693c2b0e277020, JSON.stringify(tabName));
    }, [
        atlassianAccountId,
        prefetchResult
    ]);
    return children({
        lastVisitedTab: lastVisitedTab,
        setLastVisitedTab: setLastVisitedTab
    });
};
var $9f8e9b28cffe222b$export$2e2bcd8739ae039 = $9f8e9b28cffe222b$var$LastVisitedTabProvider;

});

parcelRegister("iiD75", function(module, exports) {
$parcel$export(module.exports, "GlobalPagesDocumentTitle", () => $f668621f1dc2452a$export$4dac9a8c7deb6216);

var $eJOHy = parcelRequire("eJOHy");

var $3nL89 = parcelRequire("3nL89");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $dQLI1 = parcelRequire("dQLI1");
const $f668621f1dc2452a$export$4dac9a8c7deb6216 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: (0, $4cTDP.fg)('blu-7514_update_jira_home_your_work_to_for_you') ? formatMessage((0, $dQLI1.default).pageTitleForYou) : formatMessage((0, $dQLI1.default).pageTitleYourWork)
    });
};

});
parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

parcelRegister("dQLI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $42b36699b376685e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $42b36699b376685e$var$messages = (0, $7qGN1.defineMessages)({
    pageTitle: {
        "id": "home.document-title.page-title",
        "defaultMessage": "For you - {appTitle}"
    },
    pageTitleForYou: {
        "id": "home.document-title.page-title-for-you",
        "defaultMessage": "For you"
    },
    pageTitleYourWork: {
        "id": "home.document-title.page-title-your-work",
        "defaultMessage": "Your work"
    }
});
var $42b36699b376685e$export$2e2bcd8739ae039 = $42b36699b376685e$var$messages;

});


parcelRegister("d5Xhr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cd0bf6ccbf1486e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5gjY4 = parcelRequire("5gjY4");
const $1cd0bf6ccbf1486e$var$FullSkeleton = ({ tabConfigs: tabConfigs, deepDiveCards: deepDiveCards })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd0bf6ccbf1486e$var$TabWrapper, null, deepDiveCards, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1cd0bf6ccbf1486e$var$navigationWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd0bf6ccbf1486e$var$Navigation, null, tabConfigs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd0bf6ccbf1486e$var$NavItem, {
            key: tab.id
        }, "\xa0\xa0\xa0\xa0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1cd0bf6ccbf1486e$var$NavLine, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gjY4.YourWorkItemListSkeleton), null));
var $1cd0bf6ccbf1486e$export$2e2bcd8739ae039 = $1cd0bf6ccbf1486e$var$FullSkeleton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cd0bf6ccbf1486e$var$TabWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $1cd0bf6ccbf1486e$var$navigationWrapperStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.negative.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cd0bf6ccbf1486e$var$Navigation = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _1e0c1txw _k48p1wq8 _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $1cd0bf6ccbf1486e$var$NavLine = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkmuej _94n5idpf _1sb2b3bt _4t3iyh40 _1ltvu2gc _kqswstnw _1xi2u2gc _1bsb1kw7",
            __cmplp.className
        ])
    });
});
const $1cd0bf6ccbf1486e$var$NavItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko12b0 _11c82smr _bfhkip91 _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _ca0qidpf _n3tdidpf _19bvu2gc _u5f3u2gc _1bsb1kei",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lsYYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $27aef56d5adc082c$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $eJOHy = parcelRequire("eJOHy");

var $gHI4w = parcelRequire("gHI4w");

var $lRq8t = parcelRequire("lRq8t");

var $4D17a = parcelRequire("4D17a");

var $koAZ4 = parcelRequire("koAZ4");

var $jvrKU = parcelRequire("jvrKU");
const $27aef56d5adc082c$var$Header = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { atlassianAccountId: accountId } = (0, $koAZ4.useTenantContext)();
    if (!accountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4D17a.IssueCreateHomePageTrigger), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        truncateTitle: true
    }, formatMessage((0, $jvrKU.default).forYouTitle)));
};
var $27aef56d5adc082c$export$2e2bcd8739ae039 = $27aef56d5adc082c$var$Header;

});
parcelRegister("4D17a", function(module, exports) {
$parcel$export(module.exports, "IssueCreateHomePageTrigger", () => $05ac9765e00b33b8$export$aaa9ad4038546623);

var $eJOHy = parcelRequire("eJOHy");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $95O7y = parcelRequire("95O7y");
const $05ac9765e00b33b8$var$OPEN_GLOBAL_ISSUE_CREATE = 'createissue';
const $05ac9765e00b33b8$var$GIC_TRIGGER_SOURCE = 'gicTriggerSource';
const $05ac9765e00b33b8$var$UNIVERSAL_CREATE_HOME_SOURCE_VALUE = 'ucAtlassianHomeCreateIssue';
const $05ac9765e00b33b8$export$aaa9ad4038546623 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const createIssueRef = (0, $eJOHy.useRef)(true);
    const [openGlobalIssueCreate, _setopenGlobalIssueCreate] = (0, $95O7y.useQueryParam)($05ac9765e00b33b8$var$OPEN_GLOBAL_ISSUE_CREATE);
    const [gicTriggerSource] = (0, $95O7y.useQueryParam)($05ac9765e00b33b8$var$GIC_TRIGGER_SOURCE);
    (0, $eJOHy.useEffect)(()=>{
        if (createIssueRef.current && openGlobalIssueCreate === 'true') {
            const isFromUniversalCreateHome = gicTriggerSource === $05ac9765e00b33b8$var$UNIVERSAL_CREATE_HOME_SOURCE_VALUE;
            const triggerPointKey = isFromUniversalCreateHome ? (0, $84DOT.UC_ATLASSIAN_HOME_CREATE_ISSUE) : (0, $84DOT.HOME_PAGE_DEFAULT_OPEN_GIC);
            openIssueCreateModal({
                triggerPointKey: triggerPointKey
            });
        }
        createIssueRef.current = false;
    }, [
        openIssueCreateModal,
        openGlobalIssueCreate,
        gicTriggerSource
    ]);
    return null;
};
var $05ac9765e00b33b8$export$2e2bcd8739ae039 = $05ac9765e00b33b8$export$aaa9ad4038546623;

});

parcelRegister("jvrKU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e89b027e1d342a7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6e89b027e1d342a7$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "home.header.title",
        "defaultMessage": "Your work"
    },
    forYouTitle: {
        "id": "home.header.forYou",
        "defaultMessage": "For you"
    }
});
var $6e89b027e1d342a7$export$2e2bcd8739ae039 = $6e89b027e1d342a7$var$messages;

});


parcelRegister("02Vwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b0b1ca7323a5e7f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4b0b1ca7323a5e7f$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "home.title",
        "defaultMessage": "Your work"
    },
    quotedTitle: {
        "id": "home.quoted-title",
        "defaultMessage": "\u2018Your work\u2019"
    },
    workedon: {
        "id": "home.workedon",
        "defaultMessage": "Worked on"
    },
    viewed: {
        "id": "home.viewed",
        "defaultMessage": "Viewed"
    },
    assigned: {
        "id": "home.assigned",
        "defaultMessage": "Assigned to me"
    },
    starred: {
        "id": "home.starred",
        "defaultMessage": "Starred"
    },
    boards: {
        "id": "home.boards",
        "defaultMessage": "Boards"
    },
    workSuggestions: {
        "id": "home.work-suggestions",
        "defaultMessage": "Work suggestions"
    },
    experimentSettingsChangeFailFeedback: {
        "id": "home.experiment-settings-change-fail-feedback",
        "defaultMessage": "Something went wrong saving your preference"
    },
    experimentPreferenceChangeSuccessMessage: {
        "id": "home.experiment-preference-change-success-message",
        "defaultMessage": "{destinationPage} is now your default homepage."
    },
    projects: {
        "id": "home.projects",
        "defaultMessage": "Projects"
    },
    dashboards: {
        "id": "home.dashboards",
        "defaultMessage": "Dashboards"
    }
});
var $4b0b1ca7323a5e7f$export$2e2bcd8739ae039 = $4b0b1ca7323a5e7f$var$messages;

});

parcelRegister("aSC67", function(module, exports) {
$parcel$export(module.exports, "default", () => $66804db60e289c7c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $37Shs = parcelRequire("37Shs");

var $l1nnk = parcelRequire("l1nnk");

var $qzoYE = parcelRequire("qzoYE");

var $6PAED = parcelRequire("6PAED");

var $cHtIB = parcelRequire("cHtIB");

var $cxKOj = parcelRequire("cxKOj");

var $8OZBC = parcelRequire("8OZBC");

var $2nbRu = parcelRequire("2nbRu");
const $66804db60e289c7c$var$StableRecentProjects = ({ prefetchResult: prefetchResult })=>{
    const [stablePrefectResult, setStablePrefectResult] = (0, $eJOHy.useState)(prefetchResult);
    const { recentProjects: recentProjects, recent2QueuesByRecentProjects: recent2QueuesByRecentProjects } = (0, $eJOHy.useMemo)(()=>{
        const recent = (0, $2nbRu.getRecentProjects)(stablePrefectResult);
        const recent2Queues = (0, $2nbRu.getRecent2QueuesByRecentProjects)(stablePrefectResult, recent);
        return {
            recentProjects: recent,
            recent2QueuesByRecentProjects: recent2Queues
        };
    }, [
        stablePrefectResult
    ]);
    const cloudId = (0, $cHtIB.useCloudId)();
    const applicationPermissions = (0, $6PAED.useApplicationPermissions)();
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        if (// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        !stablePrefectResult || !stablePrefectResult.data || !stablePrefectResult.data.tabs || !stablePrefectResult.data.tabs.RecentlyViewed || !stablePrefectResult.data.tabs.RecentlyViewed.data || !stablePrefectResult.data.tabs.RecentlyViewed.data.sections || stablePrefectResult.data.tabs.RecentlyViewed.data.sections.length === 0) // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setStablePrefectResult(prefetchResult);
    }, [
        prefetchResult,
        stablePrefectResult
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $qzoYE.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8OZBC.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $37Shs.DeepDiveCardProvider), {
        recentProjects: recentProjects,
        recent2QueuesByRecentProjects: recent2QueuesByRecentProjects,
        isLoading: stablePrefectResult ? stablePrefectResult.loading : true,
        recommendedProjectsData: (0, $cxKOj.expValEquals)('recommended_projects_for_you_page', 'cohort', 'test', 'control') ? prefetchResult?.data?.recommendedProjectsData : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l1nnk.DeepDiveCardsSection), null)));
};
var $66804db60e289c7c$export$2e2bcd8739ae039 = $66804db60e289c7c$var$StableRecentProjects;

});
parcelRegister("37Shs", function(module, exports) {
$parcel$export(module.exports, "DeepDiveCardProvider", () => $8de4170dad0095bb$export$7f8816b3b37698d5);

var $eJOHy = parcelRequire("eJOHy");

var $f2JN3 = parcelRequire("f2JN3");

var $cxKOj = parcelRequire("cxKOj");

var $hl7hT = parcelRequire("hl7hT");
const $8de4170dad0095bb$var$isEqual = (prev, next)=>prev.recentProjects === next.recentProjects && prev.recent2QueuesByRecentProjects === next.recent2QueuesByRecentProjects && prev.isLoading === next.isLoading;
const $8de4170dad0095bb$var$DeepDiveCardProviderCurrent = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hl7hT.DeepDiveCardProvider), props), $8de4170dad0095bb$var$isEqual);
const $8de4170dad0095bb$var$isEqualExp = (prev, next)=>prev.recentProjects === next.recentProjects && prev.recent2QueuesByRecentProjects === next.recent2QueuesByRecentProjects && prev.isLoading === next.isLoading && prev.recommendedProjectsData === next.recommendedProjectsData;
const $8de4170dad0095bb$var$DeepDiveCardProviderExp = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hl7hT.DeepDiveCardProvider), props), $8de4170dad0095bb$var$isEqualExp);
const $8de4170dad0095bb$export$7f8816b3b37698d5 = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expValEquals)('recommended_projects_for_you_page', 'cohort', 'test', 'control'), $8de4170dad0095bb$var$DeepDiveCardProviderExp, $8de4170dad0095bb$var$DeepDiveCardProviderCurrent);

});
parcelRegister("hl7hT", function(module, exports) {
$parcel$export(module.exports, "DeepDiveCardProvider", () => $afd716c9c07c1570$export$7f8816b3b37698d5);
$parcel$export(module.exports, "useDeepDiveCardContext", () => $afd716c9c07c1570$export$b4cff14669e21cfe);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $fWdEN = parcelRequire("fWdEN");

var $9zU7V = parcelRequire("9zU7V");

var $5CXDx = parcelRequire("5CXDx");

var $aw6cb = parcelRequire("aw6cb");

var $hbjwU = parcelRequire("hbjwU");

var $52OZb = parcelRequire("52OZb");

var $7Yxhk = parcelRequire("7Yxhk");
const $afd716c9c07c1570$var$DeepDiveCardContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isloadingProjects: true,
    sectionTitle: '',
    data: [],
    recommendedProjectsData: undefined
});
const $afd716c9c07c1570$export$7f8816b3b37698d5 = ({ recentProjects: recentProjects, recent2QueuesByRecentProjects: recent2QueuesByRecentProjects, children: children, isLoading: isLoading, recommendedProjectsData: recommendedProjectsData })=>{
    const sectionTitleGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fWdEN.messages).sectionTitleGalaxia : (0, $fWdEN.messages).sectionTitle;
    const intl = (0, $lRq8t.default)();
    const softwareAndCoreFilters = (0, $5CXDx.default)(recentProjects, [
        (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT),
        (0, $FhXEJ.SOFTWARE_PROJECT),
        (0, $FhXEJ.CORE_PROJECT)
    ]);
    const softwareBoards = (0, $7Yxhk.default)(recentProjects);
    const productDiscoveryViews = (0, $aw6cb.default)(recentProjects);
    const serviceDeskBoardsAndFilters = (0, $52OZb.default)(recentProjects, recent2QueuesByRecentProjects);
    const projectColors = (0, $hbjwU.useFetchProjectColor)(recentProjects);
    // Build props per supported project type
    const supportedProjects = recentProjects.filter(({ projectType: projectType })=>[
            (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT),
            (0, $FhXEJ.SOFTWARE_PROJECT),
            (0, $FhXEJ.CORE_PROJECT),
            (0, $FhXEJ.SERVICE_DESK_PROJECT),
            (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT)
        ].includes(projectType));
    const data = supportedProjects.map((projectBase)=>{
        const project = {
            ...projectBase,
            barColor: projectColors[projectBase.key]
        };
        if (project.projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || project.projectType === (0, $FhXEJ.CORE_PROJECT)) return {
            project: project,
            boards: project.projectType === (0, $FhXEJ.SOFTWARE_PROJECT) ? {
                loading: softwareBoards.data && softwareBoards.data[`${project.id}`] && softwareBoards.data[`${project.id}`].loading,
                error: softwareBoards.data && softwareBoards.data[`${project.id}`] && softwareBoards.data[`${project.id}`].error,
                data: softwareBoards.data && softwareBoards.data[`${project.id}`]
            } : {
                data: (0, $9zU7V.getCoreProjectDefaultBoard)(project, intl)
            },
            filters: {
                loading: softwareAndCoreFilters.loading,
                error: softwareAndCoreFilters.error,
                data: softwareAndCoreFilters.data && softwareAndCoreFilters.data[project.key]
            }
        };
        if (project.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return {
            project: project,
            boards: {
                loading: productDiscoveryViews.data && productDiscoveryViews.data[`${project.id}`] && productDiscoveryViews.data[`${project.id}`].loading,
                error: productDiscoveryViews.data && productDiscoveryViews.data[`${project.id}`] && productDiscoveryViews.data[`${project.id}`].error,
                data: productDiscoveryViews.data && productDiscoveryViews.data[`${project.id}`]
            },
            filters: {
                loading: softwareAndCoreFilters.loading,
                error: softwareAndCoreFilters.error,
                data: softwareAndCoreFilters.data && softwareAndCoreFilters.data[project.key]
            }
        };
        if (project.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || project.projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT)) return {
            project: project,
            boards: {
                loading: serviceDeskBoardsAndFilters && serviceDeskBoardsAndFilters[project.key] && serviceDeskBoardsAndFilters[project.key].loading,
                error: serviceDeskBoardsAndFilters && serviceDeskBoardsAndFilters[project.key] && serviceDeskBoardsAndFilters[project.key].error,
                data: serviceDeskBoardsAndFilters && serviceDeskBoardsAndFilters[project.key] && serviceDeskBoardsAndFilters[project.key].boards
            },
            filters: {
                loading: serviceDeskBoardsAndFilters && serviceDeskBoardsAndFilters[project.key] && serviceDeskBoardsAndFilters[project.key].loading,
                error: serviceDeskBoardsAndFilters && serviceDeskBoardsAndFilters[project.key] && serviceDeskBoardsAndFilters[project.key].error,
                data: serviceDeskBoardsAndFilters && serviceDeskBoardsAndFilters[project.key] && serviceDeskBoardsAndFilters[project.key].filters
            }
        };
        throw new Error('Unreachable.');
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afd716c9c07c1570$var$DeepDiveCardContext.Provider, {
        value: {
            isloadingProjects: isLoading,
            sectionTitle: intl.formatMessage(sectionTitleGalaxia),
            data: // @ts-expect-error - TS2322 - Type '{ project: { barColor: string; projectName: string; projectType: ProjectType; avatarUrl: string; href: string; id: number; key: string; isSimplified: boolean; }; boards: { loading: boolean | undefined; error: boolean | undefined; data: DeepDiveItem | undefined; } | { ...; }; filters: { ...; }; }[]' is not assignable to type 'Props[]'.
            data,
            recommendedProjectsData: recommendedProjectsData
        }
    }, children);
};
const $afd716c9c07c1570$export$b4cff14669e21cfe = ()=>(0, $eJOHy.useContext)($afd716c9c07c1570$var$DeepDiveCardContext);

});
parcelRegister("fWdEN", function(module, exports) {
$parcel$export(module.exports, "messages", () => $78db37763b8ac42d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $78db37763b8ac42d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    sectionTitle: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.section-title",
        "defaultMessage": "Recent projects"
    },
    queuesHeading: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.queues-heading",
        "defaultMessage": "Queues in the project"
    },
    boardsHeading: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.boards-heading",
        "defaultMessage": "Boards in the project"
    },
    assignedToMe: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.assigned-to-me",
        "defaultMessage": "My open issues"
    },
    assignedToMeIdeas: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.assigned-to-me-ideas",
        "defaultMessage": "My ideas"
    },
    doneIssues: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.done-issues",
        "defaultMessage": "Done issues"
    },
    coreBoardTitle: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.core-board-title",
        "defaultMessage": "Board"
    },
    assignedToMeIssueTermRefresh: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.assigned-to-me-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    doneIssuesIssueTermRefresh: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    },
    sectionTitleGalaxia: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.section-title-galaxia",
        "defaultMessage": "Recent spaces"
    },
    queuesHeadingGalaxia: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.queues-heading-galaxia",
        "defaultMessage": "Queues in the space"
    },
    boardsHeadingGalaxia: {
        "id": "deep-dive-cards-section.services.deep-dive-provider.boards-heading-galaxia",
        "defaultMessage": "Boards in the space"
    }
});

});

parcelRegister("9zU7V", function(module, exports) {
$parcel$export(module.exports, "getCoreProjectDefaultBoard", () => $b1f286d1c86f0311$export$8033e9570dec065e);

var $cxKOj = parcelRequire("cxKOj");

var $fWdEN = parcelRequire("fWdEN");
const $b1f286d1c86f0311$export$8033e9570dec065e = (project, intl)=>{
    const boardsHeadingGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fWdEN.messages).boardsHeadingGalaxia : (0, $fWdEN.messages).boardsHeading;
    return {
        heading: intl.formatMessage(boardsHeadingGalaxia),
        items: [
            {
                content: intl.formatMessage((0, $fWdEN.messages).coreBoardTitle),
                href: `/projects/${project.key}/board`,
                type: 'core'
            }
        ]
    };
};

});

parcelRegister("5CXDx", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ff2c7a0a912e0cb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $9pTd3 = parcelRequire("9pTd3");

var $cxKOj = parcelRequire("cxKOj");

var $hgi0g = parcelRequire("hgi0g");

var $lRq8t = parcelRequire("lRq8t");

var $fWdEN = parcelRequire("fWdEN");
const $2ff2c7a0a912e0cb$var$getAssignedToMeJQL = (projectKey)=>`assignee = currentUser() AND project='${projectKey}' AND statusCategory != 3`;
const $2ff2c7a0a912e0cb$var$getDoneIssuesJQL = (projectKey)=>`project='${projectKey}' AND statusCategory = Done`;
const $2ff2c7a0a912e0cb$var$getReportedByMeJQL = (projectKey)=>`reporter = currentUser() AND project='${projectKey}' AND statusCategory != 3`;
const $2ff2c7a0a912e0cb$var$getMyIssuesProjectFragment = (projectKey, type)=>type === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT) ? `${projectKey}_reported: issues(jql:"${$2ff2c7a0a912e0cb$var$getReportedByMeJQL(projectKey)}",first:1) {
           totalCount
         }` : `${projectKey}_assigned: issues(jql:"${$2ff2c7a0a912e0cb$var$getAssignedToMeJQL(projectKey)}",first:1) {
           totalCount
         }`;
const $2ff2c7a0a912e0cb$var$getProjectFragment = (projectKey, type)=>`${$2ff2c7a0a912e0cb$var$getMyIssuesProjectFragment(projectKey, type)}`;
const $2ff2c7a0a912e0cb$export$5db520940cf00715 = 'getDoneAndAssignedToMeIssuesByProjectsForDeepDiveCards';
const $2ff2c7a0a912e0cb$export$def8f24ba3f5929f = (projects)=>`query ${$2ff2c7a0a912e0cb$export$5db520940cf00715} {
            ${projects.map(({ key: key, projectType: projectType })=>$2ff2c7a0a912e0cb$var$getProjectFragment(key, projectType)).join()}
        }`;
const $2ff2c7a0a912e0cb$var$getGlobalIssueNavigatorUrl = (jql)=>{
    return `/issues/?jql=${encodeURIComponent(jql)}`;
};
const $2ff2c7a0a912e0cb$var$fetchMyAssignedIssuesInProjects = (projects)=>{
    if (projects.length > 0) {
        const graphqlQuery = $2ff2c7a0a912e0cb$export$def8f24ba3f5929f(projects);
        const queryUrl = '/rest/gira/latest/?deep-dive-assignedIssueCount=1';
        return (0, $hgi0g.default)(queryUrl, {
            method: 'POST',
            body: JSON.stringify({
                operationName: $2ff2c7a0a912e0cb$export$5db520940cf00715,
                query: graphqlQuery
            })
        });
    }
    return Promise.resolve(null);
};
const $2ff2c7a0a912e0cb$export$8f3be984e0afefa = (project, assigned, done, reported)=>({
        [project.key]: [
            ...assigned ? [
                {
                    content: assigned.message,
                    href: $2ff2c7a0a912e0cb$var$getGlobalIssueNavigatorUrl($2ff2c7a0a912e0cb$var$getAssignedToMeJQL(project.key)),
                    itemCount: assigned.count,
                    isLoading: assigned.loading,
                    error: assigned.error
                }
            ] : [],
            ...done ? [
                {
                    content: done.message,
                    href: $2ff2c7a0a912e0cb$var$getGlobalIssueNavigatorUrl($2ff2c7a0a912e0cb$var$getDoneIssuesJQL(project.key)),
                    itemCount: done.count,
                    isLoading: done.loading,
                    error: done.error
                }
            ] : [],
            ...reported ? [
                {
                    content: reported.message,
                    href: $2ff2c7a0a912e0cb$var$getGlobalIssueNavigatorUrl($2ff2c7a0a912e0cb$var$getReportedByMeJQL(project.key)),
                    itemCount: reported.count,
                    isLoading: reported.loading,
                    error: reported.error
                }
            ] : []
        ]
    });
const $2ff2c7a0a912e0cb$var$useFetchAssignedIssuesCountPerProject = (recentProjects, supportedProjects = [
    (0, $FhXEJ.SOFTWARE_PROJECT),
    (0, $FhXEJ.CORE_PROJECT)
])=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [results, setResults] = (0, $eJOHy.useState)({
        loading: false,
        error: false
    });
    (0, $eJOHy.useEffect)(()=>{
        let didCancel = false;
        (async ()=>{
            const softwareProjects = recentProjects.filter((project)=>supportedProjects.includes(project.projectType));
            const buildDeepDiveInfoItems = (fetchResult)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                softwareProjects.reduce((acc, project)=>{
                    if (project.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) {
                        const reported = fetchResult && fetchResult.data[`${project.key}_reported`];
                        return {
                            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                            ...acc,
                            ...$2ff2c7a0a912e0cb$export$8f3be984e0afefa(project, undefined, undefined, {
                                count: reported ? reported.totalCount : -1,
                                error: !reported,
                                loading: false,
                                message: formatMessage((0, $fWdEN.messages).assignedToMeIdeas)
                            })
                        };
                    }
                    const assigned = fetchResult && fetchResult.data[`${project.key}_assigned`];
                    return {
                        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                        ...acc,
                        ...$2ff2c7a0a912e0cb$export$8f3be984e0afefa(project, {
                            count: assigned ? assigned.totalCount : -1,
                            error: !assigned,
                            loading: false,
                            message: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fWdEN.messages).assignedToMeIssueTermRefresh : (0, $fWdEN.messages).assignedToMe)
                        }, {
                            count: -1,
                            error: false,
                            loading: false,
                            message: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fWdEN.messages).doneIssuesIssueTermRefresh : (0, $fWdEN.messages).doneIssues)
                        })
                    };
                }, {});
            try {
                setResults({
                    loading: false,
                    error: false,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    data: softwareProjects.reduce((acc, project)=>{
                        let projectDeepDiveInfo;
                        if (project.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) projectDeepDiveInfo = $2ff2c7a0a912e0cb$export$8f3be984e0afefa(project, undefined, undefined, {
                            count: -1,
                            error: false,
                            loading: true,
                            message: formatMessage((0, $fWdEN.messages).assignedToMeIdeas)
                        });
                        else projectDeepDiveInfo = $2ff2c7a0a912e0cb$export$8f3be984e0afefa(project, {
                            count: -1,
                            error: false,
                            loading: true,
                            message: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fWdEN.messages).assignedToMeIssueTermRefresh : (0, $fWdEN.messages).assignedToMe)
                        }, {
                            count: -1,
                            error: false,
                            loading: false,
                            message: formatMessage((0, $cxKOj.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fWdEN.messages).doneIssuesIssueTermRefresh : (0, $fWdEN.messages).doneIssues)
                        });
                        return {
                            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                            ...acc,
                            ...projectDeepDiveInfo
                        };
                    }, {})
                });
                const fetchResult = await $2ff2c7a0a912e0cb$var$fetchMyAssignedIssuesInProjects(softwareProjects);
                if (fetchResult && fetchResult.data) !didCancel && setResults({
                    loading: false,
                    error: false,
                    data: buildDeepDiveInfoItems(fetchResult)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (fetchError) {
                (0, $9pTd3.trackFetchErrors)({
                    error: fetchError,
                    id: 'fetchAssignedIssueCountPerProject',
                    packageName: 'deepDiveCards'
                });
                !didCancel && setResults({
                    loading: false,
                    error: true,
                    data: buildDeepDiveInfoItems()
                });
            }
        })();
        return ()=>{
            didCancel = true;
        };
    // Disabling lint rule to help avoid extra api calls due to changing recentProject object references between re-renders
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage,
        JSON.stringify(recentProjects)
    ]);
    return results;
};
var $2ff2c7a0a912e0cb$export$2e2bcd8739ae039 = $2ff2c7a0a912e0cb$var$useFetchAssignedIssuesCountPerProject;

});

parcelRegister("aw6cb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff98deec5bb54c32$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $80xRm = parcelRequire("80xRm");

var $FhXEJ = parcelRequire("FhXEJ");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");

var $koAZ4 = parcelRequire("koAZ4");

var $4hgsM = parcelRequire("4hgsM");
const $ff98deec5bb54c32$export$5db520940cf00715 = 'jira_polaris_getDeepDiveProductDiscoveryViews';
const $ff98deec5bb54c32$export$fa43aca9146b337b = `
query ${$ff98deec5bb54c32$export$5db520940cf00715}($ari: ID!) {
  polarisProject(id: $ari, skipRefresh: true) {
    key
    viewsets {
      ...ViewSet
      viewsets {
        ...ViewSet
      }
    }
  }
}

fragment ViewSet on PolarisViewSet {
  type
  name
  rank
  views {
    id
    rank
    name
    xid
  }
}
`;
const $ff98deec5bb54c32$var$fetchProductDiscoveryViews = (cloudid, id)=>{
    const queryUrl = '/gateway/api/graphql';
    const ari = (0, $4hgsM.createProjectAri)(cloudid, id.toString());
    return (0, $hgi0g.default)(queryUrl, {
        method: 'POST',
        body: JSON.stringify({
            operationName: $ff98deec5bb54c32$export$5db520940cf00715,
            query: $ff98deec5bb54c32$export$fa43aca9146b337b,
            variables: {
                ari: ari
            }
        }),
        headers: {
            'X-ExperimentalApi': 'polaris-v0'
        }
    });
};
const $ff98deec5bb54c32$var$initialViewsState = (productDiscoveryProjects)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    productDiscoveryProjects.forEach(({ id: projectId })=>{
        result[projectId] = {
            loading: true,
            error: false
        };
    });
    return result;
};
const $ff98deec5bb54c32$export$8437ee0439878fce = (polarisProject)=>{
    const { key: key, viewsets: viewsets = [] } = polarisProject;
    const priorityViewSet = viewsets?.find(({ type: type })=>type === 'PRIORITIZE');
    if (priorityViewSet) {
        const flattenedViewsAndViewSets = [
            ...priorityViewSet.views ?? [],
            ...priorityViewSet.viewsets ?? []
        ];
        const topLevelViewsSorted = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(flattenedViewsAndViewSets, (viewOrViewSet)=>viewOrViewSet.rank);
        return topLevelViewsSorted.map((viewOrViewSet)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (viewOrViewSet.type !== undefined) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const viewSet = viewOrViewSet;
                const viewsInfo = viewSet?.views?.map(({ name: name, xid: xid })=>({
                        type: 'productDiscoveryView',
                        content: name,
                        href: (0, $4hgsM.getViewUrl)(key, xid)
                    })) ?? [];
                return {
                    type: 'productDiscoveryView',
                    content: viewSet.name,
                    href: (0, $4hgsM.getProductDiscoveryProjectUrl)(key),
                    children: viewsInfo
                };
            }
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const view = viewOrViewSet;
            return {
                type: 'productDiscoveryView',
                content: view.name,
                href: (0, $4hgsM.getViewUrl)(key, view.xid)
            };
        });
    }
    return [];
};
const $ff98deec5bb54c32$var$useFetchProductDiscoveryViews = (recentProjects)=>{
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const productDiscoveryProjects = (0, $eJOHy.useMemo)(()=>recentProjects.filter((project)=>project.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(recentProjects)
    ]);
    const [results, setResults] = (0, $eJOHy.useState)({
        data: $ff98deec5bb54c32$var$initialViewsState(productDiscoveryProjects)
    });
    (0, $eJOHy.useEffect)(()=>{
        let didCancel = false;
        setResults({
            data: $ff98deec5bb54c32$var$initialViewsState(productDiscoveryProjects)
        });
        (async ()=>{
            await Promise.all(productDiscoveryProjects.map(async ({ id: projectId })=>{
                try {
                    const { data: viewData } = await $ff98deec5bb54c32$var$fetchProductDiscoveryViews(cloudId, projectId);
                    !didCancel && setResults(({ data: data })=>({
                            data: {
                                ...data,
                                [projectId]: {
                                    items: viewData.polarisProject ? $ff98deec5bb54c32$export$8437ee0439878fce(viewData.polarisProject) : [],
                                    loading: false,
                                    error: false
                                }
                            }
                        }));
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (fetchError) {
                    (0, $9pTd3.trackFetchErrors)({
                        error: fetchError,
                        id: 'fetchProductDiscoveryViews',
                        packageName: 'deepDiveCards'
                    });
                    !didCancel && setResults(({ data: data })=>({
                            data: {
                                ...data,
                                [projectId]: {
                                    loading: false,
                                    error: true
                                }
                            }
                        }));
                }
            }));
        })();
        return ()=>{
            didCancel = true;
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId,
        JSON.stringify(recentProjects)
    ]);
    return results;
};
var $ff98deec5bb54c32$export$2e2bcd8739ae039 = $ff98deec5bb54c32$var$useFetchProductDiscoveryViews;

});
parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});
parcelRegister("4ppQ2", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $5BbSa = parcelRequire("5BbSa");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $1QISL = parcelRequire("1QISL");

var $cUaWv = parcelRequire("cUaWv");

var $6c1m2 = parcelRequire("6c1m2");

var $d7YnM = parcelRequire("d7YnM");

var $4sprp = parcelRequire("4sprp");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $335d8a321b94e157$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $lylkU(iteratees, function(iteratee) {
        if ($4sprp(iteratee)) return function(value) {
            return $5BbSa(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d7YnM
    ];
    var index = -1;
    iteratees = $lylkU(iteratees, $cUaWv($1lM9j));
    var result = $k0Eii(collection, function(value, key, collection) {
        var criteria = $lylkU(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $1QISL(result, function(object, other) {
        return $6c1m2(object, other, orders);
    });
}
module.exports = $335d8a321b94e157$var$baseOrderBy;

});
parcelRegister("1QISL", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $158d7678f0c45464$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $158d7678f0c45464$var$baseSortBy;

});

parcelRegister("6c1m2", function(module, exports) {

var $boN2o = parcelRequire("boN2o");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4824ea093db12906$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $boN2o(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $4824ea093db12906$var$compareMultiple;

});
parcelRegister("boN2o", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $84c7f970dc532949$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9D78T(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9D78T(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $84c7f970dc532949$var$compareAscending;

});




parcelRegister("4hgsM", function(module, exports) {
$parcel$export(module.exports, "getBoardUrl", () => $3055de046d1d09d2$export$505a9f131607d070);
$parcel$export(module.exports, "getProductDiscoveryProjectUrl", () => $3055de046d1d09d2$export$b9d6e9362d24c80f);
$parcel$export(module.exports, "getViewUrl", () => $3055de046d1d09d2$export$bdccd6a672e4a607);
$parcel$export(module.exports, "createProjectAri", () => $3055de046d1d09d2$export$e12cf9774899f456);

var $8oKDI = parcelRequire("8oKDI");
const $3055de046d1d09d2$export$505a9f131607d070 = (projectKey, boardId, boardType)=>`/jira/software/${boardType === 'simple' ? '' : 'c/'}projects/${projectKey}/boards/${boardId}`;
const $3055de046d1d09d2$export$b9d6e9362d24c80f = (projectKey)=>`/jira/polaris/projects/${projectKey}/ideas`;
const $3055de046d1d09d2$export$bdccd6a672e4a607 = (projectKey, viewSlug)=>`${$3055de046d1d09d2$export$b9d6e9362d24c80f(projectKey)}/view/${viewSlug}`;
const $3055de046d1d09d2$export$e12cf9774899f456 = (cloudId, projectId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: projectId
    });

});


parcelRegister("hbjwU", function(module, exports) {
$parcel$export(module.exports, "useFetchProjectColor", () => $f79e4b625d06fb37$export$a146b958957364e8);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $hgi0g = parcelRequire("hgi0g");
const $f79e4b625d06fb37$var$mappings = {
    'project_avatar_alien.svg': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'project_avatar_cloud.svg': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    'project_avatar_code.svg': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'project_avatar_coffee.svg': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'project_avatar_design.svg': "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    'project_avatar_disc.svg': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'project_avatar_drill.svg': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    'project_avatar_food.svg': "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    'project_avatar_koala.svg': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    'project_avatar_mobile.svg': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    'project_avatar_money.svg': "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    'project_avatar_nature.svg': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    'project_avatar_notes.svg': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'project_avatar_flag.svg': "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    'project_avatar_parrot.svg': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    'project_avatar_plane.svg': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'project_avatar_power.svg': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'project_avatar_refresh.svg': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    'project_avatar_rocket.svg': "var(--ds-background-neutral, #091E420F)",
    'project_avatar_science.svg': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    'project_avatar_settings.svg': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'project_avatar_spanner.svg': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'project_avatar_storm.svg': "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    'project_avatar_support.svg': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'project_avatar_website.svg': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'project_avatar_yeti.svg': "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    default: "var(--ds-background-neutral, #091E420F)"
};
const $f79e4b625d06fb37$export$a146b958957364e8 = (data)=>{
    const [colorMapping, setColorMapping] = (0, $eJOHy.useState)({});
    const requestURI = (0, $eJOHy.useMemo)(()=>{
        const queryParams = data.map(({ key: projectKey })=>`project=${projectKey}`).join('&');
        return `/rest/internal/2/projectAvatarNames?${queryParams}`;
    }, [
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (async ()=>{
            try {
                const response = await (0, $hgi0g.default)(requestURI);
                if (!response || !Object.keys(response).length) setColorMapping({});
                setColorMapping(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                Object.keys(response).reduce((acc, key)=>({
                        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                        ...acc,
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'project_avatar_alien.svg': "var(--ds-background-accent-teal-subtler)"; readonly 'project_avatar_cloud.svg': "var(--ds-background-accent-blue-subtler)"; readonly 'project_avatar_code.svg': "var(--ds-background-accent-red-subtler)"; ... 23 more ...; readonly default: "var(--ds-background-neutral)"; }'.
                        [key]: $f79e4b625d06fb37$var$mappings[response[key]]
                    }), {}));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (fetchError) {
                (0, $9pTd3.trackFetchErrors)({
                    error: fetchError,
                    id: 'fetchProjectColor',
                    packageName: 'deepDiveCards'
                });
            }
        })();
    }, [
        requestURI
    ]);
    return colorMapping;
};

});

parcelRegister("52OZb", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ac19f18447cde63$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $9pTd3 = parcelRequire("9pTd3");

var $cxKOj = parcelRequire("cxKOj");

var $hgi0g = parcelRequire("hgi0g");

var $lRq8t = parcelRequire("lRq8t");

var $5SwkH = parcelRequire("5SwkH");

var $2QZBX = parcelRequire("2QZBX");

var $4cTDP = parcelRequire("4cTDP");

var $fWdEN = parcelRequire("fWdEN");
const $7ac19f18447cde63$var$fetchServiceDeskQueues = (projectKey)=>(0, $hgi0g.default)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/categories?deep-dive-sdNav=1`);
const $7ac19f18447cde63$var$fetchServiceDeskQueuesCount = (projectKey, queueId)=>(0, $hgi0g.default)(`/rest/servicedeskapi/servicedesk/${projectKey}/queue/${queueId}?includeCount=true&deep-dive-sdNav=1`);
const $7ac19f18447cde63$var$MAX_SHOWN_QUEUES = 2;
const $7ac19f18447cde63$export$1590e6d5b25891b4 = 'no-category';
const $7ac19f18447cde63$var$calculateAdditionalQueuesNeeded = (max, current)=>max - Math.min(max, current);
const $7ac19f18447cde63$var$padRecentQueues = (recentQueues, padding)=>{
    const queues = recentQueues || [];
    const numPaddingNeeded = $7ac19f18447cde63$var$calculateAdditionalQueuesNeeded($7ac19f18447cde63$var$MAX_SHOWN_QUEUES, queues.length);
    return [
        ...queues.slice(0, $7ac19f18447cde63$var$MAX_SHOWN_QUEUES).map((queue)=>({
                id: queue.id.toString(),
                content: queue.title || '',
                href: queue.href || '',
                isLoading: true,
                itemCount: -1
            })),
        ...padding.slice(0, numPaddingNeeded)
    ];
};
const $7ac19f18447cde63$var$getInitialBoardState = (serviceProjects, recentQueues)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    serviceProjects.reduce((acc, { id: projectId, key: key })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [key]: {
                loading: true,
                error: false,
                filters: $7ac19f18447cde63$var$padRecentQueues(recentQueues[`project_${projectId}`], new Array($7ac19f18447cde63$var$MAX_SHOWN_QUEUES).fill(0).map(()=>({
                        id: '',
                        content: '',
                        href: '',
                        isLoading: true,
                        itemCount: -1
                    })))
            }
        }), {});
const $7ac19f18447cde63$var$updateBoardsFilterIssueCount = (board, filterId, issueCount, isLoading, error)=>{
    if (!board) return {};
    const { filters: filters, ...rest } = board;
    const newFilters = filters && filters.map((filter)=>{
        const newFilter = {
            ...filter
        };
        if (newFilter.id === filterId) {
            newFilter.itemCount = issueCount;
            newFilter.isLoading = isLoading;
            newFilter.error = error;
        }
        return newFilter;
    }) || [];
    return {
        ...rest,
        filters: newFilters
    };
};
const $7ac19f18447cde63$var$getQueuesFromCategory = ({ categories: categories }, categoryKey)=>categories.find((category)=>category.key === categoryKey)?.queues || [];
const $7ac19f18447cde63$var$useFetchQueues = (recentProjects, recentQueues)=>{
    const queuesHeadingGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fWdEN.messages).queuesHeadingGalaxia : (0, $fWdEN.messages).queuesHeading;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const serviceProjects = (0, $eJOHy.useMemo)(()=>recentProjects.filter((project)=>project.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || project.projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('csm_rename_jcs_to_csm')), [
        recentProjects
    ]);
    const [results, setResults] = (0, $eJOHy.useState)($7ac19f18447cde63$var$getInitialBoardState(serviceProjects, recentQueues));
    const heading = formatMessage(queuesHeadingGalaxia);
    (0, $eJOHy.useEffect)(()=>{
        if (!serviceProjects) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        let didCancel = false;
        // Set initial data
        setResults($7ac19f18447cde63$var$getInitialBoardState(serviceProjects, recentQueues));
        // Fetch the count for a recent queue
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'key' implicitly has an 'any' type.
        const handleFetchingQueueCount = async ({ id: id, key: key })=>{
            try {
                const { issueCount: issueCount } = await $7ac19f18447cde63$var$fetchServiceDeskQueuesCount(key, id);
                !didCancel && setResults((resultsState)=>{
                    const board = resultsState && resultsState[key];
                    const newBoard = $7ac19f18447cde63$var$updateBoardsFilterIssueCount(board, id, issueCount, false, false);
                    return {
                        ...resultsState,
                        [key]: newBoard
                    };
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (fetchError) {
                (0, $9pTd3.trackFetchErrors)({
                    error: fetchError,
                    id: 'fetchQueueCount',
                    packageName: 'deepDiveCards'
                });
                !didCancel && setResults((resultsState)=>{
                    const board = resultsState && resultsState[key];
                    const newBoard = $7ac19f18447cde63$var$updateBoardsFilterIssueCount(board, id, -1, false, true);
                    return {
                        ...resultsState,
                        [key]: {
                            ...newBoard
                        }
                    };
                });
            }
        };
        // Fetch the queues for a service desk project
        const handleFetchingServiceDeskQueues = async ({ id: projectId, key: key })=>{
            try {
                const queuesByCategory = await $7ac19f18447cde63$var$fetchServiceDeskQueues(key);
                const queuesForDropdown = $7ac19f18447cde63$var$getQueuesFromCategory(queuesByCategory, $7ac19f18447cde63$export$1590e6d5b25891b4);
                // Recent queues provided by caller of deep-dive-card (recent2QueuesByRecentProjects prop)
                const recentProjectQueues = recentQueues[`project_${projectId}`] || [];
                const recentQueueItems = recentProjectQueues.map(({ id: id, title: title, href: href })=>({
                        id: id.toString(),
                        title: title,
                        key: key,
                        href: href
                    }));
                const numAdditionalFiltersNeeded = $7ac19f18447cde63$var$calculateAdditionalQueuesNeeded($7ac19f18447cde63$var$MAX_SHOWN_QUEUES, recentQueueItems.length);
                // extra queues fetched from 'no-category'
                const extraFilters = queuesForDropdown.filter(({ id: id })=>!recentQueueItems.find((recentFilter)=>recentFilter.id === id.toString())).map(({ id: id, name: name })=>({
                        id: id.toString(),
                        title: name,
                        key: key,
                        href: (0, $5SwkH.getQueueUrl)({
                            projectKey: (0, $2QZBX.toProjectKey)(key),
                            category: $7ac19f18447cde63$export$1590e6d5b25891b4,
                            queueId: Number(id)
                        })
                    })).slice(0, numAdditionalFiltersNeeded);
                const filtersItems = [
                    ...recentQueueItems,
                    ...extraFilters
                ];
                const filters = filtersItems.map(({ id: id, title: title, href: href })=>({
                        id: id,
                        content: title,
                        href: href,
                        isLoading: true,
                        itemCount: -1
                    }));
                const boardItems = queuesForDropdown.map(({ id: id, name: name })=>({
                        content: name,
                        href: (0, $5SwkH.getQueueUrl)({
                            projectKey: (0, $2QZBX.toProjectKey)(key),
                            category: $7ac19f18447cde63$export$1590e6d5b25891b4,
                            queueId: Number(id)
                        }),
                        type: 'serviceDesk'
                    }));
                !didCancel && // @ts-expect-error - TS2345 - Argument of type '(resultsState: BoardAndFilterResults) => { [x: string]: BoardsAndFilter | { loading: false; error: false; boards: { heading: string; items: { content: string; href: string; type: string; }[]; }; filters: { ...; }[]; }; }' is not assignable to parameter of type 'SetStateAction<BoardAndFilterResults>'.
                setResults((resultsState)=>({
                        ...resultsState,
                        [key]: {
                            loading: false,
                            error: false,
                            boards: {
                                heading: heading,
                                items: boardItems
                            },
                            filters: filters
                        }
                    }));
                await Promise.all(filtersItems.map(handleFetchingQueueCount));
            // Fetch queue count
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (fetchError) {
                (0, $9pTd3.trackFetchErrors)({
                    error: fetchError,
                    id: 'fetchServiceDeskQueues',
                    packageName: 'deepDiveCards'
                });
                !didCancel && setResults((resultsState)=>({
                        ...resultsState,
                        [key]: {
                            loading: false,
                            error: true
                        }
                    }));
            }
        };
        // Load Data
        (async ()=>{
            // Load list of queues
            await Promise.all(serviceProjects.map(handleFetchingServiceDeskQueues));
        })();
        return ()=>{
            didCancel = true;
        };
    // Disabling rule to use JSON.stringify to ensure that the nav items
    // are fetched only when project keys are added/removed/reordered
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heading,
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(recentQueues),
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(serviceProjects.map((p)=>p.key))
    ]);
    return results;
};
var $7ac19f18447cde63$export$2e2bcd8739ae039 = $7ac19f18447cde63$var$useFetchQueues;

});
parcelRegister("5SwkH", function(module, exports) {
$parcel$export(module.exports, "QUEUE_ROUTES", () => $f69cc1f14172fd66$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $f69cc1f14172fd66$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $f69cc1f14172fd66$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $f69cc1f14172fd66$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $f69cc1f14172fd66$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $f69cc1f14172fd66$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $f69cc1f14172fd66$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $f69cc1f14172fd66$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $f69cc1f14172fd66$export$91152835d12ca65f);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("cBiei");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $1Ncmp = parcelRequire("1Ncmp");

var $jlJsl = parcelRequire("jlJsl");

var $3TivI = parcelRequire("3TivI");
const $f69cc1f14172fd66$var$LOCATION = 'servicedesk.common.navigation.queues';
let $f69cc1f14172fd66$var$navigatorPromise;
const $f69cc1f14172fd66$var$getPushStateNavigator = ()=>{
    if (!$f69cc1f14172fd66$var$navigatorPromise) $f69cc1f14172fd66$var$navigatorPromise = (0, $3TivI.createPushStateNavigator)();
    return $f69cc1f14172fd66$var$navigatorPromise;
};
const $f69cc1f14172fd66$export$410a6306dae101ca = {
    [(0, $jlJsl.INCIDENTS)]: 'section/incidents',
    [(0, $jlJsl.CHANGES)]: 'section/changes',
    [(0, $jlJsl.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $jlJsl.PROBLEMS)]: 'section/problems',
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $jlJsl.NO_CATEGORY)]: 'queues'
};
const $f69cc1f14172fd66$var$fromCategory = (category)=>$f69cc1f14172fd66$export$410a6306dae101ca[category || (0, $jlJsl.NO_CATEGORY)];
const $f69cc1f14172fd66$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $1Ncmp.emitSignal)($f69cc1f14172fd66$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $7kixv.Observable).fromPromise($f69cc1f14172fd66$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $7kixv.Observable).empty();
    }).catch(()=>(0, $7kixv.Observable).empty());
};
const $f69cc1f14172fd66$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $f69cc1f14172fd66$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $f69cc1f14172fd66$export$86f6a6d69e87f843 = (queueId, category)=>`${$f69cc1f14172fd66$export$954f428fa284c7(queueId, category)}/edit`;
const $f69cc1f14172fd66$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $f69cc1f14172fd66$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $f69cc1f14172fd66$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$f69cc1f14172fd66$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $f69cc1f14172fd66$export$a796bfaff67c9fae = (issueKey)=>`${$f69cc1f14172fd66$export$954f428fa284c7()}/issue/${issueKey}`;
const $f69cc1f14172fd66$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$f69cc1f14172fd66$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $f69cc1f14172fd66$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$f69cc1f14172fd66$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("1Ncmp", function(module, exports) {
$parcel$export(module.exports, "emitSignal", () => $c1b2870b87d5d674$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Playwright tests.
 *
 * This acts as a bridge between the storybook application and playwright for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $c1b2870b87d5d674$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c1b2870b87d5d674$var$registerSignal = (signal, meta)=>{
    window.playwrightSignals.allSignals.push(signal);
    const signalsByName = window.playwrightSignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $c1b2870b87d5d674$var$initPlaywrightSignals = ()=>{
    window.playwrightSignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $c1b2870b87d5d674$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($c1b2870b87d5d674$var$isProduction()) return;
    if (!window.playwrightSignals) $c1b2870b87d5d674$var$initPlaywrightSignals();
    $c1b2870b87d5d674$var$registerSignal(signal, meta);
};

});

parcelRegister("3TivI", function(module, exports) {
$parcel$export(module.exports, "createPushStateNavigator", () => $27fedfefc1b80d24$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
const $27fedfefc1b80d24$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $27fedfefc1b80d24$var$REQUIRE_TIMEOUT = 100;
const $27fedfefc1b80d24$var$REQUIRE_RETRIES = 5;
const $27fedfefc1b80d24$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $gjeS9.loadBridge)({
        name: $27fedfefc1b80d24$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $27fedfefc1b80d24$var$REQUIRE_TIMEOUT,
        tentatives: $27fedfefc1b80d24$var$REQUIRE_RETRIES
    });

});



parcelRegister("7Yxhk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c78c2221b31c160a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $9pTd3 = parcelRequire("9pTd3");

var $cxKOj = parcelRequire("cxKOj");

var $hgi0g = parcelRequire("hgi0g");

var $lRq8t = parcelRequire("lRq8t");

var $4hgsM = parcelRequire("4hgsM");

var $fWdEN = parcelRequire("fWdEN");
const $c78c2221b31c160a$export$7138c24907de3954 = (projectKey)=>`/rest/agile/1.0/board?projectLocation=${projectKey}&startAt=0&deep-dive-getboards=1`;
const $c78c2221b31c160a$var$fetchBoards = (projectKey)=>(0, $hgi0g.default)($c78c2221b31c160a$export$7138c24907de3954(projectKey));
const $c78c2221b31c160a$var$initialBoardState = (softwareProjects)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    softwareProjects.reduce((acc, { id: projectId })=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acc,
            [projectId]: {
                loading: true,
                error: false
            }
        }), {});
const $c78c2221b31c160a$var$useFetchSoftwareBoards = (recentProjects)=>{
    const boardsHeadingGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fWdEN.messages).boardsHeadingGalaxia : (0, $fWdEN.messages).boardsHeading;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const softwareProjects = (0, $eJOHy.useMemo)(()=>recentProjects.filter((project)=>project.projectType === (0, $FhXEJ.SOFTWARE_PROJECT)), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(recentProjects)
    ]);
    const [results, setResults] = (0, $eJOHy.useState)({
        data: $c78c2221b31c160a$var$initialBoardState(softwareProjects)
    });
    const heading = formatMessage(boardsHeadingGalaxia);
    (0, $eJOHy.useEffect)(()=>{
        let didCancel = false;
        setResults({
            data: $c78c2221b31c160a$var$initialBoardState(softwareProjects)
        });
        (async ()=>{
            await Promise.all(softwareProjects.map(async ({ id: projectId, key: projectKey })=>{
                try {
                    const { values: values } = await $c78c2221b31c160a$var$fetchBoards(projectKey);
                    !didCancel && setResults(({ data: data })=>({
                            data: {
                                ...data,
                                [projectId]: {
                                    heading: heading,
                                    items: values.map(({ id: id, name: name, type: type })=>({
                                            content: name,
                                            href: (0, $4hgsM.getBoardUrl)(projectKey, id.toString(), type),
                                            type: type
                                        })),
                                    loading: false,
                                    error: false
                                }
                            }
                        }));
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (fetchError) {
                    (0, $9pTd3.trackFetchErrors)({
                        error: fetchError,
                        id: 'fetchSoftwareBoards',
                        packageName: 'deepDiveCards'
                    });
                    !didCancel && setResults(({ data: data })=>({
                            data: {
                                ...data,
                                [projectId]: {
                                    loading: false,
                                    error: true
                                }
                            }
                        }));
                }
            }));
        })();
        return ()=>{
            didCancel = true;
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        heading,
        JSON.stringify(softwareProjects)
    ]);
    return results;
};
var $c78c2221b31c160a$export$2e2bcd8739ae039 = $c78c2221b31c160a$var$useFetchSoftwareBoards;

});



parcelRegister("l1nnk", function(module, exports) {
$parcel$export(module.exports, "DeepDiveCardsSection", () => $b9c0f7d0ff55519c$export$120bea8055b02990);

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $bJTU6 = parcelRequire("bJTU6");

var $aTfrB = parcelRequire("aTfrB");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $FhXEJ = parcelRequire("FhXEJ");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $qzoYE = parcelRequire("qzoYE");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");


var $cOzpJ = parcelRequire("cOzpJ");

var $hl7hT = parcelRequire("hl7hT");

var $8qEQb = parcelRequire("8qEQb");

var $goB9t = parcelRequire("goB9t");

var $eRr5N = parcelRequire("eRr5N");

var $k5FRD = parcelRequire("k5FRD");
const $b9c0f7d0ff55519c$var$getLandingUrl = (project, boards, recentData)=>{
    const recentBoard = recentData.items?.find((x)=>x.attributes.containerId === String(project.id));
    return project.projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || project.projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || project.projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT) || project.projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('csm_rename_jcs_to_csm') ? recentBoard?.url ?? boards.data?.items?.at(0)?.href : null;
};
const $b9c0f7d0ff55519c$export$f056421102729c2f = ({ useDeepDiveCardContext: // eslint-disable-next-line react-hooks/react-compiler
useDeepDiveCardContext = (0, $hl7hT.useDeepDiveCardContext) })=>{
    const viewAllGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $k5FRD.default).viewAllGalaxia : (0, $k5FRD.default).viewAll;
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data, sectionTitle: sectionTitle, isloadingProjects: isloadingProjects } = useDeepDiveCardContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const maxlen = (0, $10796b75b11e0d43$export$332af86e8819810d);
    const projectsDirectoryUrl = '/jira/projects';
    const [recentData] = (0, $qzoYE.useRecentBoards)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$OuterSectionStyles
    }, isloadingProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$PlaceholderStyles
    }), !isloadingProjects && (data.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$HeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9c0f7d0ff55519c$var$SectionTitle, null, sectionTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b9c0f7d0ff55519c$export$f8fe8ba0816633ed, {
        href: projectsDirectoryUrl,
        actionSubjectId: "viewAllProjectsLink"
    }, formatMessage(viewAllGalaxia))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$HorizontalScrollingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$SectionStyles
    }, data.slice(0, maxlen).map(({ project: project, boards: boards, filters: filters }, index)=>{
        const globalErrorState = boards.error === true && filters.error === true && !filters.data;
        const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goB9t.DeepDiveCard), {
            project: project,
            key: index,
            landingUrl: $b9c0f7d0ff55519c$var$getLandingUrl(project, boards, recentData)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qEQb.FilterShortcuts), {
            project: project,
            filters: filters
        }), globalErrorState !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qEQb.BoardsDropdown), {
            project: project,
            boards: boards
        }));
        return card;
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$HorizontalScrollOverflowFadeStyles
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$EmptyWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRr5N.EmptyStateDeepDiveCard), {
        projectsDirectoryUrl: projectsDirectoryUrl,
        actionSubjectId: "recentProjectsBrowseProjectsButton"
    }))));
};
const $b9c0f7d0ff55519c$export$c67f6701f4cd5c8 = ({ useDeepDiveCardContext: // eslint-disable-next-line react-hooks/react-compiler
useDeepDiveCardContext = (0, $hl7hT.useDeepDiveCardContext) })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { data: data, isloadingProjects: isloadingProjects, recommendedProjectsData: recommendedProjectsData } = useDeepDiveCardContext();
    const maxlen = (0, $10796b75b11e0d43$export$332af86e8819810d);
    const [recentData] = (0, $qzoYE.useRecentBoards)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$OuterSectionStyles
    }, isloadingProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$PlaceholderStyles
    }), !isloadingProjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bJTU6.default), {
        projectsDirectoryUrl: (0, $10796b75b11e0d43$export$410ed140f4840233),
        recommendedProjects: recommendedProjectsData?.recommendations ?? []
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aTfrB.default), {
        recommendations: recommendedProjectsData?.recommendations ?? []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$HorizontalScrollingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$SectionStyles
    }, data.slice(0, maxlen).map(({ project: project, boards: boards, filters: filters }, index)=>{
        const globalErrorState = boards.error === true && filters.error === true && !filters.data;
        const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goB9t.DeepDiveCard), {
            project: project,
            key: index,
            landingUrl: $b9c0f7d0ff55519c$var$getLandingUrl(project, boards, recentData)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qEQb.FilterShortcuts), {
            project: project,
            filters: filters
        }), globalErrorState !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qEQb.BoardsDropdown), {
            project: project,
            boards: boards
        }));
        return card;
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b9c0f7d0ff55519c$var$EmptyWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRr5N.EmptyStateDeepDiveCard), {
        projectsDirectoryUrl: (0, $10796b75b11e0d43$export$410ed140f4840233),
        actionSubjectId: "recentProjectsBrowseProjectsButton"
    })))));
};
const $b9c0f7d0ff55519c$export$120bea8055b02990 = (0, $f2JN3.componentWithCondition)(()=>(0, $cxKOj.expValEquals)('recommended_projects_for_you_page', 'cohort', 'test', 'control'), $b9c0f7d0ff55519c$export$c67f6701f4cd5c8, $b9c0f7d0ff55519c$export$f056421102729c2f);
var $b9c0f7d0ff55519c$export$2e2bcd8739ae039 = $b9c0f7d0ff55519c$export$120bea8055b02990;
const $b9c0f7d0ff55519c$var$OuterSectionStyles = (0, $1DXK0.xcss)({
    display: 'block',
    position: 'relative',
    paddingTop: 'space.200',
    marginTop: 'space.0',
    marginBottom: 'space.300',
    borderTop: '1px solid',
    borderColor: 'color.border'
});
const $b9c0f7d0ff55519c$var$HeaderStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $b9c0f7d0ff55519c$var$HorizontalScrollingStyles = (0, $1DXK0.xcss)({
    overflowX: 'auto',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    position: 'relative' // This is needed to position the Box that uses the HorizontalScrollOverflowFadeStyles
});
const $b9c0f7d0ff55519c$var$SectionStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    whiteSpace: 'nowrap'
});
// The purpose of these styles is to create a fade effect on the right side of the horizontal scroll to give the user
// a visual cue that there is more content to scroll to. The linear transition from transparent to white is used to
// create the fade effect.
const $b9c0f7d0ff55519c$var$HorizontalScrollOverflowFadeStyles = (0, $1DXK0.xcss)({
    display: 'block',
    position: 'absolute',
    right: 'space.0',
    top: 'space.400',
    bottom: 'space.0',
    width: "var(--ds-space-400, 32px)",
    background: `linear-gradient(
        90deg,
        transparent,
${''}
        ${"var(--ds-surface, #FFFFFF)"} 90%
    )`
});
const $b9c0f7d0ff55519c$var$EmptyWrapperStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.300',
    paddingBottom: 'space.400',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $b9c0f7d0ff55519c$var$PlaceholderStyles = (0, $1DXK0.xcss)({
    height: '196px',
    alignItems: 'center',
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center'
});
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9c0f7d0ff55519c$var$SectionTitle = /*#__PURE__*/ (0, $cdbP5.default).h2.withConfig({
    componentId: "sc-1c9zpnq-0"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};font-weight:${"var(--ds-font-weight-medium, 500)"};`;
const $b9c0f7d0ff55519c$export$f8fe8ba0816633ed = /*#__PURE__*/ (0, $cdbP5.default)((0, $cOzpJ.LinkWithAnalytics)).withConfig({
    componentId: "sc-1c9zpnq-1"
})`font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"},display:inline-flex;text-decoration:none;color:${"var(--ds-link, #0C66E4)"};margin:0;`;

});
parcelRegister("bJTU6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a31fc696fe7ccc5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6pJMC = parcelRequire("6pJMC");

var $78OnL = parcelRequire("78OnL");

var $4EKqI = parcelRequire("4EKqI");

var $9PbMz = parcelRequire("9PbMz");
const $a31fc696fe7ccc5e$var$RecommendedProjectsContainer = ({ children: children, projectsDirectoryUrl: projectsDirectoryUrl, recommendedProjects: recommendedProjects })=>{
    const [selectedTab, setSelectedTab] = (0, $eJOHy.useState)(recommendedProjects.length === 0 ? 'recent' : 'recommended');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "recommendedProjectsContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pJMC.JSErrorBoundary), {
        id: "recommendedProjectsContainer",
        packageName: "jiraGlobalPagesHomeProjectRecommendations",
        teamName: "helios",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9PbMz.default), {
        projectsDirectoryUrl: projectsDirectoryUrl,
        selectedTab: selectedTab,
        onSetSelectedTab: setSelectedTab
    }), selectedTab === 'recommended' && children[0], selectedTab === 'recent' && children[1])));
};
var $a31fc696fe7ccc5e$export$2e2bcd8739ae039 = $a31fc696fe7ccc5e$var$RecommendedProjectsContainer;

});
parcelRegister("9PbMz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0b17cd1f362c2d4$export$2e2bcd8739ae039);
/* SectionTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");

var $806LH = parcelRequire("806LH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $cxKOj = parcelRequire("cxKOj");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $iIKXl = parcelRequire("iIKXl");
const $a0b17cd1f362c2d4$var$messages = (0, $7qGN1.defineMessages)({
    viewAll: {
        "id": "home-project-recommendations.view-all.non-final",
        "defaultMessage": "View all projects"
    },
    viewAllGalaxia: {
        "id": "home-project-recommendations.view-all-galaxia.non-final",
        "defaultMessage": "View all spaces"
    },
    sectionRecommendedTitle: {
        "id": "home-project-recommendations.section-recommended-title.non-final",
        "defaultMessage": "Recommended projects"
    },
    sectionRecommendedTitleGalaxia: {
        "id": "home-project-recommendations.section-recommended-title-galaxia.non-final",
        "defaultMessage": "Recommended spaces"
    },
    sectionRecentTitle: {
        "id": "home-project-recommendations.section-recent-title.non-final",
        "defaultMessage": "Recent projects"
    },
    sectionRecentTitleGalaxia: {
        "id": "home-project-recommendations.section-recent-title-galaxia.non-final",
        "defaultMessage": "Recent spaces"
    }
});
const $a0b17cd1f362c2d4$var$styles = {
    headerStyles: "_1e0c1txw _1bah1yb4",
    tabListContainerStyles: "_2rko12b0 _1h6dmuej _1dqonqa1 _189ee4h9 _4t3izwfg _1bsb1ns9 _19bvu2gc _u5f3u2gc"
};
const $a0b17cd1f362c2d4$var$SectionTitle = ({ projectsDirectoryUrl: projectsDirectoryUrl, selectedTab: selectedTab, onSetSelectedTab: onSetSelectedTab })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onLinkClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'viewAllProjectsLink');
    }, [
        createAnalyticsEvent
    ]);
    const sectionRecommendedTitleGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $a0b17cd1f362c2d4$var$messages.sectionRecommendedTitleGalaxia : $a0b17cd1f362c2d4$var$messages.sectionRecommendedTitle;
    const sectionRecentTitleGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $a0b17cd1f362c2d4$var$messages.sectionRecentTitleGalaxia : $a0b17cd1f362c2d4$var$messages.sectionRecentTitle;
    const viewAllGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $a0b17cd1f362c2d4$var$messages.viewAllGalaxia : $a0b17cd1f362c2d4$var$messages.viewAll;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignBlock: "center",
        xcss: $a0b17cd1f362c2d4$var$styles.headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium"
    }, formatMessage(selectedTab === 'recommended' ? sectionRecommendedTitleGalaxia : sectionRecentTitleGalaxia)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIKXl.default), {
        selected: selectedTab,
        onSetSelectedTab: onSetSelectedTab
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: projectsDirectoryUrl,
        onClick: onLinkClick
    }, formatMessage(viewAllGalaxia))));
};
var $a0b17cd1f362c2d4$export$2e2bcd8739ae039 = $a0b17cd1f362c2d4$var$SectionTitle;

});
parcelRegister("iIKXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf1cfb46cebef9cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");

var $kRgKj = parcelRequire("kRgKj");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $6smsD = parcelRequire("6smsD");
const $bf1cfb46cebef9cc$var$messages = (0, $7qGN1.defineMessages)({
    recommendedTabLabel: {
        "id": "home-project-recommendations.recommended-tab-label.non-final",
        "defaultMessage": "Recommended"
    },
    recentTabLabel: {
        "id": "home-project-recommendations.recent-tab-label.non-final",
        "defaultMessage": "Recent"
    }
});
const $bf1cfb46cebef9cc$var$TabContainer = ({ selected: selected, onSetSelectedTab: onSetSelectedTab })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onTabClick = (0, $eJOHy.useCallback)((analyticsEvent, newSelectedTab)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'projectRecommendationsTab', {
            selectedTab: newSelectedTab
        });
        onSetSelectedTab(newSelectedTab);
    }, [
        onSetSelectedTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.050",
        alignBlock: "center",
        role: "radiogroup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6smsD.default), {
        id: "recommended",
        name: formatMessage($bf1cfb46cebef9cc$var$messages.recommendedTabLabel),
        selected: selected,
        onTabClick: onTabClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6smsD.default), {
        id: "recent",
        name: formatMessage($bf1cfb46cebef9cc$var$messages.recentTabLabel),
        selected: selected,
        onTabClick: onTabClick
    }));
};
var $bf1cfb46cebef9cc$export$2e2bcd8739ae039 = $bf1cfb46cebef9cc$var$TabContainer;

});
parcelRegister("6smsD", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e5c464e689c257e$export$2e2bcd8739ae039);
/* TabButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $1e5c464e689c257e$var$styles = {
    tabStyles: "_2rkolb4i _11c82smr _189ee4h9 _1dqonqa1 _1h6d3acm _bfhk1w7a _syaz1gjq _4t3i1ou6 _k48p1wq8 _ca0qze3t _u5f3utpp _n3tdze3t _19bvutpp _cun9syzs _vbqb1lh4 _1bg4ze3t _irr3166n _30l31gjq _1di61dty",
    tabSelectedStyles: "_2rkolb4i _11c82smr _189ee4h9 _1dqonqa1 _1h6d1yqz _4t3i1ou6 _k48p1wq8 _ca0qze3t _u5f3utpp _n3tdze3t _19bvutpp _bfhkfg4m _syazaqb7 _80om73ad _cun9syzs _vbqb1lh4 _1bg4ze3t _irr3i1yw _30l3aqb7 _1di61dty"
};
const $1e5c464e689c257e$var$TabButton = ({ id: id, selected: selected, onTabClick: onTabClick, name: name })=>{
    const isSelected = selected === id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
        role: "radio",
        xcss: isSelected ? $1e5c464e689c257e$var$styles.tabSelectedStyles : $1e5c464e689c257e$var$styles.tabStyles,
        onClick: (event, analyticsEvent)=>onTabClick(analyticsEvent, id),
        "aria-checked": isSelected,
        "aria-label": name
    }, name);
};
var $1e5c464e689c257e$export$2e2bcd8739ae039 = $1e5c464e689c257e$var$TabButton;

});




parcelRegister("aTfrB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c59a048ba6ebec7$export$2e2bcd8739ae039);
/* RecommendedProjectsSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $4EKqI = parcelRequire("4EKqI");

var $l35xs = parcelRequire("l35xs");

var $93dtV = parcelRequire("93dtV");
const $9c59a048ba6ebec7$var$styles = {
    sectionStyles: "_1reo1wug _ca0qv47k _n3tdv47k _kqswh2mm _2lx21bp4",
    projectsListStyles: ""
};
const $9c59a048ba6ebec7$var$RecommendedProjectsSection = ({ recommendations: recommendations })=>{
    if (!recommendations || recommendations.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $93dtV.RecommendedProjectsEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "recommendedProjectsSection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $9c59a048ba6ebec7$var$styles.sectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        xcss: $9c59a048ba6ebec7$var$styles.projectsListStyles,
        as: "div"
    }, recommendations.map((recommendation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l35xs.default), {
            key: recommendation.project.key,
            recommendation: recommendation
        })))));
};
var $9c59a048ba6ebec7$export$2e2bcd8739ae039 = $9c59a048ba6ebec7$var$RecommendedProjectsSection;

});
parcelRegister("l35xs", function(module, exports) {
$parcel$export(module.exports, "default", () => $27c7e52818309cf1$export$2e2bcd8739ae039);
/* RecommendedProjectCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $5DgXR = parcelRequire("5DgXR");

var $806LH = parcelRequire("806LH");

var $gm7H7 = parcelRequire("gm7H7");

var $hxN6p = parcelRequire("hxN6p");

var $lc0OY = parcelRequire("lc0OY");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $27c7e52818309cf1$var$messages = (0, $7qGN1.defineMessages)({
    usedByTeammate: {
        "id": "home-project-recommendations.used-by-teammate.non-final",
        "defaultMessage": "Used by {teammate}"
    },
    popularWithTeammates: {
        "id": "home-project-recommendations.popular-with-teammates.non-final",
        "defaultMessage": "Popular with teammates"
    },
    recommendationCardAriaLabel: {
        "id": "home-project-recommendations.recommendation-card-aria-label.non-final",
        "defaultMessage": "Recommended project: {projectName}, a {projectType} project. Recommendation reason: {recommendationType}"
    },
    businessProject: {
        "id": "home-project-recommendations.business-project.non-final",
        "defaultMessage": "Business project"
    },
    customerServiceProject: {
        "id": "home-project-recommendations.customer-service-project.non-final",
        "defaultMessage": "Customer service project"
    },
    productDiscoveryProject: {
        "id": "home-project-recommendations.product-discovery-project.non-final",
        "defaultMessage": "Product discovery"
    },
    serviceDeskProject: {
        "id": "home-project-recommendations.service-desk-project.non-final",
        "defaultMessage": "Service desk project"
    },
    softwareProject: {
        "id": "home-project-recommendations.software-project.non-final",
        "defaultMessage": "Software project"
    }
});
const $27c7e52818309cf1$var$styles = {
    cardStyles: "_4bfu18uv _1hmsglyw _ajmmnqa1 _2rko12b0 _1h6dmuej _1dqonqa1 _189ee4h9 _1bsb96e4 _1ul996e4 _4t3iqkoa _1e0c1ule _bfhkvuon _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _syaz1fxt _1ydc18uv _1x28glyw _1726nqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _irr3108i _30l31fxt _1nrm18uv _c2waglyw _1iohnqa1 _1di61ji5"
};
const $27c7e52818309cf1$var$getProjectUrl = (projectKey)=>`/browse/${projectKey}`;
const $27c7e52818309cf1$var$RecommendedProjectCard = ({ recommendation: recommendation })=>{
    const { project: project, details: details } = recommendation;
    const { name: name, avatarUrl: avatarUrl, key: key, type: projectType } = project;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const recommendationText = details.type === 'TENANT_ACTIVITY' ? formatMessage($27c7e52818309cf1$var$messages.popularWithTeammates) : formatMessage($27c7e52818309cf1$var$messages.usedByTeammate, {
        teammate: details.user.name
    });
    const recommendationIcon = (0, $eJOHy.useMemo)(()=>{
        return details.type === 'TENANT_ACTIVITY' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gm7H7))), {
            label: "",
            size: "small"
        });
    }, [
        details.type
    ]);
    const onCardClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'projectCard'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'recommendedProjectCard', {
            projectType: projectType,
            recommendationType: details.type,
            recommendationRelevancyScore: details.relevancyScore
        });
    }, [
        createAnalyticsEvent,
        projectType,
        details.type,
        details.relevancyScore
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lc0OY.default), {
        href: $27c7e52818309cf1$var$getProjectUrl(key),
        xcss: $27c7e52818309cf1$var$styles.cardStyles,
        onClick: onCardClick,
        "aria-label": formatMessage($27c7e52818309cf1$var$messages.recommendationCardAriaLabel, {
            projectName: name,
            projectType: projectType,
            recommendationType: recommendationText
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "medium",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h4",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        maxLines: 1,
        weight: "semibold",
        color: "color.text"
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        weight: "regular",
        size: "small",
        as: "p",
        maxLines: 1,
        color: "color.text.subtle"
    }, formatMessage($27c7e52818309cf1$var$getProjectTypeMessage(projectType)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.025",
        alignBlock: "center"
    }, recommendationIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        weight: "regular",
        size: "small",
        as: "p",
        maxLines: 1,
        color: "color.text.subtle"
    }, recommendationText))))));
};
const $27c7e52818309cf1$var$getProjectTypeMessage = (projectType)=>{
    switch(projectType){
        case 'business':
            return $27c7e52818309cf1$var$messages.businessProject;
        case 'customer_service':
            return $27c7e52818309cf1$var$messages.customerServiceProject;
        case 'product_discovery':
            return $27c7e52818309cf1$var$messages.productDiscoveryProject;
        case 'service_desk':
            return $27c7e52818309cf1$var$messages.serviceDeskProject;
        case 'software':
        default:
            return $27c7e52818309cf1$var$messages.softwareProject;
    }
};
var $27c7e52818309cf1$export$2e2bcd8739ae039 = $27c7e52818309cf1$var$RecommendedProjectCard;

});

parcelRegister("93dtV", function(module, exports) {
$parcel$export(module.exports, "RecommendedProjectsEmptyState", () => $75f9f7295f53de19$export$c28872577b41293e);
/* RecommendedProjectsEmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $6MnLl = parcelRequire("6MnLl");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $cxKOj = parcelRequire("cxKOj");
const $75f9f7295f53de19$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateTextGalaxia: {
        "id": "home-project-recommendations.empty-state-text-galaxia.non-final",
        "defaultMessage": "Any recommended spaces will appear here"
    },
    emptyStateHeaderGalaxia: {
        "id": "home-project-recommendations.empty-state-header-galaxia.non-final",
        "defaultMessage": "No spaces found"
    },
    emptyStateText: {
        "id": "home-project-recommendations.empty-state-text.non-final",
        "defaultMessage": "Any recommended projects will appear here"
    },
    emptyStateHeader: {
        "id": "home-project-recommendations.empty-state-header.non-final",
        "defaultMessage": "No projects found"
    }
});
const $75f9f7295f53de19$var$styles = {
    emptyStateStyles: "_y3gn1h6o _syaz1fxt _ca0qv77o _n3tdv77o _19bvze3t _u5f3ze3t _1bsb1osq"
};
const $75f9f7295f53de19$export$c28872577b41293e = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const emptyStateTextGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $75f9f7295f53de19$var$messages.emptyStateTextGalaxia : $75f9f7295f53de19$var$messages.emptyStateText;
    const emptyStateHeaderGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $75f9f7295f53de19$var$messages.emptyStateHeaderGalaxia : $75f9f7295f53de19$var$messages.emptyStateHeader;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $75f9f7295f53de19$var$styles.emptyStateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        description: formatMessage(emptyStateTextGalaxia),
        header: formatMessage(emptyStateHeaderGalaxia)
    }));
};

});


parcelRegister("qzoYE", function(module, exports) {
$parcel$export(module.exports, "useRecentActions", () => $28b016429ca0fd70$export$5c0647984dfa7d27);
$parcel$export(module.exports, "useRecentBoards", () => $28b016429ca0fd70$export$3731bd023be4f71);
$parcel$export(module.exports, "RecentsContainer", () => $28b016429ca0fd70$export$5de14a1c1400859e);


var $4k95d = parcelRequire("4k95d");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

const $28b016429ca0fd70$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $28b016429ca0fd70$export$d4c72bab9d6cc13a = {
    [(0, $530fa672789495a8$export$f95f1a684a17f189)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$6e58b6b0aa48a271)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$6737b9227f60f39d)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$91a9dba2d38d9a6f)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    [(0, $530fa672789495a8$export$20f1031cc9fdf29e)]: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    workedOn: {
        ...$28b016429ca0fd70$var$emptyItemState
    },
    all: {
        ...$28b016429ca0fd70$var$emptyItemState
    }
};
const $28b016429ca0fd70$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'quick-search-boards') acc[0, $530fa672789495a8$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'quick-search-filters') acc[0, $530fa672789495a8$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'quick-search-dashboards') acc[0, $530fa672789495a8$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'quick-search-projects') acc[0, $530fa672789495a8$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'quick-search-queues') acc[0, $530fa672789495a8$export$20f1031cc9fdf29e] = itemResponse.items;
        return acc;
    }, {});
const $28b016429ca0fd70$var$transformWorkedOnItems = (response)=>// select the right data and rename it
    response.data.activities.myActivities.workedOn.nodes.map(({ object: { id: id, localResourceId: localResourceId, name: name, extension: extension, iconUrl: iconUrl, url: url, containers: containers, type: type } })=>({
            id: id,
            localResourceId: localResourceId,
            title: name,
            metadata: extension.issueKey,
            avatarUrl: iconUrl,
            url: url,
            attributes: {
                containerName: containers.find((container)=>container.type === 'PROJECT')?.name
            },
            type: `${type.toLowerCase()}s`
        }));
const $28b016429ca0fd70$var$getQueryConfig = (amount, types)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    types.reduce((acc, type)=>{
        acc[type] = amount;
        return acc;
    }, {});
const $28b016429ca0fd70$var$loadRecentItems = (amount = (0, $ed46f2cd980f21d3$export$22ea57e66775a6b2), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $4k95d.fetchRecentItems)({
                counts: $28b016429ca0fd70$var$getQueryConfig(amount, typesToFetch)
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $28b016429ca0fd70$var$transformItems(itemResponse || []);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $28b016429ca0fd70$var$loadRecentItemsSingleList = (amount = (0, $ed46f2cd980f21d3$export$5f1b6c5e9d257e5e), types)=>async ({ setState: setState, getState: getState })=>{
        if (types.length) try {
            const promise = (0, $4k95d.fetchRecentItemsSingleList)({
                types: types,
                limit: amount
            });
            const loadingState = {
                all: {
                    ...getState().all,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const responseState = {
                all: {
                    items: itemResponse != null ? itemResponse[0].items : [],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                all: {
                    ...getState().all,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $28b016429ca0fd70$var$loadWorkedOnItems = (amount = (0, $ed46f2cd980f21d3$export$8666f31c8873bff))=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        try {
            const promise = (0, $4k95d.fetchWorkedOnItems)({
                cloudId: cloudId,
                amount: amount
            });
            const loadingState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const transformedItems = $28b016429ca0fd70$var$transformWorkedOnItems(itemResponse);
            const responseState = {
                workedOn: {
                    items: transformedItems,
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            // @ts-expect-error - TS2345 - Argument of type '{ workedOn: { items: { id: string | number; localResourceId: string; title: string; metadata: string; avatarUrl: string; url: string; attributes: { containerName: string | null | undefined; }; type: string; }[]; ... 4 more ...; hasSuccessOnce: boolean; }; }' is not assignable to parameter of type 'Partial<State>'.
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $28b016429ca0fd70$export$e324594224ef24da = {
    loadRecentAll: (amount)=>async (actions2, props)=>{
            $28b016429ca0fd70$var$loadRecentItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $530fa672789495a8$export$f95f1a684a17f189) : undefined,
                (0, $530fa672789495a8$export$6e58b6b0aa48a271),
                (0, $530fa672789495a8$export$91a9dba2d38d9a6f),
                (0, $530fa672789495a8$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $530fa672789495a8$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadRecentAllSingleList: (amount)=>async (actions2, props)=>{
            $28b016429ca0fd70$var$loadRecentItemsSingleList(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $530fa672789495a8$export$f95f1a684a17f189) : undefined,
                (0, $530fa672789495a8$export$6e58b6b0aa48a271),
                (0, $530fa672789495a8$export$91a9dba2d38d9a6f),
                (0, $530fa672789495a8$export$6737b9227f60f39d),
                (0, $530fa672789495a8$export$ebb48b08205007c5),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $530fa672789495a8$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadWorkedOnAllSingleList: $28b016429ca0fd70$var$loadWorkedOnItems,
    loadRecentBoards: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$f95f1a684a17f189)
        ]),
    loadRecentProjects: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$91a9dba2d38d9a6f)
        ]),
    loadRecentDashboards: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$6e58b6b0aa48a271)
        ]),
    loadRecentFilters: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$6737b9227f60f39d)
        ]),
    loadRecentQueues: (amount)=>$28b016429ca0fd70$var$loadRecentItems(amount, [
            (0, $530fa672789495a8$export$20f1031cc9fdf29e)
        ])
};
const $28b016429ca0fd70$var$store = (0, $GtRbT.createStore)({
    name: (0, $ed46f2cd980f21d3$export$eb2b39783d051b9),
    actions: $28b016429ca0fd70$export$e324594224ef24da,
    initialState: $28b016429ca0fd70$export$d4c72bab9d6cc13a
});
const $28b016429ca0fd70$export$5c0647984dfa7d27 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: null
});
const $28b016429ca0fd70$export$9a54f46f5b7734c = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state.all
});
const $28b016429ca0fd70$export$e8278a7bcff1ec98 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state.workedOn
});
const $28b016429ca0fd70$export$3731bd023be4f71 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$f95f1a684a17f189]
});
const $28b016429ca0fd70$export$81cb5beef51d43ca = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$6e58b6b0aa48a271]
});
const $28b016429ca0fd70$export$f6b9a13c4ec08b45 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$91a9dba2d38d9a6f]
});
const $28b016429ca0fd70$export$8d2bfb6d3657bae2 = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$6737b9227f60f39d]
});
const $28b016429ca0fd70$export$8756abb0bb90a56e = (0, $iJq0l.createHook)($28b016429ca0fd70$var$store, {
    selector: (state)=>state[0, $530fa672789495a8$export$20f1031cc9fdf29e]
});
const $28b016429ca0fd70$export$5de14a1c1400859e = (0, $6E16M.createContainer)($28b016429ca0fd70$var$store);

});
const $530fa672789495a8$export$91a9dba2d38d9a6f = 'projects';
const $530fa672789495a8$export$ebb48b08205007c5 = 'issues';
const $530fa672789495a8$export$6737b9227f60f39d = 'filters';
const $530fa672789495a8$export$6e58b6b0aa48a271 = 'dashboards';
const $530fa672789495a8$export$20f1031cc9fdf29e = 'queues';
const $530fa672789495a8$export$f95f1a684a17f189 = 'boards';
const $530fa672789495a8$export$3c11110d46d67e8c = 'jwmBoards';
const $530fa672789495a8$export$5e2cc09b58170ca2 = 'addons';
const $530fa672789495a8$export$eebccb886b064713 = 'plans';
const $530fa672789495a8$export$1c2ea36059c73937 = 'alerts';

parcelRegister("4k95d", function(module, exports) {
$parcel$export(module.exports, "fetchRecentItems", () => $5fc362b79c81ddfc$export$20d49db97b653a7b);
$parcel$export(module.exports, "fetchRecentItemsSingleList", () => $5fc362b79c81ddfc$export$a00963dad78984b8);
$parcel$export(module.exports, "fetchWorkedOnItems", () => $5fc362b79c81ddfc$export$f3763cb0ecc90572);

var $b5RwB = parcelRequire("b5RwB");


var $eBhI6 = parcelRequire("eBhI6");

var $9XTSb = parcelRequire("9XTSb");

const $5fc362b79c81ddfc$var$PATH_BUCKETED = '/rest/internal/2/productsearch/search';
const $5fc362b79c81ddfc$var$PATH_SINGLE_LIST = '/rest/internal/2/productsearch/singleRecentList';
// dummy handle error
const $5fc362b79c81ddfc$var$handleError = (error)=>{
    throw error;
};
const $5fc362b79c81ddfc$var$toQuery = ({ counts: counts })=>// @ts-expect-error - TS2769 - No overload matches this call.
    Object.keys(counts) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, itemType)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<ItemType, number>>'.
        result.push(`${itemType}=${counts[itemType]}`);
        return result;
    }, []).join(',');
const $5fc362b79c81ddfc$export$20d49db97b653a7b = async ({ counts: counts })=>{
    const url = `${$5fc362b79c81ddfc$var$PATH_BUCKETED}?${(0, $b5RwB.stringify)({
        counts: $5fc362b79c81ddfc$var$toQuery({
            counts: counts
        }),
        type: Object.keys(counts).join(',')
    })}`;
    try {
        const response = await fetch(url, (0, $eBhI6.getDefaultOptions)(url));
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3a153a61cf6b691b$export$67d19e9a991baa07)) return $5fc362b79c81ddfc$var$handleError(new (0, $9XTSb.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $5fc362b79c81ddfc$var$handleError(new Error(status));
        }
        if (status === (0, $3a153a61cf6b691b$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $5fc362b79c81ddfc$var$handleError(error);
    }
};
const $5fc362b79c81ddfc$export$a00963dad78984b8 = async ({ types: types, limit: limit })=>{
    const url = $5fc362b79c81ddfc$var$PATH_SINGLE_LIST;
    try {
        const response = await fetch(url, {
            ...(0, $eBhI6.getDefaultOptions)(url),
            method: 'POST',
            body: JSON.stringify({
                groups: [
                    {
                        types: types,
                        limit: limit
                    }
                ]
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3a153a61cf6b691b$export$67d19e9a991baa07)) return $5fc362b79c81ddfc$var$handleError(new (0, $9XTSb.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $5fc362b79c81ddfc$var$handleError(new Error(status));
        }
        if (status === (0, $3a153a61cf6b691b$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $5fc362b79c81ddfc$var$handleError(error);
    }
};
const $5fc362b79c81ddfc$export$f3763cb0ecc90572 = async ({ cloudId: cloudId, amount: amount })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'jira_NavigationActivity',
                query: (0, $91b4cfd47cb3a0c0$export$2b91517d6d5b4365),
                variables: {
                    first: amount,
                    cloudID: cloudId
                }
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $3a153a61cf6b691b$export$67d19e9a991baa07)) return $5fc362b79c81ddfc$var$handleError(new (0, $9XTSb.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $5fc362b79c81ddfc$var$handleError(new Error(status));
        }
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $5fc362b79c81ddfc$var$handleError(error);
    }
};

});
const $3a153a61cf6b691b$export$ff39ebd4bb12b718 = 201;
const $3a153a61cf6b691b$export$3288b14b6745c572 = 204;
const $3a153a61cf6b691b$export$9de493bcd9b1d977 = 400;
const $3a153a61cf6b691b$export$67d19e9a991baa07 = 401;
const $3a153a61cf6b691b$export$a3269a3914b007e3 = 403;
const $3a153a61cf6b691b$export$8bca792d963eb0ef = 404;
const $3a153a61cf6b691b$export$4a3cb39801694eee = 407;
const $3a153a61cf6b691b$export$fa405bbf47d510e2 = 408;
const $3a153a61cf6b691b$export$c09e7ea0fc79f34f = 409;
const $3a153a61cf6b691b$export$5244030134e99 = 412;
const $3a153a61cf6b691b$export$f90ac1df0b60853d = 413;
const $3a153a61cf6b691b$export$a447d0a965e16776 = 422;
const $3a153a61cf6b691b$export$3b48aba8957000cd = 426;
const $3a153a61cf6b691b$export$6763168a631449a2 = 429;
const $3a153a61cf6b691b$export$e813cd7045fcc98d = 500;
const $3a153a61cf6b691b$export$2ce38d41a306034e = 502;
const $3a153a61cf6b691b$export$974c37534b0191b1 = 503;
const $3a153a61cf6b691b$export$5400e8dddac3fcf3 = 504;

parcelRegister("9XTSb", function(module, exports) {
$parcel$export(module.exports, "AuthenticationError", () => $3b0c201b6a8510b5$export$cf0c46b07324e9c5);
class $3b0c201b6a8510b5$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});

const $91b4cfd47cb3a0c0$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;


const $ed46f2cd980f21d3$export$eb2b39783d051b9 = 'navigation-recents-store';
const $ed46f2cd980f21d3$export$22ea57e66775a6b2 = 5;
const $ed46f2cd980f21d3$export$8666f31c8873bff = 10;
const $ed46f2cd980f21d3$export$5f1b6c5e9d257e5e = 20;


const $10796b75b11e0d43$export$332af86e8819810d = 5;
const $10796b75b11e0d43$export$12d852d15fcac15e = 'deep-dive-card-demo-card-spotlight';
const $10796b75b11e0d43$export$b9c74fbc98d01c6d = 'demo-project-card';
const $10796b75b11e0d43$export$861c7adb7ce6dfc9 = 'itsm-sample-project-card';
const $10796b75b11e0d43$export$fa4bd7915d7cf526 = 'first-user-created-jsm-project-card';
const $10796b75b11e0d43$export$410ed140f4840233 = '/jira/projects';

parcelRegister("cOzpJ", function(module, exports) {
$parcel$export(module.exports, "LinkWithAnalytics", () => $fbf8cd94163c2a37$export$560bebe32100cf5e);

var $eJOHy = parcelRequire("eJOHy");

var $c3tJH = parcelRequire("c3tJH");
var $kRgKj = parcelRequire("kRgKj");

var $c9uTK = parcelRequire("c9uTK");
const $fbf8cd94163c2a37$export$b48da23035bc42ab = (0, $c3tJH.AnalyticsEventToProps)('link', {
    onClick: 'clicked'
})((0, $c9uTK.Link));
const $fbf8cd94163c2a37$export$560bebe32100cf5e = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId = '', attributes: attributes = {}, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fbf8cd94163c2a37$export$b48da23035bc42ab, {
        ...props,
        // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
        onClick: (_, analyticsEvent)=>{
            const { payload: payload } = analyticsEvent;
            analyticsEvent.update({
                action: typeof action !== 'undefined' ? action : payload.action,
                actionSubject: typeof actionSubject !== 'undefined' ? actionSubject : payload.actionSubject
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
            if (props.onClick) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            props.onClick();
        }
    });

});

parcelRegister("8qEQb", function(module, exports) {
$parcel$export(module.exports, "BoardsDropdown", () => $23ce5295aa8ab75c$export$a39330a467b31748);
$parcel$export(module.exports, "FilterShortcuts", () => $23ce5295aa8ab75c$export$26d6962839aa4c0a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $c3tJH = parcelRequire("c3tJH");
var $kRgKj = parcelRequire("kRgKj");

var $goB9t = parcelRequire("goB9t");
const $23ce5295aa8ab75c$var$BoardsDropdownWithAnalytics = (0, $c3tJH.AnalyticsEventToProps)('deepDiveCardBoardsDropdown', {
    onError: 'error'
})((0, $goB9t.BoardsDropdown));
const $23ce5295aa8ab75c$var$handleBoardsDropdownError = (analyticsEvent)=>{
    analyticsEvent.update({
        action: 'error',
        actionSubject: 'boardsDropdown'
    });
    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'deepDiveCardBoardsDropdown');
};
const $23ce5295aa8ab75c$export$a39330a467b31748 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23ce5295aa8ab75c$var$BoardsDropdownWithAnalytics, {
        ...props,
        onError: $23ce5295aa8ab75c$var$handleBoardsDropdownError
    });
const $23ce5295aa8ab75c$var$FilterShortcutsWithAnalytics = (0, $c3tJH.AnalyticsEventToProps)('deepDiveCardFilterShortcuts', {
    onError: 'error'
})((0, $goB9t.FilterShortcuts));
const $23ce5295aa8ab75c$var$handleFilterShortCutsError = (analyticsEvent)=>{
    analyticsEvent.update({
        action: 'error',
        actionSubject: 'filterShortcuts'
    });
    (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'deepDiveCardFilterShortcuts');
};
const $23ce5295aa8ab75c$export$26d6962839aa4c0a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23ce5295aa8ab75c$var$FilterShortcutsWithAnalytics, {
        ...props,
        onError: $23ce5295aa8ab75c$var$handleFilterShortCutsError
    });

});
parcelRegister("goB9t", function(module, exports) {
$parcel$export(module.exports, "DeepDiveCard", () => $e4459b4f8c408015$export$673ef83eae2bd98f);
$parcel$export(module.exports, "BoardsDropdown", () => $e4459b4f8c408015$export$a39330a467b31748);
$parcel$export(module.exports, "FilterShortcuts", () => $e4459b4f8c408015$export$26d6962839aa4c0a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $1OQKp = parcelRequire("1OQKp");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $k71qx = parcelRequire("k71qx");

var $cxKOj = parcelRequire("cxKOj");

var $FhXEJ = parcelRequire("FhXEJ");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");

var $iiqPE = parcelRequire("iiqPE");

var $cOzpJ = parcelRequire("cOzpJ");

var $dxHqx = parcelRequire("dxHqx");

var $fYZMH = parcelRequire("fYZMH");

var $jx5O3 = parcelRequire("jx5O3");

var $27w8y = parcelRequire("27w8y");
const $e4459b4f8c408015$var$ToolTipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterTitleToolipContainer, {
        ref: ref,
        ...props
    }));
const $e4459b4f8c408015$var$getRebrandedProjectTypeMessage = (isSimplified, projectType)=>{
    if (projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('jcs_project_type_m3')) return $iiqPE.boards.customerService;
    if (projectType === (0, $FhXEJ.SOFTWARE_PROJECT)) return isSimplified ? $iiqPE.boards.teamManagedSoftware : $iiqPE.boards.companyManagedSoftware;
    if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT)) return isSimplified ? $iiqPE.boards.teamManagedServiceManagement : $iiqPE.boards.companyManagedServiceManagement;
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return $iiqPE.boards.productDiscovery;
    return isSimplified ? $iiqPE.boards.teamManagedBusiness : $iiqPE.boards.companyManagedBusiness;
};
const $e4459b4f8c408015$export$a5fe9717dd10954a = (isSimplified, projectType, formatMessage)=>{
    // TODO: All that projectTypeMsg seems to be very legacy, we can get rid of it when cleaning jcs_project_type_m3
    if ((0, $4cTDP.fg)('jcs_project_type_m3')) // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'ProjectType'.
    return formatMessage($e4459b4f8c408015$var$getRebrandedProjectTypeMessage(isSimplified, projectType));
     // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'ProjectType'.
    const boardTypeMessage = $e4459b4f8c408015$var$getRebrandedProjectTypeMessage(isSimplified, projectType);
    let projectTypeMsg = '';
    if (projectType === 'service_desk') projectTypeMsg = formatMessage($iiqPE.types.service_desk);
    else if (projectType) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ product_discovery: MessageDescriptor; software: MessageDescriptor; service_desk: MessageDescriptor; business: MessageDescriptor; }'.
    projectTypeMsg = formatMessage($iiqPE.types[projectType]);
    return projectTypeMsg ? formatMessage(boardTypeMessage, {
        projectType: projectTypeMsg
    }) : '';
};
const $e4459b4f8c408015$var$getDropdownTitle = (projectType)=>{
    if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('csm_rename_jcs_to_csm')) return $iiqPE.general.queue;
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return $iiqPE.general.views;
    return $iiqPE.general.board;
};
const $e4459b4f8c408015$export$673ef83eae2bd98f = ({ project: { projectName: projectName, projectType: projectType, avatarUrl: avatarUrl, href: href, isSimplified: isSimplified, barColor: barColor }, landingUrl: landingUrl, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const boardTypeMessage = $e4459b4f8c408015$export$a5fe9717dd10954a(isSimplified, projectType, formatMessage);
    const cardHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$export$8b251419efc915eb, {
        href: landingUrl ?? href,
        actionSubject: "card",
        actionSubjectId: "deepDiveProjectCard",
        attributes: {
            projectType: projectType,
            nextGen: isSimplified
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jx5O3.default), {
        url: avatarUrl,
        width: 24,
        height: 24
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$Heading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ProjectNameHeading, {
        "data-testid": "deep-dive-card-content--project-name-heading"
    }, projectName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ProjectTypeSubheading, {
        "data-testid": "deep-dive-card-content--project-type-subheading"
    }, boardTypeMessage)));
    return(// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$StyledContainer, {
        barColor: barColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: projectName,
        position: "top"
    }, cardHeader), children));
};
$e4459b4f8c408015$export$673ef83eae2bd98f.whyDidYouRender = true;
const $e4459b4f8c408015$var$ErrorSkeletonContainer = ({ message: message, hideMessage: hideMessage })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formattedMessage = formatMessage(message);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formattedMessage,
        position: "mouse",
        mousePosition: "top" // @ts-expect-error - TS2322 - Type 'StyledComponentClass<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { height?: string | number | undefined; }, any, ClassAttributes<...> & ... 1 more ... & { ...; }>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
        ,
        tag: $e4459b4f8c408015$var$ErrorSkeleton,
        truncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hideMessage !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ErrorMessage, null, formattedMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYZMH.default), null)));
};
const $e4459b4f8c408015$export$a39330a467b31748 = ({ project: project, boards: { loading: loading, error: error, data: data }, onError: onError })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { projectType: projectType } = project;
    (0, $27w8y.useEffectFireErrorCallback)(error, onError);
    const errorGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $iiqPE.state.errorGalaxia : $iiqPE.state.error;
    const [items, itemCount] = (0, $eJOHy.useMemo)(()=>{
        const dataItems = data?.items || []; // Children items are section headers, we only want to count the children, not the section headers
        const count = dataItems.reduce((total, item)=>item.children ? total + item.children.length : total + 1, 0);
        return [
            dataItems,
            count
        ];
    }, [
        data
    ]);
    if (error === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$export$5e51488ddda0709f, {
        "data-vc": "deep-dive-card-filter-shortcuts-board-content-row-with-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ErrorSkeletonContainer, {
        message: errorGalaxia
    }));
    if (loading === true || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$export$5e51488ddda0709f, {
        "data-vc": "deep-dive-card-filter-shortcuts-board-content-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
        percentageWidth: 75
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
        invisible: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$export$5e51488ddda0709f, {
        "data-vc": "deep-dive-card-filter-shortcuts-board-content-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        testId: "deep-dive-cards-section.ui.deep-dive-card.dropdown",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$export$741c5897273b6f8f, {
                ...triggerProps,
                appearance: "subtle" // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
                ,
                iconAfter: itemCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    spacing: "compact",
                    size: "small",
                    label: ""
                }) : null,
                isDisabled: !itemCount,
                spacing: "none",
                testId: "deep-dive-cards-section.ui.deep-dive-card.deep-dive-card-board-content-dropdown-trigger" // @ts-expect-error - TS2322: Type 'Ref<HTMLElement>' is not assignable to type '((instance: any) => void) | RefObject<SVGElement | HTMLElement | Component<{}, {}, any>> | undefined'
                ,
                innerRef: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$DropdownTitle, {
                numItems: itemCount,
                "data-testid": "deep-dive-card--board-content--dropdown--title",
                jsvDarkmodeInnovationEnabled: true
            }, formatMessage($e4459b4f8c408015$var$getDropdownTitle(projectType), {
                numberBoards: itemCount
            }))),
        spacing: "compact",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxHqx.DropdownMenuContent), {
        data: items,
        project: project
    })));
};
const $e4459b4f8c408015$export$26d6962839aa4c0a = ({ project: { projectType: projectType, isSimplified: isSimplified }, filters: { loading: loading, error: error, data: data }, onError: onError })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const errorGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? $iiqPE.state.errorGalaxia : $iiqPE.state.error;
    (0, $27w8y.useEffectFireErrorCallback)(error, onError);
    if (error === true && !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterShortCutsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ContentRow, {
        "data-vc": "deep-dive-card-filter-shortcuts-content-row-with-errorg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ErrorSkeletonContainer, {
        message: errorGalaxia
    })));
    if (!data) {
        if (loading !== true && !false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterShortCutsContainer, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterShortCutsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ContentRow, {
            "data-vc": "deep-dive-card-filter-shortcuts-content-row-loading-0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
            percentageWidth: 75
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
            invisible: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ContentRow, {
            "data-vc": "deep-dive-card-filter-shortcuts-content-row-loading-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
            percentageWidth: 75
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ContentRow, {
            "data-vc": "deep-dive-card-filter-shortcuts-content-row-loading-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
            percentageWidth: 75
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, null)));
    }
    const links = data.map((item, idx)=>{
        const loadingTitle = item.isLoading === true && !item.content;
        const loadingItemCounts = item.isLoading;
        const itemCountsError = item.error;
        const renderItemCounts = ()=>{
            if (loadingItemCounts === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, null);
            if (itemCountsError === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ErrorSkeletonContainer, {
                hideMessage: true,
                message: $iiqPE.state.errorCount
            });
            return item.itemCount !== undefined && item.itemCount >= 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterCountBadge, {
                count: item.itemCount,
                "data-testid": "deep-dive-card-content--dropdown--content--filter-link--count-badge"
            }) : null;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ContentRow, {
            key: idx,
            "data-vc": `deep-dive-card-filter-shortcuts-content-row-${idx}`
        }, loadingTitle === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$LoadingBarSkeleton, {
            percentageWidth: 75
        }), renderItemCounts()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$export$79f6f15df797f8df, {
            href: item.href,
            loading: loadingItemCounts,
            actionSubjectId: "deepDiveCardLinkFilter",
            attributes: {
                projectType: projectType,
                nextGen: isSimplified
            },
            "data-testid": "deep-dive-card-content--dropdown--content--filter-link",
            "aria-label": item.content
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: item.content,
            position: "bottom" // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
            ,
            tag: $e4459b4f8c408015$var$ToolTipContainer,
            truncate: true,
            testId: "deep-dive-cards-section.ui.deep-dive-card.deep-dive-card-content-dropdown-content-filter-link-tool-tip-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterTitle, {
            "data-testId": "deep-dive-card-content--dropdown--content--filter-link--tool-tip-container--filter-title"
        }, item.content)), renderItemCounts()));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterShortCutsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$ContentRow, {
        "data-vc": "deep-dive-card-filter-shortcuts-content-row-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4459b4f8c408015$var$FilterLinksHeading, null, formatMessage(projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT) || projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('csm_rename_jcs_to_csm') ? $iiqPE.heading.queuesHeading : $iiqPE.heading.boardsHeading))), links);
};
const $e4459b4f8c408015$var$gutterLeftRightPullback = 4; /**
                                    * The amount board item counts 'flow' into the top gutter area separating the heading.
                                    */ 
const $e4459b4f8c408015$var$gutterTopPullback = 4 * (1 / 4); /**
                                        * Top and bottom padding for computing hover state backgrounds.
                                        */ 
const $e4459b4f8c408015$var$hoverStateTopBottomPadding = 4 * (3 / 4); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$StyledContainer = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-0"
})`display:flex;height:168px;width:240px;padding-top:${"var(--ds-space-200, 16px)"};flex-direction:column;color:inherit;background:${"var(--ds-surface-raised, #FFFFFF)"};:not(:first-of-type){margin-left:${"var(--ds-space-150, 12px)"};}border:none;${'' /* eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage */ } border-radius:${"var(--ds-radius-small, 3px)"};border-left:20px solid ${(props)=>props.barColor || "var(--ds-background-neutral, #091E420F)"};box-sizing:border-box;box-shadow:${"var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"};transition:box-shadow 0.3s ease-in-out,border-color 0.6s ease-in;:hover{box-shadow:${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};}`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$Heading = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-1"
})({
    display: 'inline-block',
    verticalAlign: 'top',
    flex: 1,
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-050, 4px)",
    overflow: 'hidden'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order
const $e4459b4f8c408015$var$ProjectNameHeadingOld = /*#__PURE__*/ (0, $cdbP5.default).p.withConfig({
    componentId: "sc-1xw97h-2"
})({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text, #172B4D)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: 0,
    height: '16px'
});
const $e4459b4f8c408015$var$ProjectNameHeadingNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_11c8140y _1reo15vq _18m915vq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1fxt _o5721q9c _1bto1l2s _4t3if6fq"
        ])
    }, children);
const $e4459b4f8c408015$var$projectNameHeadingStyles = null;
const $e4459b4f8c408015$var$ProjectNameHeading = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('jira_kuro_jjj_for_you_project_name_cropped_card'), $e4459b4f8c408015$var$ProjectNameHeadingNew, $e4459b4f8c408015$var$ProjectNameHeadingOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$ProjectTypeSubheading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _syaz1fxt _1bto1l2s _o5721q9c _1p1dglyw",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $e4459b4f8c408015$var$DropdownTitle = /*#__PURE__*/ (0, $cdbP5.default).p.withConfig({
    componentId: "sc-1xw97h-3"
})`display:flex;text-transform:none;font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};${({ jsvDarkmodeInnovationEnabled: jsvDarkmodeInnovationEnabled })=>!jsvDarkmodeInnovationEnabled && `font-weight: ${"var(--ds-font-weight-semibold, 600)"};`} ${({ numItems: numItems, jsvDarkmodeInnovationEnabled: jsvDarkmodeInnovationEnabled })=>!jsvDarkmodeInnovationEnabled && `color: ${numItems ? "var(--ds-text, #172B4D)" : "var(--ds-text-subtlest, #626F86)"};`}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$ContentRow = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-4"
})({
    display: 'flex',
    paddingLeft: "var(--ds-space-200, 16px)",
    paddingRight: "var(--ds-space-150, 12px)",
    marginBottom: "var(--ds-space-025, 2px)"
});
const $e4459b4f8c408015$var$shimmer = /*#__PURE__*/ (0, $cdbP5.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$LoadingBarSkeleton = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-5"
})`display:inline-block;height:${(props)=>props.height ? `${props.height}px` : '22px'};animation-duration:0.85s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$e4459b4f8c408015$var$shimmer};animation-timing-function:linear;background-color:${"var(--ds-background-neutral, #091E420F)"};background-image:linear-gradient( to right,${"var(--ds-background-neutral, #091E420F)"} 10%,${"var(--ds-background-neutral, #091E420F)"} 20%,${"var(--ds-background-neutral, #091E420F)"} 30% );background-repeat:no-repeat;border-radius:${"var(--ds-radius-small, 4px)"};visibility:${(props)=>props.invisible ? 'hidden' : 'visible'};:not(:last-child),:only-child{flex:1;}:last-child{margin-left:${"var(--ds-space-200, 16px)"};width:24px;margin-right:${"var(--ds-space-050, 4px)"};}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e4459b4f8c408015$var$FilterLinksHeading = /*#__PURE__*/ (0, $cdbP5.default).p.withConfig({
    componentId: "sc-1xw97h-6"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    color: "var(--ds-text-subtlest, #626F86)",
    paddingLeft: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$FilterTitleToolipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $e4459b4f8c408015$var$FilterTitle = /*#__PURE__*/ (0, $cdbP5.default).p.withConfig({
    componentId: "sc-1xw97h-7"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};text-transform:none;color:${"var(--ds-text, #172B4D)"};text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding:${"var(--ds-space-050, 4px)"} 0;padding-left:${"var(--ds-space-050, 4px)"};`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$FilterCountBadge = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-8"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};box-sizing:border-box;background:${"var(--ds-background-neutral, #091E420F)"};align-content:center;padding:1px ${"var(--ds-space-025, 2px)"} 0;border-radius:${"var(--ds-radius-full, 9999px)"};text-transform:none;margin:${$e4459b4f8c408015$var$hoverStateTopBottomPadding}px;width:30px;min-width:30px;height:16px;text-align:center;color:${"var(--ds-text, #172B4D)"};::after{content:'${({ count: count })=>parseInt(count, 10) > 99 ? '99+' : count}';}`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$ErrorSkeleton = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-9"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};display:flex;justify-content:space-between;align-items:center;margin-top:0;text-transform:none;height:${(props)=>props.height ? `${props.height}px` : '22px'};background-color:${"var(--ds-background-neutral, #091E420F)"};border-radius:${"var(--ds-radius-small, 4px)"};max-width:100%;width:100%;overflow-y:hidden;:not(:last-child),:only-child{padding:0 ${"var(--ds-space-050, 4px)"};}:last-child:not(:only-child){margin-left:${"var(--ds-space-200, 16px)"};width:24px;justify-content:center;}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$FilterShortCutsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4459b4f8c408015$var$ErrorMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e4459b4f8c408015$export$8b251419efc915eb = /*#__PURE__*/ (0, $cdbP5.default)((0, $cOzpJ.LinkWithAnalytics)).withConfig({
    componentId: "sc-1xw97h-10"
})({
    textAlign: 'left',
    color: 'inherit',
    width: '100%',
    /* Total margin needed is 28px. We reserve 14px to the subheading for line height.
   */ marginBottom: "var(--ds-space-150, 12px)",
    /* Pull the header back one grid space, as it must partly overlap with the left border bar */ marginLeft: `-${8 + $e4459b4f8c408015$var$gutterLeftRightPullback}px`,
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        color: 'inherit',
        textDecoration: 'none'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e4459b4f8c408015$export$5e51488ddda0709f = /*#__PURE__*/ (0, $cdbP5.default)($e4459b4f8c408015$var$ContentRow).withConfig({
    componentId: "sc-1xw97h-11"
})({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    margin: 0,
    height: '28px',
    alignItems: 'center',
    paddingRight: "var(--ds-space-150, 12px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e4459b4f8c408015$export$741c5897273b6f8f = /*#__PURE__*/ (0, $cdbP5.default)((0, $goZPP.default)).withConfig({
    componentId: "sc-1xw97h-12"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingTop: `${$e4459b4f8c408015$var$gutterTopPullback + 2}px !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBottom: `${$e4459b4f8c408015$var$hoverStateTopBottomPadding}px !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    paddingLeft: `${"var(--ds-space-050, 4px)"} !important`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $e4459b4f8c408015$export$c61a4e797b95e6b6 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1xw97h-13"
})({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #626F86)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    paddingLeft: `${"var(--ds-space-050, 4px)"} !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:first-of-type': {
        marginTop: "var(--ds-space-100, 8px)",
        marginBottom: "var(--ds-space-100, 8px)"
    }
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e4459b4f8c408015$export$e6b205d0cc70fa15 = /*#__PURE__*/ (0, $cdbP5.default)((0, $cOzpJ.LinkWithAnalytics)).withConfig({
    componentId: "sc-1xw97h-14"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-block',
    color: 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        color: 'inherit',
        textDecoration: 'none'
    },
    padding: "var(--ds-space-050, 4px)"
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e4459b4f8c408015$export$79f6f15df797f8df = /*#__PURE__*/ (0, $cdbP5.default)((0, $cOzpJ.LinkWithAnalytics)).withConfig({
    componentId: "sc-1xw97h-15"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};flex:1;display:flex;max-width:100%;justify-content:space-between;align-items:center;${'' /* eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage */ } border-radius:${"var(--ds-radius-small, 3px)"};text-decoration:none !important;padding:0;&:hover{background-color:${"var(--ds-background-neutral-hovered, #091E4224)"};}> ${$e4459b4f8c408015$var$LoadingBarSkeleton}:not(:last-child){margin-left:0;}`;

});
parcelRegister("iiqPE", function(module, exports) {
$parcel$export(module.exports, "types", () => $7dd61529f9e76961$export$b14ad400b1d09e0f);
$parcel$export(module.exports, "general", () => $7dd61529f9e76961$export$78b80bc2f5d4953a);
$parcel$export(module.exports, "boards", () => $7dd61529f9e76961$export$bdc70c7d78b01954);
$parcel$export(module.exports, "state", () => $7dd61529f9e76961$export$ca000e230c0caa3e);
$parcel$export(module.exports, "heading", () => $7dd61529f9e76961$export$46e4a324ac90507f);

var $7qGN1 = parcelRequire("7qGN1");
const $7dd61529f9e76961$export$b14ad400b1d09e0f = (0, $7qGN1.defineMessages)({
    business: {
        "id": "deep-dive-cards-section.common.business",
        "defaultMessage": "business"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    service_desk: {
        "id": "deep-dive-cards-section.common.service-project",
        "defaultMessage": "service"
    },
    software: {
        "id": "deep-dive-cards-section.common.software",
        "defaultMessage": "software"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    product_discovery: {
        "id": "deep-dive-cards-section.common.product_discovery",
        "defaultMessage": "product discovery"
    }
});
const $7dd61529f9e76961$export$78b80bc2f5d4953a = (0, $7qGN1.defineMessages)({
    queue: {
        "id": "deep-dive-cards-section.common.queue",
        "defaultMessage": "{numberBoards} {numberBoards, plural, one {queue} other {queues}}"
    },
    board: {
        "id": "deep-dive-cards-section.common.board",
        "defaultMessage": "{numberBoards} {numberBoards, plural, one {board} other {boards}}"
    },
    views: {
        "id": "deep-dive-cards-section.common.views",
        "defaultMessage": "{numberBoards} {numberBoards, plural, one {view} other {views}}"
    }
});
const $7dd61529f9e76961$export$bdc70c7d78b01954 = (0, $7qGN1.defineMessages)({
    companyManagedBusiness: {
        "id": "deep-dive-cards-section.common.company-managed-business",
        "defaultMessage": "Company-managed business"
    },
    teamManagedBusiness: {
        "id": "deep-dive-cards-section.common.team-managed-business",
        "defaultMessage": "Team-managed business"
    },
    companyManagedServiceManagement: {
        "id": "deep-dive-cards-section.common.company-managed-service-management",
        "defaultMessage": "Service management"
    },
    teamManagedServiceManagement: {
        "id": "deep-dive-cards-section.common.team-managed-service-management",
        "defaultMessage": "Team-managed service management"
    },
    companyManagedSoftware: {
        "id": "deep-dive-cards-section.common.company-managed-software",
        "defaultMessage": "Company-managed software"
    },
    teamManagedSoftware: {
        "id": "deep-dive-cards-section.common.team-managed-software",
        "defaultMessage": "Team-managed software"
    },
    productDiscovery: {
        "id": "deep-dive-cards-section.common.product-discovery",
        "defaultMessage": "Product Discovery"
    },
    customerService: {
        "id": "deep-dive-cards-section.common.customer-service",
        "defaultMessage": "Customer service"
    }
});
const $7dd61529f9e76961$export$ca000e230c0caa3e = (0, $7qGN1.defineMessages)({
    error: {
        "id": "deep-dive-cards-section.common.error",
        "defaultMessage": "Failed to retrieve project data"
    },
    errorCount: {
        "id": "deep-dive-cards-section.common.error-count",
        "defaultMessage": "Couldn't retrieve count"
    },
    errorGalaxia: {
        "id": "deep-dive-cards-section.common.error-galaxia",
        "defaultMessage": "Failed to retrieve space data"
    }
});
const $7dd61529f9e76961$export$46e4a324ac90507f = (0, $7qGN1.defineMessages)({
    queuesHeading: {
        "id": "deep-dive-cards-section.common.queues-heading",
        "defaultMessage": "Recent queues"
    },
    boardsHeading: {
        "id": "deep-dive-cards-section.common.boards-heading",
        "defaultMessage": "Quick links"
    }
});

});

parcelRegister("dxHqx", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuContent", () => $b8943ae726346c82$export$6e76d93a37c01248);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $f58rc = parcelRequire("f58rc");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $33rvr = parcelRequire("33rvr");
const $b8943ae726346c82$var$BoardDropdownItemComponentLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>// This was added as part of BLU-8308 to fix required children a11y violation
    /*#__PURE__*/ $eJOHy.createElement("div", {
        role: "menuitem"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $f58rc.default), {
        ...props,
        ref: ref,
        testId: "deep-dive-cards-section.ui.deep-dive-card.dropdown-content.deep-dive-card-content-dropdown-content-item-link"
    }, children)));
const $b8943ae726346c82$var$BoardDropdownItemComponent = ({ project: project, content: content, href: href, type: type, children: children, parent: parent })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleOnClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'deepDiveCardLinkBoard', {
            projectType: project.projectType,
            boardType: type,
            nextGen: project.isSimplified
        });
    };
    return (children?.length ?? 0) > 0 ? /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $b8943ae726346c82$var$dropdownItemGroupStyles
    }, /*#__PURE__*/ $eJOHy.createElement((0, $lmgo6.default), {
        "aria-level": 2,
        xcss: $b8943ae726346c82$var$dropdownItemGroupHeadingStyles,
        alignItems: "center",
        gap: "space.025"
    }, content, " ", /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
        spacing: "compact",
        label: "",
        size: "small"
    })), children?.map((props, index)=>/*#__PURE__*/ $eJOHy.createElement($b8943ae726346c82$var$BoardDropdownItemComponent, {
            ...props,
            project: project,
            key: index,
            parent: content
        }))) : /*#__PURE__*/ $eJOHy.createElement((0, $jYYbf.default), {
        testId: "deep-dive-cards-section.ui.deep-dive-card.dropdown-content.deep-dive-card-content-dropdown-content",
        href: href,
        onClick: handleOnClick,
        component: $b8943ae726346c82$var$BoardDropdownItemComponentLink,
        ...parent && {
            'aria-description': formatMessage((0, $33rvr.default).parentGroupLabel, {
                parent: parent
            })
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $b8943ae726346c82$var$dropdownItemTitleStyles,
        padding: "space.050"
    }, content));
};
const $b8943ae726346c82$export$6e76d93a37c01248 = ({ data: data, project: project })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $b8943ae726346c82$var$dropdownMenuHeightStyles
    }, /*#__PURE__*/ $eJOHy.createElement((0, $aLJ1L.default), null, data.map((props, index)=>/*#__PURE__*/ $eJOHy.createElement($b8943ae726346c82$var$BoardDropdownItemComponent, {
            ...props,
            project: project,
            key: index
        }))));
};
const $b8943ae726346c82$var$dropdownMenuHeightStyles = (0, $1DXK0.xcss)({
    maxHeight: '400px'
});
const $b8943ae726346c82$var$dropdownItemGroupStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $b8943ae726346c82$var$dropdownItemGroupHeadingStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $b8943ae726346c82$var$dropdownItemTitleStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("33rvr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e0be1385d0eaa80$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0e0be1385d0eaa80$var$messages = (0, $7qGN1.defineMessages)({
    parentGroupLabel: {
        "id": "deep-dive-cards-section.deep-dive-card.dropdown-content.parent-group-label",
        "defaultMessage": ", {parent} group"
    }
});
var $0e0be1385d0eaa80$export$2e2bcd8739ae039 = $0e0be1385d0eaa80$var$messages;

});


parcelRegister("fYZMH", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0a999de2b3bef60$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d8UFE = parcelRequire("d8UFE");

var $3cMgR = parcelRequire("3cMgR");
const $b0a999de2b3bef60$var$ErrorIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }));
var $b0a999de2b3bef60$export$2e2bcd8739ae039 = $b0a999de2b3bef60$var$ErrorIcon;

});

parcelRegister("jx5O3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e909e2321d53dd7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8Hdu4 = parcelRequire("8Hdu4");

var $bQyn2 = parcelRequire("bQyn2");
const $5e909e2321d53dd7$var$HeaderIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e909e2321d53dd7$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e909e2321d53dd7$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Hdu4))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-inverse, #FFFFFF)"
            })),
        ...props
    }));
var $5e909e2321d53dd7$export$2e2bcd8739ae039 = $5e909e2321d53dd7$var$HeaderIcon;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e909e2321d53dd7$var$BackgroundContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kn0lb4i _1plvcdhy",
            __cmplp.className
        ])
    });
});
const $5e909e2321d53dd7$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _lpgrfajl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bQyn2", function(module, exports) {
$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $69a57831c94bcd51$var$defaultIconSize = 16;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rkofajl _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});


parcelRegister("27w8y", function(module, exports) {
$parcel$export(module.exports, "useEffectFireErrorCallback", () => $f38d9395340b356a$export$f2d5117b499c0d9a);

var $eJOHy = parcelRequire("eJOHy");
const $f38d9395340b356a$export$f2d5117b499c0d9a = (error, callback)=>{
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $eJOHy.useEffect)(()=>{
        if (error === true) callback();
    }, [
        callback,
        error
    ]);
};

});



parcelRegister("eRr5N", function(module, exports) {
$parcel$export(module.exports, "EmptyStateDeepDiveCard", () => $128285dbfc88363b$export$47bb63588cd3246a);

var $eJOHy = parcelRequire("eJOHy");

var $5bY40 = parcelRequire("5bY40");

var $6MnLl = parcelRequire("6MnLl");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $9S5xC = parcelRequire("9S5xC");
const $128285dbfc88363b$export$47bb63588cd3246a = (props)=>{
    const viewAllProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9S5xC.default).viewAllProjectsGalaxia : (0, $9S5xC.default).viewAllProjects;
    const emptyStateDescriptionGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9S5xC.default).emptyStateDescriptionGalaxia : (0, $9S5xC.default).emptyStateDescription;
    const emptyStateHeaderGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9S5xC.default).emptyStateHeaderGalaxia : (0, $9S5xC.default).emptyStateHeader;
    const { projectsDirectoryUrl: projectsDirectoryUrl, actionSubjectId: actionSubjectId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        description: formatMessage(emptyStateDescriptionGalaxia),
        header: formatMessage(emptyStateHeaderGalaxia),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
            appearance: "primary",
            href: projectsDirectoryUrl,
            onClick: (_, analyticsEvent)=>(0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId)
        }, formatMessage(viewAllProjectsGalaxia))
    });
};

});
parcelRegister("9S5xC", function(module, exports) {
$parcel$export(module.exports, "default", () => $852ce5fd8839d372$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $852ce5fd8839d372$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        "id": "deep-dive-cards-section.empty-state.empty-state-header",
        "defaultMessage": "No projects found"
    },
    emptyStateDescription: {
        "id": "deep-dive-cards-section.empty-state.empty-state-description",
        "defaultMessage": "You have no recently viewed projects"
    },
    viewAllProjects: {
        "id": "deep-dive-cards-section.empty-state.view-all-projects",
        "defaultMessage": "View all projects"
    },
    emptyStateHeaderGalaxia: {
        "id": "deep-dive-cards-section.empty-state.empty-state-header-galaxia",
        "defaultMessage": "No spaces found"
    },
    emptyStateDescriptionGalaxia: {
        "id": "deep-dive-cards-section.empty-state.empty-state-description-galaxia",
        "defaultMessage": "You have no recently viewed spaces"
    },
    viewAllProjectsGalaxia: {
        "id": "deep-dive-cards-section.empty-state.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    }
});
var $852ce5fd8839d372$export$2e2bcd8739ae039 = $852ce5fd8839d372$var$messages;

});


parcelRegister("k5FRD", function(module, exports) {
$parcel$export(module.exports, "default", () => $be9e269f016ea466$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $be9e269f016ea466$var$messages = (0, $7qGN1.defineMessages)({
    viewAll: {
        "id": "deep-dive-cards-section.view-all",
        "defaultMessage": "View all projects"
    },
    viewAllGalaxia: {
        "id": "deep-dive-cards-section.view-all-galaxia",
        "defaultMessage": "View all spaces"
    }
});
var $be9e269f016ea466$export$2e2bcd8739ae039 = $be9e269f016ea466$var$messages;

});


parcelRegister("8OZBC", function(module, exports) {
$parcel$export(module.exports, "InitialDataLoader", () => $4d40f418f2e9d5c7$export$867ec025b81eadf3);

var $eJOHy = parcelRequire("eJOHy");

var $qzoYE = parcelRequire("qzoYE");

var $02OvK = parcelRequire("02OvK");
const $4d40f418f2e9d5c7$export$867ec025b81eadf3 = ()=>{
    const [, { loadRecentBoards: loadRecentBoards }] = (0, $qzoYE.useRecentActions)();
    const hasFetchedAll = (0, $eJOHy.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $02OvK.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentBoards();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentBoards
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $eJOHy.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};

});

parcelRegister("2nbRu", function(module, exports) {
$parcel$export(module.exports, "getRecentProjects", () => $3a016921868ceb85$export$1c7075484f95c574);
$parcel$export(module.exports, "getRecent2QueuesByRecentProjects", () => $3a016921868ceb85$export$a4ff28ddf0faba03);


var $4cTDP = parcelRequire("4cTDP");
const $3a016921868ceb85$var$getRecentlyViewedItemsByType = (prefetchResult, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
type)=>{
    if (prefetchResult && prefetchResult.data && prefetchResult.data.tabs.RecentlyViewed && prefetchResult.data.tabs.RecentlyViewed.data) {
        const recentlyViewedSections = prefetchResult.data.tabs.RecentlyViewed.data.sections;
        // TODO: flatten
        let recentItemInfo = [];
        for(let i = 0; i < recentlyViewedSections.length; i += 1)recentItemInfo = recentItemInfo.concat(recentlyViewedSections[i] ? recentlyViewedSections[i].items : []);
        return recentItemInfo.filter((item)=>item.type === type) || [];
    }
    return [];
};
const $3a016921868ceb85$var$getTop2RecentQueues = (prefetchResult, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
containerId)=>{
    const recentQueuesInfo = $3a016921868ceb85$var$getRecentlyViewedItemsByType(prefetchResult, 'queues').filter((item)=>item.attributes && item.attributes.projectId !== undefined ? item.attributes.projectId === containerId : false).slice(0, 2);
    return recentQueuesInfo || [];
};
const $3a016921868ceb85$export$3dd0da95519c1a33 = (subtitle)=>{
    switch(subtitle){
        case 'Service Desk':
        case 'Service':
            return 'service_desk';
        case 'Business':
            return 'business';
        case 'Product Discovery':
            return 'product_discovery';
        case 'Customer Service':
            if ((0, $4cTDP.fg)('csm_rename_jcs_to_csm')) return 'customer_service';
            return 'software';
        default:
            return 'software';
    }
};
const $3a016921868ceb85$export$1c7075484f95c574 = (prefetchResult)=>{
    if (typeof prefetchResult === 'undefined') return [];
    const top5recentProjects = $3a016921868ceb85$var$getRecentlyViewedItemsByType(prefetchResult, 'projects').slice(0, (0, $10796b75b11e0d43$export$332af86e8819810d));
    return top5recentProjects.map((project)=>{
        const projectUrlSplit = project.url.split('/');
        const projectKey = projectUrlSplit[projectUrlSplit.length - 1];
        return {
            projectName: project.title,
            projectType: $3a016921868ceb85$export$3dd0da95519c1a33(project.subtitle),
            avatarUrl: project.avatarUrl != null ? project.avatarUrl : '',
            href: project.url,
            isSimplified: project.attributes && project.attributes.nextgen ? project.attributes.nextgen === 'true' : false,
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            id: parseInt(project.entityId, 10),
            key: projectKey
        };
    });
};
const $3a016921868ceb85$export$a4ff28ddf0faba03 = (prefetchResult, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
recentProjects)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queuesByProjectId = {};
    recentProjects.filter((project)=>project.projectType === 'service_desk' || project.projectType === 'customer_service' && (0, $4cTDP.fg)('csm_rename_jcs_to_csm')).map((project)=>{
        queuesByProjectId[`project_${project.id}`] = $3a016921868ceb85$var$getTop2RecentQueues(prefetchResult, project.id.toString()).map((queue)=>({
                id: queue.id,
                title: queue.title,
                href: queue.url
            }));
        return null;
    });
    return queuesByProjectId;
};

});


parcelRegister("bQ87J", function(module, exports) {
$parcel$export(module.exports, "RightPanelLayout", () => $bb00d9a335fd93c0$export$a7d20bf2046a1cc3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $9SHd3 = parcelRequire("9SHd3");

var $48BUe = parcelRequire("48BUe");
const $bb00d9a335fd93c0$export$a7d20bf2046a1cc3 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bb00d9a335fd93c0$var$FlexLayoutWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bb00d9a335fd93c0$var$LayoutLeft, {
        rightPanelWidth: (0, $48BUe.RIGHT_PANEL_WIDTH)
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9SHd3.AsyncRightPanel), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb00d9a335fd93c0$var$FlexLayoutWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $bb00d9a335fd93c0$var$LayoutLeft = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { rightPanelWidth: rightPanelWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3vrhrb": (0, $awdRS.default)(`calc(100% - ${__cmplp.rightPanelWidth}px)`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1ule _ca0qidpf _u5f31jfw _n3tdidpf _19bv1jfw _vchhusvi _1bsb101u _16jlkb7n _1ul91fdn _18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9SHd3", function(module, exports) {
$parcel$export(module.exports, "AsyncRightPanel", () => $a0b157e685519745$export$7ef72c7d51d7de1e);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

var $48BUe = parcelRequire("48BUe");

const $a0b157e685519745$var$LazyRightSidePanel = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6dNjh")), {
    moduleId: "./src/packages/jira-home-right-side-panel/src/index.tsx"
});
const $a0b157e685519745$export$7ef72c7d51d7de1e = ()=>{
    const startExperience = (0, $8Uqf3.useExperienceStart)((0, $48BUe.RIGHT_SIDE_PANEL_EXPERIENCE));
    const onFail = (0, $aqnJa.useExperienceFail)((0, $48BUe.RIGHT_SIDE_PANEL_EXPERIENCE));
    (0, $eJOHy.useEffect)(()=>{
        startExperience();
    }, [
        startExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "right-side-panel",
        packageName: "jira-home-right-side-panel",
        fallback: "unmount",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-jira-home-right-side-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a0b157e685519745$var$LazyRightSidePanel, null)));
};

});
parcelRegister("6dNjh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("jxqpM").then(()=>parcelRequire('95dZm'));

});



parcelRegister("lUeDZ", function(module, exports) {
$parcel$export(module.exports, "TabContainerFF", () => $a1f046bcf0604bd1$export$f4d059bdea6484b1);
/* tab-container-ff.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $huH03 = parcelRequire("huH03");

var $7q9BG = parcelRequire("7q9BG");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cpHe2 = parcelRequire("cpHe2");
var $41h42 = parcelRequire("41h42");
var $7oCv0 = parcelRequire("7oCv0");
var $2cSdF = parcelRequire("2cSdF");

var $5vQ2T = parcelRequire("5vQ2T");

var $3MbOI = parcelRequire("3MbOI");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $bXOg3 = parcelRequire("bXOg3");

var $2kUzW = parcelRequire("2kUzW");

var $dYdRZ = parcelRequire("dYdRZ");

var $8HNzX = parcelRequire("8HNzX");
const $a1f046bcf0604bd1$var$getItemCounts = (tabConfig, prefetchResult)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(prefetchResult?.data?.tabs || {}, (tab)=>tab?.data?.total);
const $a1f046bcf0604bd1$export$f4d059bdea6484b1 = ({ defaultSelected: defaultSelected, prefetchResult: prefetchResult, tabConfigs: tabConfigs, services: services, onTabChange: onTabChange })=>{
    const currentUserData = (0, $3MbOI.useCurrentUser)();
    const [maxItemsToShow, setMaxItemsToShow] = (0, $eJOHy.useState)((0, $bXOg3.MAX_ITEMS_PER_PAGE));
    const [itemCounts, setItemCounts] = (0, $eJOHy.useState)(()=>$a1f046bcf0604bd1$var$getItemCounts(tabConfigs, prefetchResult));
    const [selectedTabId, setSelectedTabId] = (0, $eJOHy.useState)(defaultSelected.id);
    const tabConfigsWithTotal = tabConfigs.map((config)=>({
            ...config,
            total: itemCounts[config.provider]
        }));
    const initialSelectedConfigIndex = tabConfigsWithTotal.findIndex((config)=>config.id === selectedTabId);
    const [selectedConfigIndex, setSelectedConfigIndex] = (0, $eJOHy.useState)(initialSelectedConfigIndex);
    (0, $eJOHy.useEffect)(()=>{
        if (defaultSelected.id !== selectedTabId) {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setSelectedTabId(defaultSelected.id);
            const _selectedConfigIndex = tabConfigsWithTotal.findIndex((config)=>config.id === defaultSelected.id);
            setSelectedConfigIndex(_selectedConfigIndex);
        }
    }, [
        defaultSelected.id,
        selectedTabId,
        tabConfigsWithTotal
    ]);
    const onTotalChange = (0, $eJOHy.useCallback)((providerKeyOrId, total)=>{
        setItemCounts((prevItemCounts)=>({
                ...prevItemCounts,
                [providerKeyOrId]: total
            }));
    }, []);
    const onMoreItemsRequested = (0, $eJOHy.useCallback)(()=>{
        setMaxItemsToShow((prevMaxItemsToShow)=>prevMaxItemsToShow + (0, $bXOg3.MAX_ITEMS_PER_PAGE));
    }, []);
    const handleUpdate = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        const selected = tabConfigs[index];
        setSelectedTabId(selected.id);
        selected.onClickCallback?.();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly assigned: Metric; readonly workedon: Metric; readonly viewed: Metric; readonly starred: Metric; }'.
        (0, $dYdRZ.interactionMetrics)[selected.id].start();
        onTabChange(selected.id);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'listItemsTab', {
            itemTab: selected.id
        });
    }, [
        tabConfigs,
        onTabChange
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setItemCounts($a1f046bcf0604bd1$var$getItemCounts(tabConfigs, prefetchResult));
    }, [
        tabConfigs,
        prefetchResult
    ]);
    if (typeof services === 'undefined') throw new Error('Services not configured for Your work tab container.');
    const renderTab = (config)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string | number' can't be used to index type 'Services'.
        const Provider = services[config.provider];
        const { tabContent: Content } = config;
        const selectedConfig = tabConfigsWithTotal[selectedConfigIndex];
        const isSelected = typeof selectedConfig !== 'undefined' && config.id === selectedConfig.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
            key: config.label,
            attributes: {
                itemTab: config.id
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            id: "tab",
            packageName: "jiraHome",
            fallback: ()=>isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kUzW.default), null) : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Provider, {
            id: config.id,
            providerKey: config.provider,
            prefetchResult: prefetchResult,
            selected: isSelected,
            onTotalChange: onTotalChange,
            userProviderData: currentUserData
        }, (providerResult)=>{
            if (!isSelected) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a1f046bcf0604bd1$var$TabContentContainer, null, providerResult?.updateAvailable && providerResult?.update && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8HNzX.LoadNewActivityButton), {
                configId: selectedConfig?.id,
                onUpdate: providerResult.update
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, {
                itemProviderResult: providerResult,
                maxItems: maxItemsToShow,
                onLoadMoreClick: maxItemsToShow === (0, $bXOg3.MAX_ITEMS_PER_PAGE) ? onMoreItemsRequested : undefined
            }));
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "jiraHomeTab",
        attributes: {
            itemTab: defaultSelected.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a1f046bcf0604bd1$var$TabWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "global-pages.home.ui.tab-container.navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpHe2.default), {
        id: "your-work-page-tabs",
        onChange: handleUpdate,
        selected: selectedConfigIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7oCv0.default), null, tabConfigsWithTotal.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $41h42.default), {
            testId: `global-pages.home.ui.tab-container.navigation.item.${tab.id}`,
            key: tab.id
        }, tab.label, tab.showCount && (typeof tab.total !== 'number' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a1f046bcf0604bd1$var$BadgeSkeleton, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a1f046bcf0604bd1$var$BadgeStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
            max: 99
        }, tab.total)))))), tabConfigsWithTotal.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cSdF.default), {
            key: tab.id
        }, renderTab(tab)))))));
};
const $a1f046bcf0604bd1$var$BadgeSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $a1f046bcf0604bd1$var$BadgeSkeletonStyles
    }, "\xa0\xa0");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1f046bcf0604bd1$var$TabWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $a1f046bcf0604bd1$var$BadgeSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.hovered',
    color: 'color.text',
    borderRadius: 'radius.full',
    display: 'inline-block',
    font: 'font.body.UNSAFE_small',
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    minWidth: "var(--ds-space-025, 2px)",
    paddingBlock: 'space.050',
    paddingInline: 'space.075',
    textAlign: 'center',
    marginLeft: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1f046bcf0604bd1$var$BadgeStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01c1a",
            __cmplp.className
        ])
    });
});
const $a1f046bcf0604bd1$var$TabContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1bsb1osq _ca0qidpf _u5f3idpf _n3td12x7 _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});

parcelRegister("cpHe2", function(module, exports) {
$parcel$export(module.exports, "default", () => $03090e4bd6ee746b$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $4OxCz = parcelRequire("4OxCz");
const $03090e4bd6ee746b$var$baseStyles = null;
const $03090e4bd6ee746b$var$tabsStyles = null;
const $03090e4bd6ee746b$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $03090e4bd6ee746b$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $03090e4bd6ee746b$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eJOHy.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eJOHy.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $eJOHy.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$03090e4bd6ee746b$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $03090e4bd6ee746b$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$03090e4bd6ee746b$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $03090e4bd6ee746b$export$2e2bcd8739ae039 = $03090e4bd6ee746b$var$Tabs;

});
parcelRegister("4OxCz", function(module, exports) {
$parcel$export(module.exports, "TabContext", () => $079a819a44225d4e$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $079a819a44225d4e$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $079a819a44225d4e$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eJOHy = parcelRequire("eJOHy");
const $079a819a44225d4e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$2054129d247c3102 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});


parcelRegister("41h42", function(module, exports) {
$parcel$export(module.exports, "default", () => $c693230e7a8a8f94$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");
var $3cMgR = parcelRequire("3cMgR");

var $lcHWu = parcelRequire("lcHWu");
/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $c693230e7a8a8f94$var$Tab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $lcHWu.useTab)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1,
            children: children
        })
    });
});
var $c693230e7a8a8f94$export$2e2bcd8739ae039 = $c693230e7a8a8f94$var$Tab;

});
parcelRegister("lcHWu", function(module, exports) {
$parcel$export(module.exports, "useTab", () => $91221b4997543842$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $91221b4997543842$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $91221b4997543842$export$fae0121b5afe572d);

var $eJOHy = parcelRequire("eJOHy");

var $4OxCz = parcelRequire("4OxCz");
const $91221b4997543842$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eJOHy.useContext)((0, $4OxCz.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $91221b4997543842$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eJOHy.useContext)((0, $4OxCz.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $91221b4997543842$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eJOHy.useContext)((0, $4OxCz.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("7oCv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b96e2c7b7779acd6$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lcHWu = parcelRequire("lcHWu");

var $4OxCz = parcelRequire("4OxCz");
const $b96e2c7b7779acd6$var$baseStyles = null;
const $b96e2c7b7779acd6$var$tabListStyles = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b96e2c7b7779acd6$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $lcHWu.useTabList)();
    const ref = /*#__PURE__*/ (0, $eJOHy.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eJOHy.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eJOHy.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eJOHy.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8wxv _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8wxv _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmzwg2n _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $b96e2c7b7779acd6$export$2e2bcd8739ae039 = $b96e2c7b7779acd6$var$TabList;

});

parcelRegister("2cSdF", function(module, exports) {
$parcel$export(module.exports, "default", () => $9291670942049679$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");

var $lcHWu = parcelRequire("lcHWu");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $9291670942049679$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $lcHWu.useTabPanel)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
            children: children
        })
    });
};
var $9291670942049679$export$2e2bcd8739ae039 = $9291670942049679$var$TabPanel;

});

parcelRegister("2kUzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6cb9f7b8088f5cc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");

var $lRq8t = parcelRequire("lRq8t");

var $kGE5V = parcelRequire("kGE5V");

var $8h1Tf = parcelRequire("8h1Tf");
const $a6cb9f7b8088f5cc$var$emptyStateMaxImageWidth = 300;
const $a6cb9f7b8088f5cc$var$emptyStateMaxImageHeight = 250;
const $a6cb9f7b8088f5cc$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6cb9f7b8088f5cc$var$ErrorWrapper, {
        "data-test-id": "global-pages.home.common.ui.error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $8h1Tf.default).errorHeader),
        description: formatMessage((0, $8h1Tf.default).errorDescription),
        maxImageWidth: $a6cb9f7b8088f5cc$var$emptyStateMaxImageWidth,
        maxImageHeight: $a6cb9f7b8088f5cc$var$emptyStateMaxImageHeight,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kGE5V)))
    }));
};
var $a6cb9f7b8088f5cc$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a6cb9f7b8088f5cc$export$c1ed4f415b9e7023;
const $a6cb9f7b8088f5cc$var$ErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pk1epz _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kGE5V", function(module, exports) {
module.exports = new URL("something-wrong.d63c486f.svg", import.meta.url).toString();

});

parcelRegister("8h1Tf", function(module, exports) {
$parcel$export(module.exports, "default", () => $67fc0628c23b7cdd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $67fc0628c23b7cdd$var$messages = (0, $7qGN1.defineMessages)({
    errorHeader: {
        "id": "home.common.error-state.error-header",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "home.common.error-state.error-description",
        "defaultMessage": "We couldn\u2019t load your work, try refreshing the page."
    }
});
var $67fc0628c23b7cdd$export$2e2bcd8739ae039 = $67fc0628c23b7cdd$var$messages;

});


parcelRegister("8HNzX", function(module, exports) {
$parcel$export(module.exports, "LoadNewActivityButton", () => $664e6ac4dc71374d$export$c64f2bbc2488e6f6);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $fqBT3 = parcelRequire("fqBT3");
const $664e6ac4dc71374d$export$c64f2bbc2488e6f6 = ({ configId: configId, onUpdate: onUpdate })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'loadNewActivityButton', {
            itemTab: configId
        });
        return onUpdate();
    }, [
        configId,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $664e6ac4dc71374d$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: onClick,
        spacing: "compact"
    }, formatMessage((0, $fqBT3.default).loadMoreButton)));
};
const $664e6ac4dc71374d$var$wrapperStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    left: '50%',
    top: "var(--ds-space-150, 12px)",
    transform: 'translateX(-50%)'
});

});
parcelRegister("fqBT3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e595cd802bb5ef29$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e595cd802bb5ef29$var$messages = (0, $7qGN1.defineMessages)({
    loadMoreButton: {
        "id": "home.tab-container.load-more-button",
        "defaultMessage": "Load new activity"
    }
});
var $e595cd802bb5ef29$export$2e2bcd8739ae039 = $e595cd802bb5ef29$var$messages;

});



parcelRegister("eDNZI", function(module, exports) {
$parcel$export(module.exports, "servicesNav4", () => $7d3bbdc4c1b883e2$export$7d212612d49b138f);
$parcel$export(module.exports, "getWorkSuggestionsTab", () => $7d3bbdc4c1b883e2$export$9465c8bf56d20449);
$parcel$export(module.exports, "getTabConfigToUse", () => $7d3bbdc4c1b883e2$export$ca47564769b7ed90);

var $eJOHy = parcelRequire("eJOHy");

var $26U8a = parcelRequire("26U8a");

var $3ZJvm = parcelRequire("3ZJvm");

var $4cTDP = parcelRequire("4cTDP");

var $fYeTG = parcelRequire("fYeTG");

var $hbF3h = parcelRequire("hbF3h");

var $2wake = parcelRequire("2wake");

var $lYC3t = parcelRequire("lYC3t");

var $7KbdA = parcelRequire("7KbdA");

var $fXBb1 = parcelRequire("fXBb1");

var $cPmvw = parcelRequire("cPmvw");

var $bXOg3 = parcelRequire("bXOg3");

var $c9Dvb = parcelRequire("c9Dvb");

var $an44q = parcelRequire("an44q");

var $kKDcQ = parcelRequire("kKDcQ");
const $7d3bbdc4c1b883e2$export$bce7a36871692cab = {
    WorkedOn: (0, $fXBb1.default),
    RecentlyViewed: (0, $cPmvw.default),
    AssignedToUser: (0, $2wake.default),
    Favourites: (0, $7KbdA.default),
    WorkSuggestions: (0, $c9Dvb.WorkSuggestionsProvider)
};
const $7d3bbdc4c1b883e2$export$7d212612d49b138f = {
    ...$7d3bbdc4c1b883e2$export$bce7a36871692cab,
    Boards: (0, $lYC3t.BoardsProvider)
};
const $7d3bbdc4c1b883e2$export$9465c8bf56d20449 = (entryPointSubject, onClickCallback)=>({
        id: (0, $bXOg3.WORK_SUGGESTIONS_TAB_KEY),
        provider: 'WorkSuggestions',
        showCount: false,
        tabContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKDcQ.WorkSuggestionsTab), {
                entryPointReferenceSubject: entryPointSubject
            }),
        onClickCallback: onClickCallback
    });
const $7d3bbdc4c1b883e2$var$getTabConfigToUseWithMobileViewTab = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>(0, $fYeTG.isMobileAndInViewPanelIterationExperiment)(),
        ()=>(0, $an44q.MOBILE_WEB_WITH_VIEWED_TABS)
    ],
    [
        ()=>(0, $fYeTG.isMobileAndInMVPExperiment)(),
        ()=>(0, $an44q.MOBILE_WEB_TABS)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        ()=>(0, $an44q.NAV_V4_TABS)
    ]
]);
const $7d3bbdc4c1b883e2$var$getTabConfigToUseWithoutMobileViewTab = ()=>{
    const isMobileWebAndInMVPExperiment = (0, $fYeTG.isMobileAndInMVPExperiment)();
    const tabConfigForNav = (0, $an44q.NAV_V4_TABS);
    return isMobileWebAndInMVPExperiment ? (0, $an44q.MOBILE_WEB_TABS) : tabConfigForNav;
};
const $7d3bbdc4c1b883e2$export$ca47564769b7ed90 = (0, $hbF3h.functionWithCondition)(()=>(0, $4cTDP.fg)('jira_mobile_web_mvp_view_panel_kill_switch'), $7d3bbdc4c1b883e2$var$getTabConfigToUseWithMobileViewTab, $7d3bbdc4c1b883e2$var$getTabConfigToUseWithoutMobileViewTab);

});
parcelRegister("lYC3t", function(module, exports) {
$parcel$export(module.exports, "BoardsProvider", () => $693ba0bdd1b1303b$export$d173a9c06120e0ea);
const $693ba0bdd1b1303b$export$d173a9c06120e0ea = (props)=>{
    const { children: children } = props;
    // The tab content fetches its own data using Relay, and lint rules/Relay conventions dictate that we can't put the query here.
    // This provider is just here so the rendering can be handled consistently with the other tabs.
    return children();
};

});

parcelRegister("c9Dvb", function(module, exports) {
$parcel$export(module.exports, "WorkSuggestionsProvider", () => $a29ecc29d1f04552$export$305be3485ca0add0);
const $a29ecc29d1f04552$export$305be3485ca0add0 = (props)=>{
    const { children: children } = props;
    // The tab content fetches its own data using Relay, and lint rules/Relay conventions dictate that we can't put the query here.
    // This provider is just here so the rendering can be handled consistently with the other tabs.
    return children();
};

});

parcelRegister("an44q", function(module, exports) {
$parcel$export(module.exports, "NAV_V4_TABS", () => $ba20f6a6b0d0b891$export$623b35c7f6c13df9);
$parcel$export(module.exports, "MOBILE_WEB_TABS", () => $ba20f6a6b0d0b891$export$cc8ba092fd696cd7);
$parcel$export(module.exports, "MOBILE_WEB_WITH_VIEWED_TABS", () => $ba20f6a6b0d0b891$export$e935d40964c03708);

var $bXOg3 = parcelRequire("bXOg3");

var $4fink = parcelRequire("4fink");

var $i30fK = parcelRequire("i30fK");

var $cfk79 = parcelRequire("cfk79");

var $jVvmk = parcelRequire("jVvmk");

var $7GdIW = parcelRequire("7GdIW");
const $ba20f6a6b0d0b891$export$d5876578efb48032 = [
    {
        id: (0, $bXOg3.WORKEDON_TAB_KEY),
        provider: 'WorkedOn',
        showCount: false,
        tabContent: (0, $7GdIW.default)
    },
    {
        id: (0, $bXOg3.VIEWED_TAB_KEY),
        provider: 'RecentlyViewed',
        showCount: false,
        tabContent: (0, $cfk79.default)
    },
    {
        id: (0, $bXOg3.ASSIGNED_TAB_KEY),
        provider: 'AssignedToUser',
        showCount: true,
        tabContent: (0, $4fink.default)
    },
    {
        id: (0, $bXOg3.STARRED_TAB_KEY),
        provider: 'Favourites',
        showCount: false,
        tabContent: (0, $jVvmk.default)
    }
].filter(Boolean);
const $ba20f6a6b0d0b891$export$623b35c7f6c13df9 = [
    ...$ba20f6a6b0d0b891$export$d5876578efb48032,
    ...[
        {
            id: (0, $bXOg3.BOARDS_TAB_KEY),
            provider: 'Boards',
            showCount: false,
            tabContent: (0, $i30fK.BoardsTab)
        }
    ].filter(Boolean)
];
const $ba20f6a6b0d0b891$export$cc8ba092fd696cd7 = [
    {
        id: (0, $bXOg3.WORKEDON_TAB_KEY),
        provider: 'WorkedOn',
        showCount: false,
        tabContent: (0, $7GdIW.default)
    },
    {
        id: (0, $bXOg3.ASSIGNED_TAB_KEY),
        provider: 'AssignedToUser',
        showCount: true,
        tabContent: (0, $4fink.default)
    }
];
const $ba20f6a6b0d0b891$export$e935d40964c03708 = [
    ...$ba20f6a6b0d0b891$export$cc8ba092fd696cd7,
    {
        id: (0, $bXOg3.VIEWED_TAB_KEY),
        provider: 'RecentlyViewed',
        showCount: false,
        tabContent: (0, $cfk79.default)
    }
];

});
parcelRegister("4fink", function(module, exports) {
$parcel$export(module.exports, "default", () => $c371c815bd29c3fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $4cTDP = parcelRequire("4cTDP");

var $8PC8K = parcelRequire("8PC8K");

var $lRq8t = parcelRequire("lRq8t");

var $fYeTG = parcelRequire("fYeTG");

var $5gjY4 = parcelRequire("5gjY4");

var $bXOg3 = parcelRequire("bXOg3");

var $bdEnF = parcelRequire("bdEnF");

var $2kUzW = parcelRequire("2kUzW");

var $7fGJN = parcelRequire("7fGJN");

var $3Nff7 = parcelRequire("3Nff7");

var $1SixK = parcelRequire("1SixK");

var $9aHHU = parcelRequire("9aHHU");

var $9LAjM = parcelRequire("9LAjM");

var $fQ03e = parcelRequire("fQ03e");

var $e6Ijt = parcelRequire("e6Ijt");

var $dUTrY = parcelRequire("dUTrY");
const $c371c815bd29c3fe$var$styles = {
    itemCounter: "_otyr1b66"
};
const $c371c815bd29c3fe$var$FOOTER_HREF = '/issues/?jql=assignee%20%3D%20currentUser()%20AND%20statusCategory%20in%20(2%2C%204)%20order%20by%20statusCategory%20DESC%2C%20updated%20DESC';
const $c371c815bd29c3fe$var$AssignedToMeTab = (props)=>{
    const { itemProviderResult: { data: data, error: error, loading: loading, reloading: reloading } } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(!!data.total, error, loading, 'assignedToMe');
    if (error && !data.total) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kUzW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.ASSIGNED_TAB_KEY),
        renderState: (0, $bXOg3.ERROR_STATE)
    }));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gjY4.YourWorkItemListSkeleton), null);
    if ((!data || !data.sections || data.sections.length === 0) && (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        header: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dUTrY.default).emptyStateHeaderIssueTermRefresh : (0, $dUTrY.default).emptyStateHeader),
        description: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dUTrY.default).emptyStateDescriptionIssueTermRefresh : (0, $dUTrY.default).emptyStateDescription),
        renderImage: ()=>// renderImage doesn't add an image wrapper whereas imageUrl does
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingBlockEnd: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8PC8K.default), {
                alt: "",
                width: 154
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.ASSIGNED_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    if (!data || !data.sections || data.sections.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        header: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dUTrY.default).emptyStateHeaderIssueTermRefresh : (0, $dUTrY.default).emptyStateHeader),
        description: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $dUTrY.default).emptyStateDescriptionIssueTermRefresh : (0, $dUTrY.default).emptyStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($e6Ijt)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.ASSIGNED_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    const footer = data.total && data.total > (0, $bXOg3.MAX_ITEMS_PER_PAGE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9aHHU.TabFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $c371c815bd29c3fe$var$styles.itemCounter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fGJN.default), {
        displayedCount: (0, $bXOg3.MAX_ITEMS_PER_PAGE),
        totalCount: data.total
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.LinkWithAnalytics), {
        href: $c371c815bd29c3fe$var$FOOTER_HREF,
        actionSubjectId: "viewAllAssignedToMeLink",
        appearance: "link",
        buttonLink: true
    }, formatMessage((0, $dUTrY.default).seeAllIssuesAssignedToMe))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, reloading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1SixK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nff7.default), {
        sections: (0, $fQ03e.trimItemsBySection)(props.maxItems, data.sections)
    }), footer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.ASSIGNED_TAB_KEY),
        renderState: (0, $bXOg3.SUCCESS_STATE)
    }));
};
var $c371c815bd29c3fe$export$2e2bcd8739ae039 = $c371c815bd29c3fe$var$AssignedToMeTab;

});
parcelRegister("8PC8K", function(module, exports) {
$parcel$export(module.exports, "default", () => $a142270097aebcb1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $kuuK8 = parcelRequire("kuuK8");

var $bUEQm = parcelRequire("bUEQm");
const $a142270097aebcb1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bUEQm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kuuK8)),
    autoDark: false
});
var $a142270097aebcb1$export$2e2bcd8739ae039 = $a142270097aebcb1$var$Illustration;

});
parcelRegister("kuuK8", function(module, exports) {
module.exports = new URL("empty-add-item-darkmode.3ed103f2.svg", import.meta.url).toString();

});

parcelRegister("bUEQm", function(module, exports) {
module.exports = new URL("empty-add-item.21249b5f.svg", import.meta.url).toString();

});


parcelRegister("bdEnF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef39447eb36ad4a6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");
const $ef39447eb36ad4a6$var$emptyStateMaxImageWidth = 300;
const $ef39447eb36ad4a6$var$emptyStateMaxImageHeight = 250;
const $ef39447eb36ad4a6$var$EmptyState = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef39447eb36ad4a6$var$EmptyWrapper, {
        "data-test-id": "global-pages.home.common.ui.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        maxImageWidth: $ef39447eb36ad4a6$var$emptyStateMaxImageWidth,
        maxImageHeight: $ef39447eb36ad4a6$var$emptyStateMaxImageHeight,
        headingLevel: 2,
        ...props
    }));
$ef39447eb36ad4a6$var$EmptyState.defaultProps = {
    primaryAction: undefined,
    secondaryAction: undefined
};
var $ef39447eb36ad4a6$export$2e2bcd8739ae039 = $ef39447eb36ad4a6$var$EmptyState;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef39447eb36ad4a6$var$EmptyWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1epz _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7fGJN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2405a9e9a0ece493$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $b4CS6 = parcelRequire("b4CS6");
const $2405a9e9a0ece493$var$ItemCounter = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return props.displayedCount && props.totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2405a9e9a0ece493$var$ItemCounterWrapper, props, formatMessage((0, $b4CS6.default).showingCounter, {
        numberOfDisplayedItems: props.displayedCount,
        totalNumberOfItems: props.totalCount > 99 ? '99+' : props.totalCount
    })) : null;
};
var $2405a9e9a0ece493$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2405a9e9a0ece493$var$ItemCounter;
const $2405a9e9a0ece493$var$ItemCounterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b4CS6", function(module, exports) {
$parcel$export(module.exports, "default", () => $517e1bd747e57436$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $517e1bd747e57436$var$messages = (0, $7qGN1.defineMessages)({
    showingCounter: {
        "id": "home.common.item-counter.showing-counter",
        "defaultMessage": "Showing {numberOfDisplayedItems} of {totalNumberOfItems}"
    }
});
var $517e1bd747e57436$export$2e2bcd8739ae039 = $517e1bd747e57436$var$messages;

});


parcelRegister("3Nff7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c581288445ac89aa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $806LH = parcelRequire("806LH");

var $gohXm = parcelRequire("gohXm");

var $gxzNR = parcelRequire("gxzNR");
const $c581288445ac89aa$var$styles = {
    sectionHeader: "_11c81vhk _syaz131l _19pku2gc _1p1dangw",
    list: "_1e0c1txw _2lx21bp4 _1bsb1osq _19pkpxbi",
    sectionHeaderInnerContainer: "_11c81vhk _syaz131l _1p1dangw"
};
const $c581288445ac89aa$var$ItemList = ({ sections: sections, showStar: showStar, onItemClick: onItemClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "global-pages.home.common.ui.item-list.list",
        className: (0, $hcewu.default)([
            $c581288445ac89aa$var$styles.list
        ])
    }, sections.filter((0, $gxzNR.hasItems)).map((section, i)=>{
        const { header: header = '' } = section;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: `${header}-${i}`
        }, header ? // styles are applied to all items except the first one so that we
        // don't have unnecessary margin for the first item in order to match
        // the look and feel of original version
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: i > 0 ? $c581288445ac89aa$var$sectionHeaderContainerStyles : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
            as: "h3",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            className: (0, $hcewu.default)([
                $c581288445ac89aa$var$styles.sectionHeaderInnerContainer
            ])
        }, header))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "ul",
            xcss: $c581288445ac89aa$var$listContainerStyles
        }, section.items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "li",
                key: item.url
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gohXm.default), {
                item: item,
                index: index,
                showStar: showStar,
                onItemClick: onItemClick
            })))));
    }));
const $c581288445ac89aa$var$sectionHeaderContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
});
const $c581288445ac89aa$var$listContainerStyles = (0, $1DXK0.xcss)({
    padding: 'space.0',
    listStyleType: 'none',
    marginTop: 'space.0'
});
var $c581288445ac89aa$export$2e2bcd8739ae039 = $c581288445ac89aa$var$ItemList;

});
parcelRegister("gohXm", function(module, exports) {
$parcel$export(module.exports, "default", () => $02a9c23b2142371d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/enforce-data-testid-usage */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $gqBnP = parcelRequire("gqBnP");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $4y6lt = parcelRequire("4y6lt");

var $c9uTK = parcelRequire("c9uTK");


var $7P0Ee = parcelRequire("7P0Ee");

var $6jFQQ = parcelRequire("6jFQQ");

var $gcYgh = parcelRequire("gcYgh");

var $8IRyK = parcelRequire("8IRyK");

var $2qtFm = parcelRequire("2qtFm");
const $02a9c23b2142371d$var$middot = String.fromCharCode(183);
const $02a9c23b2142371d$var$getAdditionalAttributes = (item, type, intl)=>{
    const { formatMessage: formatMessage } = intl;
    let location;
    let category;
    let { subtitle: subtitle } = item;
    switch(type){
        case 0, $f0288da4947ad855$export$aade82542e73ffc8:
            subtitle = formatMessage((0, $gcYgh.default).board);
            location = undefined;
            if (typeof item.attributes !== 'undefined' && typeof item.attributes.containerName === 'string') location = item.attributes.containerName;
            break;
        case 0, $f0288da4947ad855$export$6b0c8e47d2c7f1d9:
            subtitle = formatMessage((0, $gcYgh.default).queue);
            location = '';
            if (typeof item.metadata === 'string') location = item.metadata;
            {
                const { attributes: attributes = {} } = item;
                const { queuesCategory: queuesCategory } = attributes;
                const practiceLabel = queuesCategory != null ? (0, $4y6lt.getPracticeLabel)(queuesCategory) : undefined;
                category = practiceLabel && formatMessage(practiceLabel);
            }
            break;
        case 0, $f0288da4947ad855$export$a448ebfa10cebc74:
            subtitle = formatMessage((0, $gcYgh.default).filter);
            break;
        case 0, $f0288da4947ad855$export$f8099f229527572c:
            subtitle = formatMessage((0, $gcYgh.default).dashboard);
            break;
        case 0, $f0288da4947ad855$export$8e58083dcbb878d:
        case 0, $f0288da4947ad855$export$3061095c9d9509f6:
            if (typeof item.attributes !== 'undefined' && typeof item.attributes.containerName === 'string') location = item.attributes.containerName;
            break;
        case 0, $f0288da4947ad855$export$8e2cd98172988d7e:
            subtitle = (0, $8IRyK.getProjectType)(item, intl);
            break;
        case 0, $f0288da4947ad855$export$2fd44a6cb58b66cb:
            subtitle = formatMessage((0, $gcYgh.default).plan);
            break;
        default:
            subtitle = undefined;
            break;
    }
    if (typeof subtitle === 'string' && typeof location === 'string') // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
    subtitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, subtitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, $02a9c23b2142371d$var$middot), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, location));
    else if (typeof location === 'string') subtitle = location;
    return {
        category: category,
        subtitle: subtitle
    };
};
const $02a9c23b2142371d$var$Item = ({ item: item, showStar: showStar, elemBefore: elemBefore, index: index, onItemClick: onItemClick })=>{
    const intl = (0, $lRq8t.default)(); // conform to lowercase, and remove the pluralised `s` if it exists
    const type = item.type.toLowerCase().replace(/s\s*$/, ''); // for the favourite button we also need to ensure we pass the pluralised type
    const pluralisedType = (0, $8IRyK.convertToFavouriteItemType)(type);
    const { category: category, subtitle: subtitle } = $02a9c23b2142371d$var$getAdditionalAttributes(item, type, intl);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'jiraHomeLink', {
            itemType: item.type,
            itemIndex: index,
            itemAction: item.action
        });
        onItemClick && onItemClick();
    }, [
        createAnalyticsEvent,
        item.type,
        item.action,
        index,
        onItemClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$export$283e28d91a9a885d, {
        href: item.url,
        key: item.url,
        onClick: onClick,
        "data-test-id": `global-pages.home.ui.tab-container.tab.item-list.item-link#${item.type ? item.type.toString() : ''}-${item.id}`
    }, showStar && item.entityId && typeof item.favourite !== 'undefined' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$AfterIconsContainer, null, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7P0Ee.FavoriteButtonWithSSR), {
        itemId: item.entityId,
        itemType: pluralisedType,
        isFavoriteInitial: item.favourite,
        isSmall: true
    })), type === 'issue' || type === 'comment' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6jFQQ.default), {
        type: type,
        url: item.avatarUrl,
        altText: item.attributes?.issueTypeName ?? ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6jFQQ.default), {
        type: type,
        url: item.avatarUrl,
        altText: item.type ?? ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$InnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qtFm.WithCategory), {
        category: category
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$Subtitle, null, subtitle)), item.status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$Status, null, item.status), item.action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$Action, null, item.action), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$AvatarGroupWrapper, null, item.contributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02a9c23b2142371d$var$AvatarGroup, {
        data: item.contributors.map((contributor)=>({
                name: contributor.name,
                src: contributor.picture && contributor.picture,
                appearance: 'circle',
                size: 'medium',
                enableTooltip: true
            }))
    })));
};
$02a9c23b2142371d$var$Item.whyDidYouRender = true;
var $02a9c23b2142371d$export$2e2bcd8739ae039 // type LinkProps = ComponentPropsWithRef<typeof Link>;
 = $02a9c23b2142371d$var$Item;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$InnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlouyt _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1y6m _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $02a9c23b2142371d$var$Title = /*#__PURE__*/ (0, $cdbP5.default).h4.withConfig({
    componentId: "bu4bgh-0"
})`font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};flex-grow:1;margin:0;`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$Subtitle = /*#__PURE__*/ (0, $cdbP5.default).small.withConfig({
    componentId: "bu4bgh-1"
})`flex-grow:1;margin:0;font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtlest, #626F86)"};> span:not(:first-child):not(:last-child){margin:0 ${"var(--ds-space-100, 8px)"};}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$Status = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "bu4bgh-2"
})({
    flex: 1,
    margin: 0,
    color: "var(--ds-text-subtlest, #626F86)",
    verticalAlign: 'center',
    minWidth: '8em',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingRight: "var(--ds-space-200, 16px)",
    textAlign: 'right'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$Action = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "bu4bgh-3"
})({
    flex: 1,
    margin: 0,
    color: "var(--ds-text-subtlest, #626F86)",
    verticalAlign: 'middle',
    minWidth: '8em',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingRight: "var(--ds-space-200, 16px)",
    textAlign: 'right'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$AvatarGroupWrapper = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "bu4bgh-4"
})({
    margin: 0,
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'flex-end',
    width: 'auto'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$AfterIconsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $02a9c23b2142371d$export$283e28d91a9a885d = /*#__PURE__*/ (0, $cdbP5.default)((0, $c9uTK.Link)).withConfig({
    componentId: "bu4bgh-5"
})({
    marginTop: 0,
    marginLeft: "var(--ds-space-negative-100, -8px)",
    marginRight: "var(--ds-space-negative-100, -8px)",
    flex: 1,
    padding: "var(--ds-space-100, 8px)",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    textDecoration: 'none',
    color: "var(--ds-link, #0C66E4)",
    '&:hover, &:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-link, #0C66E4)"} !important`,
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        textDecoration: 'none'
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        fill: 'rgba(222, 235, 255, 1)',
        color: 'rgba(0, 82, 204, 1)'
    }
}); // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02a9c23b2142371d$var$AvatarGroup = /*#__PURE__*/ (0, $cdbP5.default)((0, $gqBnP.default)).withConfig({
    componentId: "bu4bgh-6"
})({
    justifyContent: 'flex-end',
    width: '200px'
});

});
parcelRegister("4y6lt", function(module, exports) {
$parcel$export(module.exports, "getPracticeName", () => $e1b20086589ed961$export$dcaba3d3c595e59a);
$parcel$export(module.exports, "getPracticeLabel", () => $e1b20086589ed961$export$606a831b3dc84cba);

var $jlJsl = parcelRequire("jlJsl");
const $e1b20086589ed961$export$dcaba3d3c595e59a = (itsmPracticeKey)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "change-management": "Changes"; readonly "incident-management": "Incidents"; readonly "problem-management": "Problems"; readonly "service-request": "Service requests"; readonly "post-incident-review": "Post-incident reviews"; }'.
    (0, $jlJsl.practiceKeyJqlNameMapping)[itsmPracticeKey] || null;
const $e1b20086589ed961$export$606a831b3dc84cba = (itsmPracticeKey)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "change-management": MessageDescriptorV2; readonly "service-request": MessageDescriptorV2; readonly "problem-management": MessageDescriptorV2; readonly "incident-management": MessageDescriptorV2; readonly "post-incident-review": MessageDescriptorV2; readonly "no-category": MessageDescriptorV2; }'.
    (0, $jlJsl.PRACTICE_LABEL_MAP)[itsmPracticeKey];

});

const $f0288da4947ad855$export$aade82542e73ffc8 = 'board';
const $f0288da4947ad855$export$a448ebfa10cebc74 = 'filter';
const $f0288da4947ad855$export$f8099f229527572c = 'dashboard';
const $f0288da4947ad855$export$8e58083dcbb878d = 'issue';
const $f0288da4947ad855$export$3061095c9d9509f6 = 'comment';
const $f0288da4947ad855$export$8e2cd98172988d7e = 'project';
const $f0288da4947ad855$export$6b0c8e47d2c7f1d9 = 'queue';
const $f0288da4947ad855$export$2fd44a6cb58b66cb = 'plan';

parcelRegister("7P0Ee", function(module, exports) {
$parcel$export(module.exports, "FavoriteButtonWithSSR", () => $db52e94a21994d3e$export$ae863d29b9960ef8);

var $eJOHy = parcelRequire("eJOHy");

var $fVPN0 = parcelRequire("fVPN0");

var $fNmFZ = parcelRequire("fNmFZ");
const $db52e94a21994d3e$export$ae863d29b9960ef8 = ({ itemId: itemId, itemType: itemType, isFavoriteInitial: isFavoriteInitial, isSmall: isSmall })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
        isFavorite: isFavoriteInitial,
        isSmall: isSmall
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNmFZ.default), {
        itemId: itemId,
        itemType: itemType,
        isFavoriteInitial: isFavoriteInitial,
        isSmall: isSmall
    });

});
parcelRegister("fVPN0", function(module, exports) {
$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $6sjW5 = parcelRequire("6sjW5");

var $f2JN3 = parcelRequire("f2JN3");

var $6YFG2 = parcelRequire("6YFG2");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $6YFG2.default))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1rr0 _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6urTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $708ae8e1a771b9ca$var$messages = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = $708ae8e1a771b9ca$var$messages;

});


parcelRegister("fNmFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4961e4a04dcd2feb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dFtHW = parcelRequire("dFtHW");


var $c5DQI = parcelRequire("c5DQI");
class $4961e4a04dcd2feb$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c5DQI.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("c5DQI", function(module, exports) {
$parcel$export(module.exports, "FavoriteButton", () => $9f486e8c0fd92397$export$8d5dab2ad1e19ea0);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fVPN0 = parcelRequire("fVPN0");

var $aMJA4 = parcelRequire("aMJA4");

var $9R7x8 = parcelRequire("9R7x8");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $9f486e8c0fd92397$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $9f486e8c0fd92397$export$8d5dab2ad1e19ea0 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { itemId: itemId, itemType: itemType } = this.props;
        if (typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$9f486e8c0fd92397$var$isProduction && !(0, $aMJA4.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $aMJA4.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $9R7x8.getFavorite)({
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("9R7x8", function(module, exports) {
$parcel$export(module.exports, "getFavorite", () => $d577b9b229521b80$export$fce5eda070ce88d0);

var $3ugTQ = parcelRequire("3ugTQ");
const $d577b9b229521b80$export$959ca2ee969adb8d = (request)=>`/rest/internal/2/favourites/${request.type}/${request.id}`;
const $d577b9b229521b80$export$fce5eda070ce88d0 = async (request)=>(0, $3ugTQ.performGetRequest)($d577b9b229521b80$export$959ca2ee969adb8d(request));

});




parcelRegister("6jFQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ae28ce2cf1fbdda$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Wdhjx = parcelRequire("Wdhjx");

var $5SdQs = parcelRequire("5SdQs");

var $KDB2z = parcelRequire("KDB2z");

var $c59mr = parcelRequire("c59mr");

var $bjI3S = parcelRequire("bjI3S");

// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $1ae28ce2cf1fbdda$var$PlansIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "var(--ds-icon, #44546F)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $1ae28ce2cf1fbdda$var$iconMap = {
    [(0, $f0288da4947ad855$export$aade82542e73ffc8)]: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
    [(0, $f0288da4947ad855$export$a448ebfa10cebc74)]: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))),
    [(0, $f0288da4947ad855$export$f8099f229527572c)]: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))),
    [(0, $f0288da4947ad855$export$8e58083dcbb878d)]: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
    [(0, $f0288da4947ad855$export$6b0c8e47d2c7f1d9)]: (0, (/*@__PURE__*/$parcel$interopDefault($bjI3S))),
    [(0, $f0288da4947ad855$export$2fd44a6cb58b66cb)]: $1ae28ce2cf1fbdda$var$PlansIcon
};
const $1ae28ce2cf1fbdda$var$ItemIcon = ({ type: type, url: url, altText: altText = '' })=>{
    // boards include the project avatar URL, which we don't want to show
    if (typeof url === 'string' && type !== (0, $f0288da4947ad855$export$aade82542e73ffc8)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ae28ce2cf1fbdda$var$AvatarIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ae28ce2cf1fbdda$var$Avatar, {
        src: url,
        alt: altText
    }));
    if (!type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: typeof default; readonly filter: typeof default; readonly dashboard: typeof default; readonly issue: typeof default; readonly queue: typeof default; readonly plan: () => Element; }'.
    const Icon = $1ae28ce2cf1fbdda$var$iconMap[type];
    if (!Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ae28ce2cf1fbdda$var$AvatarIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious"
    }));
};
var $1ae28ce2cf1fbdda$export$2e2bcd8739ae039 = $1ae28ce2cf1fbdda$var$ItemIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ae28ce2cf1fbdda$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _4t3i1tcg _1bsb1tcg _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $1ae28ce2cf1fbdda$var$AvatarIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tcg _1bsb1tcg _1e0c1ule",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gcYgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $12bd205578e69b99$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $12bd205578e69b99$var$messages = (0, $7qGN1.defineMessages)({
    board: {
        "id": "home.common.item-list.item.board",
        "defaultMessage": "Board"
    },
    filter: {
        "id": "home.common.item-list.item.filter",
        "defaultMessage": "Filter"
    },
    dashboard: {
        "id": "home.common.item-list.item.dashboard",
        "defaultMessage": "Dashboard"
    },
    project: {
        "id": "home.common.item-list.item.project",
        "defaultMessage": "Project"
    },
    queue: {
        "id": "home.common.item-list.item.queue",
        "defaultMessage": "Queue"
    },
    plan: {
        "id": "home.common.item-list.item.plan",
        "defaultMessage": "Plan"
    },
    companyManagedBusiness: {
        "id": "home.common.item-list.item.company-managed-business",
        "defaultMessage": "Company-managed business"
    },
    teamManagedBusiness: {
        "id": "home.common.item-list.item.team-managed-business",
        "defaultMessage": "Team-managed business"
    },
    companyManagedServiceManagement: {
        "id": "home.common.item-list.item.company-managed-service-management",
        "defaultMessage": "Service management"
    },
    teamManagedServiceManagement: {
        "id": "home.common.item-list.item.team-managed-service-management",
        "defaultMessage": "Team-managed service management"
    },
    companyManagedSoftware: {
        "id": "home.common.item-list.item.company-managed-software",
        "defaultMessage": "Company-managed software"
    },
    teamManagedSoftware: {
        "id": "home.common.item-list.item.team-managed-software",
        "defaultMessage": "Team-managed software"
    },
    productDiscovery: {
        "id": "home.common.item-list.item.product-discovery",
        "defaultMessage": "Product discovery"
    },
    companyManagedCustomerServiceManagement: {
        "id": "home.common.item-list.item.company-managed-customer-service-management",
        "defaultMessage": "Customer service"
    }
});
var $12bd205578e69b99$export$2e2bcd8739ae039 = $12bd205578e69b99$var$messages;

});

parcelRegister("8IRyK", function(module, exports) {
$parcel$export(module.exports, "convertToFavouriteItemType", () => $1715cd64b950c0f4$export$bbe5655e133c94f7);
$parcel$export(module.exports, "getProjectType", () => $1715cd64b950c0f4$export$3dd0da95519c1a33);

var $FhXEJ = parcelRequire("FhXEJ");

var $aMJA4 = parcelRequire("aMJA4");

var $4cTDP = parcelRequire("4cTDP");


var $gcYgh = parcelRequire("gcYgh");
const $1715cd64b950c0f4$export$bbe5655e133c94f7 = (t)=>{
    switch(t){
        case 0, $f0288da4947ad855$export$aade82542e73ffc8:
            return 0, $aMJA4.BOARDS_ITEM_TYPE;
        case 0, $f0288da4947ad855$export$8e2cd98172988d7e:
            return 0, $aMJA4.PROJECTS_ITEM_TYPE;
        case 0, $f0288da4947ad855$export$f8099f229527572c:
            return 0, $aMJA4.DASHBOARDS_ITEM_TYPE;
        case 0, $f0288da4947ad855$export$8e58083dcbb878d:
            return 0, $aMJA4.ISSUES_ITEM_TYPE;
        case 0, $f0288da4947ad855$export$a448ebfa10cebc74:
            return 0, $aMJA4.FILTERS_ITEM_TYPE;
        case 0, $f0288da4947ad855$export$6b0c8e47d2c7f1d9:
            return 0, $aMJA4.QUEUES_ITEM_TYPE;
        case 0, $f0288da4947ad855$export$2fd44a6cb58b66cb:
            return 0, $aMJA4.PLANS_ITEM_TYPE;
        default:
            return 0, $aMJA4.ISSUES_ITEM_TYPE;
    }
};
const $1715cd64b950c0f4$export$3dd0da95519c1a33 = (item, intl)=>{
    let subtitle = '';
    if (typeof subtitle === 'string') {
        const projectType = item.attributes?.projectType !== undefined ? item.attributes.projectType : '';
        if (item.attributes && item.attributes.nextgen === 'true') {
            if (projectType === (0, $FhXEJ.SOFTWARE_PROJECT) || projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) subtitle = intl.formatMessage((0, $gcYgh.default).teamManagedSoftware);
            else if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT)) subtitle = intl.formatMessage((0, $gcYgh.default).teamManagedServiceManagement);
            else if (projectType === (0, $FhXEJ.CORE_PROJECT)) subtitle = intl.formatMessage((0, $gcYgh.default).teamManagedBusiness);
        } else if (item.attributes && item.attributes.nextgen === 'false') {
            if (projectType === (0, $FhXEJ.SOFTWARE_PROJECT)) subtitle = intl.formatMessage((0, $gcYgh.default).companyManagedSoftware);
            else if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT)) subtitle = intl.formatMessage((0, $gcYgh.default).companyManagedServiceManagement);
            else if (projectType === (0, $FhXEJ.CORE_PROJECT)) subtitle = intl.formatMessage((0, $gcYgh.default).companyManagedBusiness);
            else if (projectType === (0, $FhXEJ.CUSTOMER_SERVICE_PROJECT) && (0, $4cTDP.fg)('csm_rename_jcs_to_csm')) subtitle = intl.formatMessage((0, $gcYgh.default).companyManagedCustomerServiceManagement);
        }
    }
    return subtitle;
};

});

parcelRegister("2qtFm", function(module, exports) {
$parcel$export(module.exports, "WithCategory", () => $55acc26e1b08514e$export$44dd5293ffd0241a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8dH3d = parcelRequire("8dH3d");
const $55acc26e1b08514e$export$44dd5293ffd0241a = ({ category: category, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(category) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($55acc26e1b08514e$var$Category, null, category, " / ") : null, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55acc26e1b08514e$var$Category = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gxzNR", function(module, exports) {
$parcel$export(module.exports, "hasItems", () => $678e61d7effa0954$export$97057de2cd25fb57);
const $678e61d7effa0954$export$97057de2cd25fb57 = (section)=>!!(section.items && section.items.length > 0);

});


parcelRegister("1SixK", function(module, exports) {
$parcel$export(module.exports, "default", () => $98c5400464e79cc7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $98c5400464e79cc7$var$ReloadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98c5400464e79cc7$var$SpinnerWrapper, {
        "data-test-id": "global-pages.home.common.ui.reloading-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null));
var $98c5400464e79cc7$export$2e2bcd8739ae039 = $98c5400464e79cc7$var$ReloadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $98c5400464e79cc7$var$SpinnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkukr8 _kqswstnw _1xi2u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9aHHU", function(module, exports) {
$parcel$export(module.exports, "TabFooter", () => $d529a709c8f69aa6$export$bb15cf03569f78d);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d529a709c8f69aa6$export$bb15cf03569f78d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _19pkxy5q",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9LAjM", function(module, exports) {
$parcel$export(module.exports, "ButtonWithAnalytics", () => $5ef2bb7a5bfb58d5$export$a578b1fb92782ca2);
$parcel$export(module.exports, "LinkWithAnalytics", () => $5ef2bb7a5bfb58d5$export$560bebe32100cf5e);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $kRgKj = parcelRequire("kRgKj");

var $c9uTK = parcelRequire("c9uTK");
const $5ef2bb7a5bfb58d5$var$BaseAnalyticsComponent = (props)=>{
    const { children: children, actionSubjectId: actionSubjectId, extraAttributes: extraAttributes, buttonLink: buttonLink, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...rest,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick: (e, analyticsEvent)=>{
            if (extraAttributes) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId, extraAttributes);
            else (0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId);
            if (props.onClick) props.onClick(e, analyticsEvent);
        }
    }, children);
};
const $5ef2bb7a5bfb58d5$export$a578b1fb92782ca2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5ef2bb7a5bfb58d5$var$BaseAnalyticsComponent, props);
$5ef2bb7a5bfb58d5$export$a578b1fb92782ca2.displayName = 'ButtonWithAnalytics';
const $5ef2bb7a5bfb58d5$export$560bebe32100cf5e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5ef2bb7a5bfb58d5$var$BaseAnalyticsComponent, {
        ...props,
        component: // eslint-disable-next-line no-nested-ternary
        props.buttonLink ? props.appearance === 'link' && props.href // We only apply the new link component for anchor tag with "link" appearance
         ? (0, $eJ9f5.default) : (0, $c9uTK.Link) : undefined
    });
$5ef2bb7a5bfb58d5$export$560bebe32100cf5e.displayName = 'LinkWithAnalytics';

});

parcelRegister("e6Ijt", function(module, exports) {
module.exports = new URL("jira-laptop-done.ad39bf9b.svg", import.meta.url).toString();

});

parcelRegister("dUTrY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5231766db9862fe$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a5231766db9862fe$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        "id": "home.tabs.assigned-to-me.empty-state-header",
        "defaultMessage": "Find all your open issues in one place"
    },
    emptyStateDescription: {
        "id": "home.tabs.assigned-to-me.empty-state-description",
        "defaultMessage": "You have no open issues assigned to you"
    },
    seeAllIssuesAssignedToMe: {
        "id": "home.tabs.assigned-to-me.see-all-issues-assigned-to-me",
        "defaultMessage": "View all"
    },
    emptyStateHeaderIssueTermRefresh: {
        "id": "home.tabs.assigned-to-me.empty-state-header-issue-term-refresh",
        "defaultMessage": "Find all your open work items in one place"
    },
    emptyStateDescriptionIssueTermRefresh: {
        "id": "home.tabs.assigned-to-me.empty-state-description-issue-term-refresh",
        "defaultMessage": "You have no open work items assigned to you"
    }
});
var $a5231766db9862fe$export$2e2bcd8739ae039 = $a5231766db9862fe$var$messages;

});


parcelRegister("i30fK", function(module, exports) {
$parcel$export(module.exports, "BoardsTab", () => $1259f6ac4dc3490a$export$a0794bae3abb44c7);

var $8SAMv = parcelRequire("8SAMv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jjRt1 = parcelRequire("jjRt1");

var $8IeH1 = parcelRequire("8IeH1");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $cHtIB = parcelRequire("cHtIB");

var $4EKqI = parcelRequire("4EKqI");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $1tdir = parcelRequire("1tdir");

var $cGINE = parcelRequire("cGINE");

var $djZnY = parcelRequire("djZnY");

var $fYM66 = parcelRequire("fYM66");

var $9Q87t = parcelRequire("9Q87t");

var $lDZkd = parcelRequire("lDZkd");
// TODO: Top bar with search field (https://jplat.atlassian.net/browse/BLU-3708) and
// TODO: "Create board" button that opens existing modal (https://jplat.atlassian.net/browse/BLU-3707)
const $1259f6ac4dc3490a$var$BoardsTabWithoutErrorBoundary = ({ maxItems: maxItems, searchQuery: searchQuery, onInitialBoardsLoad: onInitialBoardsLoad })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    // To paginate, we need to get ALL boards to have the correct count.
    // If the 'first' or 'last' filters are used to limit the results fetched, it also affects totalCount.
    // So here we fetch a minimal amount of data, and then have the child components fetch details when they need them.
    // The alternative would be to use a "Load more" pattern instead of discrete-page style pagination.
    const data = (0, $j4oe4.useLazyLoadQuery)((0, $8SAMv.default), {
        cloudAri: `ari:cloud:platform::site/${cloudId}`,
        first: maxItems,
        query: searchQuery
    });
    const totalBoards = (0, $eJOHy.useMemo)(()=>data.search?.result?.totalCount ?? 0, [
        data?.search?.result
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onInitialBoardsLoad(totalBoards > 0);
    }, [
        totalBoards,
        onInitialBoardsLoad
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, totalBoards > 0 && data?.search?.result ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tdir.BoardsTable), {
        data: data?.search?.result,
        itemsPerPage: maxItems
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Q87t.BoardsTabFooter), {
        hasNextPage: data?.search?.result?.pageInfo?.hasNextPage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cGINE.EmptyState), {
        isSearch: !!searchQuery
    }));
};
const $1259f6ac4dc3490a$export$a0794bae3abb44c7 = ({ maxItems: maxItems })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [hasInitialBoards, setHasInitialBoards] = (0, $eJOHy.useState)(false);
    const [shouldDisplaySearch, setShouldDisplaySearch] = (0, $eJOHy.useState)(false);
    const [searchQuery, setSearchQuery] = (0, $eJOHy.useState)('');
    const onSearchValueChange = (value, analyticsEvent)=>{
        setSearchQuery(value);
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'boardsTabSearch');
    }; // we want to hide the search input if user doesn't have any boards
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (!shouldDisplaySearch && hasInitialBoards) // eslint-disable-next-line react-you-might-not-need-an-effect/no-chain-state-updates
        setShouldDisplaySearch(true);
    }, [
        hasInitialBoards,
        shouldDisplaySearch
    ]); // TODO is it a problem that LoadingState always assumes there is data here?
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-home-boards-tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "homePageYourWorkBoards",
        packageName: "jiraHome",
        fallback: "flag",
        teamName: "jira-cosmos",
        render: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $djZnY.BoardsErrorState), {
                error: error
            })
    }, shouldDisplaySearch && (0, $cxKOj.expVal)('blu-8218-add-search-to-for-you-boards-tab', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $1259f6ac4dc3490a$var$searchFieldWrapperStyles.box
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjRt1.default), {
        placeholder: formatMessage((0, $lDZkd.default).searchPlaceholder),
        value: searchQuery,
        isCompact: true,
        hasAutoFocus: false,
        increasedWidth: false,
        placeholderAlwaysVisible: true,
        shouldFitContainerWidth: true,
        onChange: onSearchValueChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "boards",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fYM66.LoadingState), {
            hasData: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1259f6ac4dc3490a$var$BoardsTabWithoutErrorBoundary, {
        maxItems: maxItems,
        searchQuery: searchQuery,
        onInitialBoardsLoad: setHasInitialBoards
    }))));
};
const $1259f6ac4dc3490a$var$searchFieldWrapperStyles = {
    box: "_1e0c1o8l _1q51pxbi _85i5pxbi"
};

});
parcelRegister("8SAMv", function(module, exports) {
$parcel$export(module.exports, "default", () => $0480bcdc40e1e374$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5c7ef9602af0aca58de0f331525a2fe9>>
 * @relayHash adadb3be1a833182a34f3dc5c4484f27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d13edfa613392c389fcab9eaeb0f8baaed83a8ae14b7e3dc982f9aa13a83b10b
const $0480bcdc40e1e374$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "experience",
            "value": "jira.search"
        },
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "entities",
                    "value": [
                        "jira.board"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudAri"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v3 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BoardsTabQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "result",
                            "args": v1 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "BoardsTable"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BoardsTabQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "result",
                            "args": v1 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "boardId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "favourite"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconUrl"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "container",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectId"
                                                                        },
                                                                        {
                                                                            "alias": "key",
                                                                            "kind": "ScalarField",
                                                                            "name": "projectKey"
                                                                        },
                                                                        {
                                                                            "alias": "name",
                                                                            "kind": "ScalarField",
                                                                            "name": "projectName"
                                                                        }
                                                                    ],
                                                                    "type": "SearchResultJiraBoardProjectContainer"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "userAccountId"
                                                                        },
                                                                        {
                                                                            "alias": "name",
                                                                            "kind": "ScalarField",
                                                                            "name": "userName"
                                                                        }
                                                                    ],
                                                                    "type": "SearchResultJiraBoardUserContainer"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d13edfa613392c389fcab9eaeb0f8baaed83a8ae14b7e3dc982f9aa13a83b10b",
            "metadata": {},
            "name": "BoardsTabQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0480bcdc40e1e374$var$node.hash = "f9eda10e11987e60a2f70fc693a8b275";
var $0480bcdc40e1e374$export$2e2bcd8739ae039 = $0480bcdc40e1e374$var$node;

});

parcelRegister("jjRt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0c664de71f5fe1$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $gPaDt = parcelRequire("gPaDt");
const $5a0c664de71f5fe1$var$FilterSearchWithAnalytics = (0, $as6H2.default)('filterSearch', {
    onChange: 'changed'
})((0, $gPaDt.default));
var $5a0c664de71f5fe1$export$2e2bcd8739ae039 = $5a0c664de71f5fe1$var$FilterSearchWithAnalytics;

});
parcelRegister("gPaDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae2458133d2ad358$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dqc6Z = parcelRequire("dqc6Z");
const $ae2458133d2ad358$export$4c4c11a6ab1f5b09 = 1000;
const $ae2458133d2ad358$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value, callback)=>callback(value), $ae2458133d2ad358$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $ae2458133d2ad358$var$Filter extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: true
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $ae2458133d2ad358$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $ae2458133d2ad358$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $ae2458133d2ad358$export$2e2bcd8739ae039 = $ae2458133d2ad358$var$Filter;

});
parcelRegister("dqc6Z", function(module, exports) {
$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]);
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps;
    const showTooltip = (0, $eJOHy.useMemo)(()=>{
        return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
    }, [
        renderTooltipContent,
        value
    ]);
    const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: renderTooltipContent,
        canAppear: useShowTooltip,
        position: "bottom-start",
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true
    }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ...tooltipProps,
            ...restTextFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {},
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onFocus: (0, $eJOHy.useCallback)((event)=>{
                onFocusTextField && onFocusTextField(event);
                onFocusTooltip(event);
            }, [
                onFocusTooltip
            ]),
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onBlur: (0, $eJOHy.useCallback)((event)=>{
                onBlurTextField && onBlurTextField(event);
                onBlurTooltip(event);
            }, [
                onBlurTooltip
            ]),
            ref: (0, $bzbsd.mergeRefs)(textFieldRef, tooltipRef),
            "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
        }))));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-radius-small, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {
$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {
$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $4cTDP = parcelRequire("4cTDP");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});




parcelRegister("1tdir", function(module, exports) {
$parcel$export(module.exports, "BoardsTable", () => $37d101b5399d6eff$export$1a62f34cca5dfcb5);

var $loKGq = parcelRequire("loKGq");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kDTK4 = parcelRequire("kDTK4");

var $gGgaG = parcelRequire("gGgaG");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $c9uTK = parcelRequire("c9uTK");

var $aMJA4 = parcelRequire("aMJA4");

var $bXOg3 = parcelRequire("bXOg3");

var $fQ03e = parcelRequire("fQ03e");


var $7P0Ee = parcelRequire("7P0Ee");

var $lPO0c = parcelRequire("lPO0c");

var $3s16R = parcelRequire("3s16R");
const $37d101b5399d6eff$var$isProjectBoard = (board)=>board.container?.__typename === (0, $2c5acff8995e8f4f$export$df3897b1b2d6141a);
const $37d101b5399d6eff$export$1a62f34cca5dfcb5 = ({ data: data, itemsPerPage: itemsPerPage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(!!data, null, false, (0, $bXOg3.BOARDS_TAB_KEY));
    const rowData = (0, $j4oe4.useFragment)((0, $loKGq.default), data);
    const onBoardLinkClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'boardItem', {
            pageLocation: 'home'
        });
    }, [
        createAnalyticsEvent
    ]);
    const tableHeaders = (0, $eJOHy.useMemo)(()=>({
            cells: [
                {
                    key: 'starred',
                    width: 5,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
                        xcss: $37d101b5399d6eff$var$tableHeaderIconWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
                        label: formatMessage((0, $3s16R.default).starredColumnHeader),
                        color: "var(--ds-icon-accent-yellow, #B38600)"
                    })),
                    isSortable: false
                },
                {
                    key: 'name',
                    width: 40,
                    content: formatMessage((0, $3s16R.default).nameColumnHeader),
                    isSortable: true
                },
                {
                    key: 'location',
                    width: 50,
                    content: formatMessage((0, $3s16R.default).locationColumnHeader),
                    isSortable: true
                }
            ]
        }), [
        formatMessage
    ]);
    const tableRows = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const projectAndUserBoards = rowData?.edges.map((edge)=>edge.node).filter((board)=>{
            if (!board?.boardId) return false;
            return board?.container?.__typename === (0, $2c5acff8995e8f4f$export$df3897b1b2d6141a) || board?.container?.__typename === (0, $2c5acff8995e8f4f$export$c4d6d64d4a8b428e);
        }) ?? [];
        return projectAndUserBoards.map((board, index)=>{
            const containerKey = $37d101b5399d6eff$var$isProjectBoard(board) ? board.container.projectId : board.container.userAccountId;
            const containerLabel = $37d101b5399d6eff$var$isProjectBoard(board) ? `${board.container.name} (${board.container.key})` : board.container.name;
            const containerAvatarShape = $37d101b5399d6eff$var$isProjectBoard(board) ? 'square' : 'circle';
            return {
                key: `row-${index}`,
                cells: [
                    {
                        key: `starred-${board?.favourite?.toString()}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7P0Ee.FavoriteButtonWithSSR), {
                            itemId: board?.boardId ?? '',
                            itemType: (0, $aMJA4.BOARDS_ITEM_TYPE),
                            isFavoriteInitial: Boolean(board?.favourite)
                        })
                    },
                    {
                        key: `${board?.title}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
                            href: board?.url,
                            onClick: onBoardLinkClick
                        }, board?.title)
                    },
                    {
                        key: `${containerLabel}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lPO0c.CellWithAvatar), {
                            key: containerKey,
                            imageUrl: board?.iconUrl ?? '',
                            appearance: containerAvatarShape,
                            text: containerLabel
                        })
                    }
                ]
            };
        });
    }, [
        rowData?.edges,
        onBoardLinkClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDTK4.default), {
        head: tableHeaders,
        rows: tableRows,
        rowsPerPage: itemsPerPage,
        defaultSortKey: "name",
        defaultSortOrder: "ASC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.BOARDS_TAB_KEY),
        renderState: (0, $bXOg3.SUCCESS_STATE)
    }));
};
const $37d101b5399d6eff$var$tableHeaderIconWrapperStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.100'
});

});
parcelRegister("loKGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $be475987e997717b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f58dfe7e116e2bfd91bce334902e6044>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be475987e997717b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BoardsTable",
        "selections": [
            {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "boardId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "favourite"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                    },
                                                    {
                                                        "alias": "key",
                                                        "kind": "ScalarField",
                                                        "name": "projectKey"
                                                    },
                                                    {
                                                        "alias": "name",
                                                        "kind": "ScalarField",
                                                        "name": "projectName"
                                                    }
                                                ],
                                                "type": "SearchResultJiraBoardProjectContainer"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "userAccountId"
                                                    },
                                                    {
                                                        "alias": "name",
                                                        "kind": "ScalarField",
                                                        "name": "userName"
                                                    }
                                                ],
                                                "type": "SearchResultJiraBoardUserContainer"
                                            }
                                        ]
                                    }
                                ],
                                "type": "SearchResultJiraBoard"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SearchItemConnection"
    };
}();
$be475987e997717b$var$node.hash = "cbc36fb46aaf7d10aa6cc41f00b25141";
var $be475987e997717b$export$2e2bcd8739ae039 = $be475987e997717b$var$node;

});

parcelRegister("kDTK4", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f2b3f32465e4e4b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $aXVGO = parcelRequire("aXVGO");

var $lOOiG = parcelRequire("lOOiG");
class $1f2b3f32465e4e4b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $3Vuhz.default),
            onSort: (0, $3Vuhz.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOOiG.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $aXVGO.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("aXVGO", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("lOOiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("khVsD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CCE0FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #388BFF)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r187z"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("1NCSA", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});



parcelRegister("iXYwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {
$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #626F86)"
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r187z _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbi3bv",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});




parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});



const $2c5acff8995e8f4f$export$df3897b1b2d6141a = 'SearchResultJiraBoardProjectContainer';
const $2c5acff8995e8f4f$export$c4d6d64d4a8b428e = 'SearchResultJiraBoardUserContainer';
const $2c5acff8995e8f4f$export$816c19ef9030bf21 = 'SearchResultJiraBoard';

parcelRegister("lPO0c", function(module, exports) {
$parcel$export(module.exports, "CellWithAvatar", () => $7815677e8fe16117$export$e125024564e04f7e);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");
const $7815677e8fe16117$export$e125024564e04f7e = ({ imageUrl: imageUrl, appearance: appearance = 'circle', text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: imageUrl,
        size: "small",
        appearance: appearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, text));

});

parcelRegister("3s16R", function(module, exports) {
$parcel$export(module.exports, "default", () => $655379573979f5bb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $655379573979f5bb$var$messages = (0, $7qGN1.defineMessages)({
    starredColumnHeader: {
        "id": "home.tabs.boards.boards-table.starred-column-header",
        "defaultMessage": "Starred"
    },
    starBoard: {
        "id": "home.tabs.boards.boards-table.star-board",
        "defaultMessage": "Add to starred"
    },
    unstarBoard: {
        "id": "home.tabs.boards.boards-table.unstar-board",
        "defaultMessage": "Remove from starred"
    },
    nameColumnHeader: {
        "id": "home.tabs.boards.boards-table.name-column-header",
        "defaultMessage": "Name"
    },
    adminColumnHeader: {
        "id": "home.tabs.boards.boards-table.admin-column-header",
        "defaultMessage": "Admin"
    },
    locationColumnHeader: {
        "id": "home.tabs.boards.boards-table.location-column-header",
        "defaultMessage": "Location"
    },
    actionsColumnHeader: {
        "id": "home.tabs.boards.boards-table.actions-column-header",
        "defaultMessage": "Actions"
    }
});
var $655379573979f5bb$export$2e2bcd8739ae039 = $655379573979f5bb$var$messages;

});


parcelRegister("cGINE", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $5acbb7d106f046f1$export$fddf379e22a74b00);

var $eJOHy = parcelRequire("eJOHy");

var $6e8iO = parcelRequire("6e8iO");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $bXOg3 = parcelRequire("bXOg3");

var $bdEnF = parcelRequire("bdEnF");

var $fQ03e = parcelRequire("fQ03e");

var $2YlDA = parcelRequire("2YlDA");
const $5acbb7d106f046f1$export$fddf379e22a74b00 = ({ isSearch: isSearch = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const imageProps = {
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $6e8iO.default))
    };
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(false, null, false, (0, $bXOg3.BOARDS_TAB_KEY));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        ...imageProps,
        header: formatMessage(isSearch ? (0, $2YlDA.default).emptySearchHeader : (0, $2YlDA.default).emptyStateHeader),
        headingLevel: 2,
        description: !isSearch && formatMessage((0, $2YlDA.default).emptyStateDescription),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.BOARDS_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
};

});
parcelRegister("6e8iO", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0a1b0b51f80b4a$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $g2eX0 = parcelRequire("g2eX0");
const $4f0a1b0b51f80b4a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($g2eX0)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($g2eX0))
});
var $4f0a1b0b51f80b4a$export$2e2bcd8739ae039 = $4f0a1b0b51f80b4a$var$Illustration;
// for advanced use only
const $4f0a1b0b51f80b4a$export$a179c88182cb9d56 = [
    0,
    0,
    176,
    112
];

});
parcelRegister("g2eX0", function(module, exports) {
module.exports = new URL("empty-no-boards.ff2b4767.svg", import.meta.url).toString();

});


parcelRegister("2YlDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $6057041e6d6c9099$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6057041e6d6c9099$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        "id": "home.tabs.boards.empty-state.empty-state-header",
        "defaultMessage": "You don't have any boards, yet"
    },
    emptyStateDescription: {
        "id": "home.tabs.boards.empty-state.empty-state-description",
        "defaultMessage": "Create a board to start tracking your work"
    },
    emptySearchHeader: {
        "id": "home.tabs.boards.empty-state.empty-search-header",
        "defaultMessage": "We couldn\u2019t find anything matching your search."
    }
});
var $6057041e6d6c9099$export$2e2bcd8739ae039 = $6057041e6d6c9099$var$messages;

});


parcelRegister("djZnY", function(module, exports) {
$parcel$export(module.exports, "BoardsErrorState", () => $9043c7377c480066$export$26b6c8e3e605d1d4);

var $eJOHy = parcelRequire("eJOHy");

var $bXOg3 = parcelRequire("bXOg3");

var $2kUzW = parcelRequire("2kUzW");

var $fQ03e = parcelRequire("fQ03e");
const $9043c7377c480066$export$26b6c8e3e605d1d4 = ({ error: error })=>{
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(false, error, false, (0, $bXOg3.BOARDS_TAB_KEY));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kUzW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.BOARDS_TAB_KEY),
        renderState: (0, $bXOg3.ERROR_STATE)
    }));
};

});

parcelRegister("fYM66", function(module, exports) {
$parcel$export(module.exports, "LoadingState", () => $f1048e42f26f9542$export$62aa48085237e36f);

var $eJOHy = parcelRequire("eJOHy");

var $5gjY4 = parcelRequire("5gjY4");

var $bXOg3 = parcelRequire("bXOg3");

var $fQ03e = parcelRequire("fQ03e");
const $f1048e42f26f9542$export$62aa48085237e36f = ({ hasData: hasData })=>{
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(hasData, null, true, (0, $bXOg3.BOARDS_TAB_KEY));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gjY4.YourWorkItemListSkeleton), null);
};

});

parcelRegister("9Q87t", function(module, exports) {
$parcel$export(module.exports, "BoardsTabFooter", () => $7130c72e6488510d$export$bf967ee91964aa6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lRq8t = parcelRequire("lRq8t");

var $d4W4S = parcelRequire("d4W4S");
const $7130c72e6488510d$var$fontStyle = {
    tabFooter: "_19pkxy5q"
};
function $7130c72e6488510d$export$bf967ee91964aa6b({ hasNextPage: hasNextPage }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!hasNextPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "center",
        alignItems: "center",
        gap: "space.100",
        xcss: $7130c72e6488510d$var$fontStyle.tabFooter
    }, formatMessage((0, $d4W4S.default).linkToBoardsDirectory, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                weight: "medium"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: "/jira/boards"
            }, chunks))
    }));
}

});
parcelRegister("d4W4S", function(module, exports) {
$parcel$export(module.exports, "default", () => $c11163fde732658e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c11163fde732658e$var$messages = (0, $7qGN1.defineMessages)({
    linkToBoardsDirectory: {
        "id": "home.tabs.boards.footer.link-to-boards-directory",
        "defaultMessage": "Couldn\u2019t find your boards? <a>View all boards</a>"
    }
});
var $c11163fde732658e$export$2e2bcd8739ae039 = $c11163fde732658e$var$messages;

});


parcelRegister("lDZkd", function(module, exports) {
$parcel$export(module.exports, "default", () => $de576fde616c9050$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $de576fde616c9050$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "home.tabs.boards.filter.search-placeholder",
        "defaultMessage": "Search boards"
    }
});
var $de576fde616c9050$export$2e2bcd8739ae039 = $de576fde616c9050$var$messages;

});


parcelRegister("cfk79", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b5c9ee4db24e2e1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $5gjY4 = parcelRequire("5gjY4");

var $fYeTG = parcelRequire("fYeTG");

var $lp1UD = parcelRequire("lp1UD");

var $4cTDP = parcelRequire("4cTDP");

var $bXOg3 = parcelRequire("bXOg3");

var $bdEnF = parcelRequire("bdEnF");

var $2kUzW = parcelRequire("2kUzW");

var $3Nff7 = parcelRequire("3Nff7");

var $1SixK = parcelRequire("1SixK");

var $9LAjM = parcelRequire("9LAjM");

var $fQ03e = parcelRequire("fQ03e");

var $8xHcZ = parcelRequire("8xHcZ");

var $iVJYm = parcelRequire("iVJYm");

var $7nkUa = parcelRequire("7nkUa");
const $9b5c9ee4db24e2e1$export$ae62e03c6f2a771b = (initialLength, section)=>initialLength + section.items.length;
const $9b5c9ee4db24e2e1$var$RecentlyViewedTab = (props)=>{
    const emptyStateDescriptionGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $7nkUa.default).emptyStateDescriptionGalaxia : (0, $7nkUa.default).emptyStateDescription;
    const viewAllProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $7nkUa.default).viewAllProjectsGalaxia : (0, $7nkUa.default).viewAllProjects;
    const { itemProviderResult: { data: data, error: error, loading: loading, reloading: reloading }, onLoadMoreClick: onLoadMoreClick, maxItems: maxItems } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(!!data.total, error, loading, 'recentlyViewed');
    if (error && !data.total) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kUzW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.VIEWED_TAB_KEY),
        renderState: (0, $bXOg3.ERROR_STATE)
    }));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gjY4.YourWorkItemListSkeleton), null);
    if ((!data || !data.sections || data.sections.length === 0) && (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        header: formatMessage((0, $7nkUa.default).emptyStateHeader),
        description: formatMessage((0, $7nkUa.default).emptyStateDescriptionForMobile),
        renderImage: ()=>// renderImage doesn't add an image wrapper whereas imageUrl does
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingBlockEnd: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lp1UD.default), {
                alt: "",
                width: 154
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.VIEWED_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    if (!data || !data.sections || data.sections.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        header: formatMessage((0, $7nkUa.default).emptyStateHeader),
        description: formatMessage(emptyStateDescriptionGalaxia),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8xHcZ))),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.LinkWithAnalytics), {
            actionSubjectId: "recentlyViewedBrowseProjectsButton",
            appearance: "primary",
            href: "/jira/projects"
        }, (0, $4cTDP.fg)('fix_color_of_home_buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "span",
            color: "color.text.inverse"
        }, formatMessage(viewAllProjectsGalaxia)) : formatMessage(viewAllProjectsGalaxia))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.VIEWED_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, reloading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1SixK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nff7.default), {
        sections: (0, $fQ03e.trimItemsBySection)(maxItems, data.sections)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iVJYm.default), {
        maxItems: maxItems,
        onLoadMoreClick: onLoadMoreClick,
        totalItemCount: data.sections.reduce($9b5c9ee4db24e2e1$export$ae62e03c6f2a771b, 0)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.VIEWED_TAB_KEY),
        renderState: (0, $bXOg3.SUCCESS_STATE)
    }));
};
var $9b5c9ee4db24e2e1$export$2e2bcd8739ae039 = $9b5c9ee4db24e2e1$var$RecentlyViewedTab;

});
parcelRegister("lp1UD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e46db2b1e4b17743$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $6bVJV = parcelRequire("6bVJV");

var $l2KmH = parcelRequire("l2KmH");
const $e46db2b1e4b17743$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($l2KmH)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6bVJV)),
    autoDark: false
});
var $e46db2b1e4b17743$export$2e2bcd8739ae039 = $e46db2b1e4b17743$var$Illustration;

});
parcelRegister("6bVJV", function(module, exports) {
module.exports = new URL("empty-cannot-view-item-darkmode.f5cb1022.svg", import.meta.url).toString();

});

parcelRegister("l2KmH", function(module, exports) {
module.exports = new URL("empty-cannot-view-item.d6ba9b64.svg", import.meta.url).toString();

});


parcelRegister("8xHcZ", function(module, exports) {
module.exports = new URL("migration-logo.25f5c840.svg", import.meta.url).toString();

});

parcelRegister("iVJYm", function(module, exports) {
$parcel$export(module.exports, "default", () => $219e6c7e74519558$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lwpci = parcelRequire("lwpci");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fYeTG = parcelRequire("fYeTG");

var $bXOg3 = parcelRequire("bXOg3");

var $9LAjM = parcelRequire("9LAjM");

var $4jHBC = parcelRequire("4jHBC");
const $219e6c7e74519558$var$styles = {
    iconWrapper: "_1e0c1o8l _kqswh2mm",
    tabFooter: "_y3gn1h6o _19pkxy5q _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg"
};
const $219e6c7e74519558$var$LinkToGlobalIssueNavigation = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.LinkWithAnalytics), {
        appearance: "link",
        href: "/issues/?jql=order+by+created+DESC",
        actionSubjectId: "globalIssueNavigationButton",
        buttonLink: true
    }, children);
const $219e6c7e74519558$export$83ae53699c054d49 = (props)=>{
    const { maxItems: maxItems, onLoadMoreClick: onLoadMoreClick, totalItemCount: totalItemCount } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const allItemsLoadedText = formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $4jHBC.default).allItemsLoadedViewAllIssuesIssueTermRefresh : (0, $4jHBC.default).allItemsLoadedViewAllIssues, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                paddingInline: "space.100",
                xcss: $219e6c7e74519558$var$fontStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($219e6c7e74519558$var$LinkToGlobalIssueNavigation, null, chunks))
    });
    if (totalItemCount <= (0, $bXOg3.MAX_ITEMS_PER_PAGE) && (0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
    if (totalItemCount <= (0, $bXOg3.MAX_ITEMS_PER_PAGE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $219e6c7e74519558$var$styles.tabFooter
        ])
    }, allItemsLoadedText);
    if (totalItemCount > maxItems && onLoadMoreClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $219e6c7e74519558$var$styles.tabFooter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.ButtonWithAnalytics), {
        actionSubjectId: "recentlyViewedLoadMoreButton",
        onClick: onLoadMoreClick
    }, formatMessage((0, $4jHBC.default).loadMore)));
    if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $219e6c7e74519558$var$styles.tabFooter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $219e6c7e74519558$var$styles.iconWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwpci))), {
        spacing: "spacious",
        label: ""
    })), allItemsLoadedText);
};
$219e6c7e74519558$export$83ae53699c054d49.defaultProps = {
    onLoadMoreClick: undefined
};
var $219e6c7e74519558$export$2e2bcd8739ae039 = $219e6c7e74519558$export$83ae53699c054d49;
const $219e6c7e74519558$var$fontStyle = (0, $1DXK0.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)"
});

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("4jHBC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f76b3c9ed39b6b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0f76b3c9ed39b6b6$var$messages = (0, $7qGN1.defineMessages)({
    loadMore: {
        "id": "home.tabs.recently-viewed.footer.load-more",
        "defaultMessage": "Load more"
    },
    allItemsLoaded: {
        "id": "home.tabs.recently-viewed.footer.all-items-loaded",
        "defaultMessage": "Looking for something else? {trySearch}"
    },
    trySearch: {
        "id": "home.tabs.recently-viewed.footer.try-search",
        "defaultMessage": "Try search"
    },
    allItemsLoadedViewAllIssues: {
        "id": "home.tabs.recently-viewed.footer.all-items-loaded-view-all-issues",
        "defaultMessage": "Couldn\u2019t find your issue? <a>View all issues</a>"
    },
    allItemsLoadedViewAllIssuesIssueTermRefresh: {
        "id": "home.tabs.recently-viewed.footer.all-items-loaded-view-all-issues-issue-term-refresh",
        "defaultMessage": "Couldn\u2019t find your work item? <a>View all work items</a>"
    }
});
var $0f76b3c9ed39b6b6$export$2e2bcd8739ae039 = $0f76b3c9ed39b6b6$var$messages;

});


parcelRegister("7nkUa", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa4c97740c0e0ad4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fa4c97740c0e0ad4$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        "id": "home.tabs.recently-viewed.empty-state-header",
        "defaultMessage": "You haven\u2019t viewed any item recently"
    },
    emptyStateDescription: {
        "id": "home.tabs.recently-viewed.empty-state-description",
        "defaultMessage": "In this page, you\u2019ll find a list of your recently viewed items. Get started by finding the project your team is working on."
    },
    emptyStateDescriptionForMobile: {
        "id": "home.tabs.recently-viewed.empty-state-description-for-mobile",
        "defaultMessage": "On this page, you\u2019ll find a list of your recently viewed items."
    },
    viewAllProjects: {
        "id": "home.tabs.recently-viewed.view-all-projects",
        "defaultMessage": "View all projects"
    },
    loadMore: {
        "id": "home.tabs.recently-viewed.load-more",
        "defaultMessage": "Load more"
    },
    emptyStateDescriptionGalaxia: {
        "id": "home.tabs.recently-viewed.empty-state-description-galaxia",
        "defaultMessage": "In this page, you\u2019ll find a list of your recently viewed work items. Get started by finding the space your team is working on."
    },
    viewAllProjectsGalaxia: {
        "id": "home.tabs.recently-viewed.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    }
});
var $fa4c97740c0e0ad4$export$2e2bcd8739ae039 = $fa4c97740c0e0ad4$var$messages;

});


parcelRegister("jVvmk", function(module, exports) {
$parcel$export(module.exports, "default", () => $496023f6bb71fbcc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5gjY4 = parcelRequire("5gjY4");

var $koAZ4 = parcelRequire("koAZ4");

var $bXOg3 = parcelRequire("bXOg3");

var $2kUzW = parcelRequire("2kUzW");

var $1SixK = parcelRequire("1SixK");

var $fQ03e = parcelRequire("fQ03e");

var $3Nff7 = parcelRequire("3Nff7");

var $5AZTd = parcelRequire("5AZTd");
const $496023f6bb71fbcc$var$StarredTab = (props)=>{
    const { itemProviderResult: { data: data, error: error, loading: loading, reloading: reloading } } = props;
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(!!data.total, error, loading, 'starred');
    if (error && !data.total) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kUzW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.STARRED_TAB_KEY),
        renderState: (0, $bXOg3.ERROR_STATE)
    }));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gjY4.YourWorkItemListSkeleton), null);
    if (!data || !data.sections || data.sections.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5AZTd.default), {
        shouldShowBoardsLink: appPermissions && appPermissions.hasSoftwareAccess,
        shouldShowServiceDeskLink: appPermissions && appPermissions.hasServiceDeskAccess,
        shouldShowPlansLink: appPermissions && appPermissions.hasSoftwareAccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.STARRED_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, reloading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1SixK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nff7.default), {
        sections: (0, $fQ03e.trimItemsBySection)(props.maxItems, data.sections),
        showStar: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.STARRED_TAB_KEY),
        renderState: (0, $bXOg3.SUCCESS_STATE)
    }));
};
var $496023f6bb71fbcc$export$2e2bcd8739ae039 = $496023f6bb71fbcc$var$StarredTab;

});
parcelRegister("5AZTd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5afeaa7205b043b9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $cxKOj = parcelRequire("cxKOj");

var $k52zI = parcelRequire("k52zI");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $bdEnF = parcelRequire("bdEnF");

var $9LAjM = parcelRequire("9LAjM");

var $fl6Ag = parcelRequire("fl6Ag");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5afeaa7205b043b9$var$Button = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.LinkWithAnalytics), {
        actionSubjectId: "emptyStateLink",
        appearance: "default",
        spacing: "compact",
        buttonLink: true,
        ...props
    });
const $5afeaa7205b043b9$export$fddf379e22a74b00 = (props)=>{
    const serviceProjectGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fl6Ag.default).serviceProjectGalaxia : (0, $fl6Ag.default).serviceProject;
    const projectGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fl6Ag.default).projectGalaxia : (0, $fl6Ag.default).project;
    const { shouldShowBoardsLink: shouldShowBoardsLink, shouldShowServiceDeskLink: shouldShowServiceDeskLink, shouldShowPlansLink: shouldShowPlansLink } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        maxImageWidth: 250,
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $k52zI.default)),
        header: formatMessage((0, $fl6Ag.default).header),
        headingLevel: 2,
        description: formatMessage((0, $fl6Ag.default).description),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5afeaa7205b043b9$var$Button, {
            extraAttributes: {
                whichButton: 'project'
            },
            href: "/jira/projects?page=1&selectedCategory=all&selectedProjectType=business%2Csoftware&sortKey=name&sortOrder=ASC"
        }, formatMessage(projectGalaxia)), shouldShowBoardsLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5afeaa7205b043b9$var$Button, {
            extraAttributes: {
                whichButton: 'board'
            },
            href: "/jira/boards"
        }, formatMessage((0, $fl6Ag.default).board)), shouldShowServiceDeskLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5afeaa7205b043b9$var$Button, {
            extraAttributes: {
                whichButton: 'service_desk'
            },
            href: "/jira/projects?page=1&selectedCategory=all&selectedProjectType=service_desk&sortKey=name&sortOrder=ASC"
        }, formatMessage(serviceProjectGalaxia)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5afeaa7205b043b9$var$Button, {
            href: "/jira/filters",
            extraAttributes: {
                whichButton: 'filter'
            }
        }, formatMessage((0, $fl6Ag.default).filter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5afeaa7205b043b9$var$Button, {
            href: "/jira/dashboards",
            extraAttributes: {
                whichButton: 'dashboard'
            }
        }, formatMessage((0, $fl6Ag.default).dashboard)), shouldShowPlansLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5afeaa7205b043b9$var$Button, {
            extraAttributes: {
                whichButton: 'plan'
            },
            href: "/jira/plans?page=1&orderBy=title&sortDirection=ASC&maxResults=25"
        }, formatMessage((0, $fl6Ag.default).plan)))
    });
};
var $5afeaa7205b043b9$export$2e2bcd8739ae039 = $5afeaa7205b043b9$export$fddf379e22a74b00;

});
parcelRegister("k52zI", function(module, exports) {
$parcel$export(module.exports, "default", () => $35f288d19412e29c$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $iCpeN = parcelRequire("iCpeN");
const $35f288d19412e29c$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iCpeN)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iCpeN))
});
var $35f288d19412e29c$export$2e2bcd8739ae039 = $35f288d19412e29c$var$Illustration;
// for advanced use only
const $35f288d19412e29c$export$a179c88182cb9d56 = [
    0,
    0,
    400,
    400
];

});
parcelRegister("iCpeN", function(module, exports) {
module.exports = new URL("empty-state-starred.f03d0ca1.svg", import.meta.url).toString();

});


parcelRegister("fl6Ag", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c5b6c80d0a4a292$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2c5b6c80d0a4a292$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "home.tabs.starred.empty-state.header",
        "defaultMessage": "Star your work for quick access"
    },
    description: {
        "id": "home.tabs.starred.empty-state.description",
        "defaultMessage": "Get started by finding your"
    },
    project: {
        "id": "home.tabs.starred.empty-state.project",
        "defaultMessage": "Project"
    },
    board: {
        "id": "home.tabs.starred.empty-state.board",
        "defaultMessage": "Board"
    },
    serviceProject: {
        "id": "home.tabs.starred.empty-state.service-project",
        "defaultMessage": "Service project"
    },
    filter: {
        "id": "home.tabs.starred.empty-state.filter",
        "defaultMessage": "Filter"
    },
    dashboard: {
        "id": "home.tabs.starred.empty-state.dashboard",
        "defaultMessage": "Dashboard"
    },
    plan: {
        "id": "home.tabs.starred.empty-state.plan",
        "defaultMessage": "Plan"
    },
    projectGalaxia: {
        "id": "home.tabs.starred.empty-state.project-galaxia",
        "defaultMessage": "Space"
    },
    serviceProjectGalaxia: {
        "id": "home.tabs.starred.empty-state.service-project-galaxia",
        "defaultMessage": "Service space"
    }
});
var $2c5b6c80d0a4a292$export$2e2bcd8739ae039 = $2c5b6c80d0a4a292$var$messages;

});



parcelRegister("7GdIW", function(module, exports) {
$parcel$export(module.exports, "default", () => $e772e3fd793b2c94$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $6gFzo = parcelRequire("6gFzo");

var $lRq8t = parcelRequire("lRq8t");

var $fYeTG = parcelRequire("fYeTG");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $5gjY4 = parcelRequire("5gjY4");

var $bXOg3 = parcelRequire("bXOg3");

var $bdEnF = parcelRequire("bdEnF");

var $2kUzW = parcelRequire("2kUzW");

var $3Nff7 = parcelRequire("3Nff7");

var $1SixK = parcelRequire("1SixK");

var $9aHHU = parcelRequire("9aHHU");

var $9LAjM = parcelRequire("9LAjM");

var $fQ03e = parcelRequire("fQ03e");

var $1b3nd = parcelRequire("1b3nd");

var $4NJsk = parcelRequire("4NJsk");
const $e772e3fd793b2c94$export$ae62e03c6f2a771b = (initialLength, section)=>initialLength + section.items.length;
const $e772e3fd793b2c94$var$WorkedOnTab = (props)=>{
    const emptyStateDescriptionIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $4NJsk.default).emptyStateDescriptionIssueTermRefreshGalaxia : (0, $4NJsk.default).emptyStateDescriptionIssueTermRefresh;
    const viewAllProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $4NJsk.default).viewAllProjectsGalaxia : (0, $4NJsk.default).viewAllProjects;
    const { itemProviderResult: { data: data, error: error, loading: loading, reloading: reloading }, onLoadMoreClick: onLoadMoreClick } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $fQ03e.useFireErrorOrSuccessAnalytics)(!!data.total, error, loading, 'workedOn');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = (0, $eJOHy.useMemo)(()=>createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), [
        createAnalyticsEvent
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        // BLU-1095
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'recentWorkItem', {
            pageLocation: 'home'
        });
    }, [
        analyticsEvent
    ]);
    if (error && !data.total) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kUzW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.WORKEDON_TAB_KEY),
        renderState: (0, $bXOg3.ERROR_STATE)
    }));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gjY4.YourWorkItemListSkeleton), null);
    if (data.sections.length === 0 && (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        header: formatMessage((0, $4NJsk.default).emptyStateHeader),
        description: formatMessage((0, $4NJsk.default).emptyStateDescriptionMobile),
        renderImage: ()=>// renderImage doesn't add an image wrapper whereas imageUrl does
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingBlockEnd: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6gFzo.default), {
                alt: "",
                width: 154
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.WORKEDON_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    if (data.sections.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdEnF.default), {
        header: formatMessage((0, $4NJsk.default).emptyStateHeader),
        description: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? emptyStateDescriptionIssueTermRefreshGalaxia : (0, $4NJsk.default).emptyStateDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1b3nd))),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.LinkWithAnalytics), {
            actionSubjectId: "recentlyViewedBrowseProjectsButton",
            appearance: "primary",
            buttonLink: true,
            href: "/jira/projects"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "span",
            color: "color.text.inverse"
        }, formatMessage(viewAllProjectsGalaxia)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.WORKEDON_TAB_KEY),
        renderState: (0, $bXOg3.EMPTY_STATE)
    }));
    const numberOfItemsInAllSections = data.sections.reduce($e772e3fd793b2c94$export$ae62e03c6f2a771b, 0);
    const footer = numberOfItemsInAllSections > (0, $bXOg3.MAX_ITEMS_PER_PAGE) && onLoadMoreClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9aHHU.TabFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LAjM.ButtonWithAnalytics), {
        actionSubjectId: "recentlyViewedLoadMoreButton",
        onClick: onLoadMoreClick
    }, formatMessage((0, $4NJsk.default).loadMore))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, reloading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1SixK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Nff7.default), {
        sections: (0, $fQ03e.trimItemsBySection)(props.maxItems, data.sections),
        onItemClick: handleClick
    }), footer, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
        transitionKey: (0, $bXOg3.WORKEDON_TAB_KEY),
        renderState: (0, $bXOg3.SUCCESS_STATE)
    }));
};
var $e772e3fd793b2c94$export$2e2bcd8739ae039 = $e772e3fd793b2c94$var$WorkedOnTab;

});
parcelRegister("6gFzo", function(module, exports) {
$parcel$export(module.exports, "default", () => $e45f161a3f22b080$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $fDxEb = parcelRequire("fDxEb");

var $5ESbw = parcelRequire("5ESbw");
const $e45f161a3f22b080$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5ESbw)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fDxEb)),
    autoDark: false
});
var $e45f161a3f22b080$export$2e2bcd8739ae039 = $e45f161a3f22b080$var$Illustration;

});
parcelRegister("fDxEb", function(module, exports) {
module.exports = new URL("empty-add-card-darkmode.a582fc88.svg", import.meta.url).toString();

});

parcelRegister("5ESbw", function(module, exports) {
module.exports = new URL("empty-add-card.19eb67a4.svg", import.meta.url).toString();

});


parcelRegister("1b3nd", function(module, exports) {
module.exports = new URL("migration-logo.25f5c840.svg", import.meta.url).toString();

});

parcelRegister("4NJsk", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bb408e696f0623c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1bb408e696f0623c$var$messages = (0, $7qGN1.defineMessages)({
    emptyStateHeader: {
        "id": "home.tabs.worked-on.empty-state-header",
        "defaultMessage": "You haven\u2019t worked on anything yet"
    },
    emptyStateDescription: {
        "id": "home.tabs.worked-on.empty-state-description",
        "defaultMessage": "In this page, you\u2019ll find your recently worked on issues. Get started by finding the project your team is working on."
    },
    emptyStateDescriptionMobile: {
        "id": "home.tabs.worked-on.empty-state-description-mobile",
        "defaultMessage": "On this page, you\u2019ll find your recent work."
    },
    viewAllProjects: {
        "id": "home.tabs.worked-on.view-all-projects",
        "defaultMessage": "View all projects"
    },
    loadMore: {
        "id": "home.tabs.worked-on.load-more",
        "defaultMessage": "Load more"
    },
    emptyStateDescriptionIssueTermRefresh: {
        "id": "home.tabs.worked-on.empty-state-description-issue-term-refresh",
        "defaultMessage": "In this page, you\u2019ll find your recently worked on work items. Get started by finding the project your team is working on."
    },
    viewAllProjectsGalaxia: {
        "id": "home.tabs.worked-on.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    },
    emptyStateDescriptionIssueTermRefreshGalaxia: {
        "id": "home.tabs.worked-on.empty-state-description-issue-term-refresh-galaxia",
        "defaultMessage": "In this page, you\u2019ll find your recently worked on work items. Get started by finding the space your team is working on."
    }
});
var $1bb408e696f0623c$export$2e2bcd8739ae039 = $1bb408e696f0623c$var$messages;

});



parcelRegister("kKDcQ", function(module, exports) {
$parcel$export(module.exports, "WorkSuggestionsTab", () => $a7c4e2614b78061f$export$4969b21f82d6008);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $fQ03e = parcelRequire("fQ03e");

var $bXOg3 = parcelRequire("bXOg3");
const $a7c4e2614b78061f$export$4969b21f82d6008 = ({ entryPointReferenceSubject: entryPointReferenceSubject })=>{
    // TODO is it a problem that LoadingState always assumes there is data here?
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "renderWorkSuggestionsTabYourWork",
        packageName: "jiraSoftwareWorkSuggestionsYourWork",
        teamName: "jolt",
        entryPointReferenceSubject: entryPointReferenceSubject,
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
                transitionKey: (0, $bXOg3.WORK_SUGGESTIONS_TAB_KEY),
                renderState: (0, $bXOg3.ERROR_STATE)
            })),
        fallback: null,
        runtimeProps: {
            onLoadedRenderSuccess: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fQ03e.EndInteractionsTracker), {
                    transitionKey: (0, $bXOg3.WORK_SUGGESTIONS_TAB_KEY),
                    renderState: (0, $bXOg3.SUCCESS_STATE)
                })
        }
    });
};

});


parcelRegister("1zAS0", function(module, exports) {
$parcel$export(module.exports, "JiraHome", () => $6af9683e8ab3b454$export$5f42bf5b1ccfb113);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $LFmXM = parcelRequire("LFmXM");

var $d129d = parcelRequire("d129d");

var $3So8J = parcelRequire("3So8J");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fYeTG = parcelRequire("fYeTG");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $jbJvT = parcelRequire("jbJvT");

var $bXOg3 = parcelRequire("bXOg3");

var $fOowo = parcelRequire("fOowo");

var $iiD75 = parcelRequire("iiD75");

var $d5Xhr = parcelRequire("d5Xhr");

var $lsYYU = parcelRequire("lsYYU");

var $02Vwm = parcelRequire("02Vwm");

var $aSC67 = parcelRequire("aSC67");

var $bQ87J = parcelRequire("bQ87J");

var $lUeDZ = parcelRequire("lUeDZ");

var $eDNZI = parcelRequire("eDNZI");
const $6af9683e8ab3b454$var$onTabSelected = (0, $LFmXM.default)((setLastVisitedTab)=>(selectedTab)=>setLastVisitedTab(selectedTab));
const $6af9683e8ab3b454$export$5f42bf5b1ccfb113 = ({ prefetchResult: prefetchResult })=>{
    const isMobileWebAndInMVPExperiment = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    const intl = (0, $lRq8t.default)();
    const tabConfigsToUse = (0, $eJOHy.useMemo)(()=>(0, $eDNZI.getTabConfigToUse)(), []);
    const intlTabConfigs = (0, $eJOHy.useMemo)(()=>tabConfigsToUse.map((tab)=>{
            const config = {
                ...tab,
                id: tab.id,
                // generate an intld label for the Atlaskit Tab Navigation component
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ dashboards: MessageDescriptorV2; projects: MessageDescriptorV2; experimentPreferenceChangeSuccessMessage: MessageDescriptorV2; ... 6 more ...; title: MessageDescriptorV2; }'.
                label: intl.formatMessage((0, $02Vwm.default)[tab.id])
            };
            return config;
        }), [
        intl,
        tabConfigsToUse
    ]);
    const slowRunOnce = (0, $eJOHy.useRef)(false); // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $4cTDP.fg)('uip_slow_test') && !slowRunOnce.current) {
        slowRunOnce.current = true;
        let timeNow = 0;
        let timeDelayForExperiment = 0;
        try {
            timeNow = performance.now();
            timeDelayForExperiment = (0, $cxKOj.expVal)('uip_slow_test_experiment', 'delay', 0);
        } catch (e) {}
        if (timeDelayForExperiment > 0 && timeDelayForExperiment < 1000) {
            /* eslint-disable-next-line no-empty */ while(performance.now() - timeNow <= timeDelayForExperiment);
        }
    }
    const RightPanelWrapper = isMobileWebAndInMVPExperiment ? (0, $eJOHy.Fragment) : (0, $bQ87J.RightPanelLayout);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jbJvT.RelayMigrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: "jiraHome"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        id: "root",
        packageName: "jiraHome"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RightPanelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "global-pages.home.ui.home"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iiD75.GlobalPagesDocumentTitle), {
        "data-testid": "global-pages.home.ui.global-pages-document-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6af9683e8ab3b454$var$PageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d129d.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lsYYU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOowo.LastVisitedTabProviderFF), {
        prefetchResult: prefetchResult
    }, ({ queriedTab: queriedTab, lastVisitedTab: lastVisitedTab, setLastVisitedTab: setLastVisitedTab })=>{
        let matchingConfigs = intlTabConfigs.filter((config)=>config.id === lastVisitedTab);
        switch(queriedTab){
            case 'starred':
                matchingConfigs = intlTabConfigs.filter((config)=>config.id === (0, $bXOg3.STARRED_TAB_KEY));
                break;
            case 'viewed':
                matchingConfigs = intlTabConfigs.filter((config)=>config.id === (0, $bXOg3.VIEWED_TAB_KEY));
                break;
            default:
                break;
        }
        if (matchingConfigs.length === 0 && prefetchResult.loading && !isMobileWebAndInMVPExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5Xhr.default), {
            tabConfigs: intlTabConfigs,
            deepDiveCards: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aSC67.default), {
                prefetchResult: undefined
            })
        });
        const selectedTab = matchingConfigs.length > 0 ? matchingConfigs[0] : intlTabConfigs[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isMobileWebAndInMVPExperiment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aSC67.default // @ts-expect-error Type 'Partial<RouteResourceResponse<PrefetchResult>>' is not assignable to type 'RouteResourceResponse<PrefetchResult> | undefined'.
        ), {
            prefetchResult: prefetchResult
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lUeDZ.TabContainerFF), {
            services: (0, $eDNZI.servicesNav4),
            prefetchResult: prefetchResult,
            tabConfigs: intlTabConfigs,
            defaultSelected: selectedTab,
            onTabChange: $6af9683e8ab3b454$var$onTabSelected(setLastVisitedTab)
        }));
    }))))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6af9683e8ab3b454$var$PageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul91nk9 _19pk12x7 _2hwxu2gc _otyrxy5q _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6af9683e8ab3b454$var$TabFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _19pkxy5q",
            __cmplp.className
        ])
    });
});
$6af9683e8ab3b454$var$TabFooter.displayName = 'TabFooter';

});



parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $eaa2e9e24133f900$export$fcc03ee4c944962f(value);
            $eaa2e9e24133f900$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("a73Mn", function(module, exports) {
$parcel$export(module.exports, "jiraHomePageLoad", () => $82e3d38577f588bf$export$d495b84702662e16);

var $hqYEY = parcelRequire("hqYEY");
const $82e3d38577f588bf$export$d495b84702662e16 = (0, $hqYEY.metrics).pageLoad({
    key: 'jira-home',
    ssr: {
        doneAsFmp: true
    },
    histogram: {
        initial: {
            fmp: '2500_3000_3500_4000_5000_6000',
            tti: '2500_4000_4500_5000_6000_7000_8000_9000'
        },
        transition: {
            fmp: '1000_2500_3000_3500_4000_5000_6000',
            tti: '1000_2500_3000_3500_4000_5000_6000'
        }
    }
});

});




//# sourceMappingURL=async-jira-home.82844816.js.map
